import { includesIgnoringAccents } from '../../utils/utils';
import { SandreToSSD2 } from './SandreToSSD2';
import type { SSD2Id } from './SSD2Id';

const EfsaSSD2Referential =
  // ----- ne pas supprimer cette ligne : début
  {
    'RF-00000007-PAR': {
      reference: 'RF-00000007-PAR',
      name: '1-(2,4 dichlorophenyl)-2-Imidazol-1-yl-ethanol',
      casNumber: '27656-21-9',
      otherNames: [],
      reportable: true
    },
    'RF-00000010-CHE': {
      reference: 'RF-00000010-CHE',
      name: 'Calcium oxide',
      casNumber: '1305-78-8',
      otherNames: [],
      reportable: true
    },
    'RF-00000010-MCG': {
      reference: 'RF-00000010-MCG',
      name: 'Bacillus pumilus',
      casNumber: null,
      otherNames: ['B. pumilis'],
      reportable: true
    },
    'RF-00000010-PAR': {
      reference: 'RF-00000010-PAR',
      name: 'Bixafen (sum of bixafen and desmethyl-bixafen, expressed as bixafen)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00000011-PAR': {
      reference: 'RF-00000011-PAR',
      name: 'Chlorbenside sulfone',
      casNumber: '7082-99-7',
      otherNames: [],
      reportable: true
    },
    'RF-00000012-PAR': {
      reference: 'RF-00000012-PAR',
      name: 'SDS-3701 (4-hydroxy-2,5,6- trichloroisophthalonitrile)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00000013-PAR': {
      reference: 'RF-00000013-PAR',
      name: 'Climbazole',
      casNumber: '38083-17-9',
      otherNames: [],
      reportable: true
    },
    'RF-00000014-PAR': {
      reference: 'RF-00000014-PAR',
      name: 'Cotinine',
      casNumber: '486-56-6',
      otherNames: [],
      reportable: true
    },
    'RF-00000015-CHE': {
      reference: 'RF-00000015-CHE',
      name: 'Chlorates',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00000015-PAR': {
      reference: 'RF-00000015-PAR',
      name: 'Cyenopyrafen',
      casNumber: '560121-52-0',
      otherNames: [],
      reportable: true
    },
    'RF-00000017-PAR': {
      reference: 'RF-00000017-PAR',
      name: 'Dichlorobenzophenone, 2,4-',
      casNumber: '85-29-0',
      otherNames: [],
      reportable: true
    },
    'RF-00000018-PAR': {
      reference: 'RF-00000018-PAR',
      name: 'Dinobuton sulfone',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00000019-ADD': {
      reference: 'RF-00000019-ADD',
      name: 'Acetic acid',
      casNumber: '64-19-7',
      otherNames: ['ethanoic acid', 'ethylic acid'],
      reportable: true
    },
    'RF-00000019-PAR': {
      reference: 'RF-00000019-PAR',
      name: 'Endosulfan ether',
      casNumber: '3369-52-6',
      otherNames: [],
      reportable: true
    },
    'RF-00000020-PAR': {
      reference: 'RF-00000020-PAR',
      name: 'Endosulfan lactone',
      casNumber: '3868-61-9',
      otherNames: [],
      reportable: true
    },
    'RF-00000021-PAR': {
      reference: 'RF-00000021-PAR',
      name: '2-keto-ethofumesate',
      casNumber: '26244-33-7',
      otherNames: ['Ethofumesate-2-keto'],
      reportable: true
    },
    'RF-00000022-PAR': {
      reference: 'RF-00000022-PAR',
      name: 'Fluazifop-P',
      casNumber: '83066-88-0',
      otherNames: [],
      reportable: true
    },
    'RF-00000023-PAR': {
      reference: 'RF-00000023-PAR',
      name: 'Fluopyram (sum fluopyram and fluopyram-benzamide (M25) expressed as fluopyram)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00000024-PAR': {
      reference: 'RF-00000024-PAR',
      name: 'Fluxapyroxad',
      casNumber: '907204-31-3',
      otherNames: [],
      reportable: true
    },
    'RF-00000025-ORG': {
      reference: 'RF-00000025-ORG',
      name: '4-Chloro,3-methylphenol',
      casNumber: '59-50-7',
      otherNames: ['4-Chloor,3-methylphenol'],
      reportable: true
    },
    'RF-00000025-PAR': {
      reference: 'RF-00000025-PAR',
      name: 'Isopyrazam',
      casNumber: '881685-58-1',
      otherNames: [],
      reportable: true
    },
    'RF-00000026-PAR': {
      reference: 'RF-00000026-PAR',
      name: 'Mefenpyr-diethyl',
      casNumber: '135590-91-9',
      otherNames: [],
      reportable: true
    },
    'RF-00000027-PAR': {
      reference: 'RF-00000027-PAR',
      name: 'Moschus ketone',
      casNumber: '956-82-1',
      otherNames: [],
      reportable: true
    },
    'RF-00000028-PAR': {
      reference: 'RF-00000028-PAR',
      name: 'N-desethyl-pirimiphos-methyl',
      casNumber: '67018-59-1',
      otherNames: [],
      reportable: true
    },
    'RF-00000030-PAR': {
      reference: 'RF-00000030-PAR',
      name: 'Spirotetramat (spirotetramat and its metabolite BYI08330-enol expressed as spirotetramat)',
      casNumber: null,
      otherNames: [
        'Sum of spirotetramat and spirotetramat-enol, expressed as spirotetramat'
      ],
      reportable: true
    },
    'RF-00000031-ADD': {
      reference: 'RF-00000031-ADD',
      name: 'Aluminium ammonium sulphate',
      casNumber: '7784-25-0',
      otherNames: [],
      reportable: true
    },
    'RF-00000031-PAR': {
      reference: 'RF-00000031-PAR',
      name: 'Tricresyl phosphate',
      casNumber: '1330-78-5',
      otherNames: [],
      reportable: true
    },
    'RF-00000032-PAR': {
      reference: 'RF-00000032-PAR',
      name: 'Trifloxystrobin (sum of trifloxystrobin and its metabolite (E, E)-methoxyimino- {2-[1-(3-trifluoromethyl-phenyl)-ethylideneamino-oxymethyl]-phenyl}-acetic acid (CGA 321113))',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00000033-ADD': {
      reference: 'RF-00000033-ADD',
      name: 'Aluminium silicate (Kaolin)',
      casNumber: '1332-58-7',
      otherNames: [],
      reportable: true
    },
    'RF-00000035-ADD': {
      reference: 'RF-00000035-ADD',
      name: 'Aluminium sulphate',
      casNumber: '10043-01-3',
      otherNames: [],
      reportable: true
    },
    'RF-00000039-ADD': {
      reference: 'RF-00000039-ADD',
      name: 'Ammonium carbonates',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00000040-ADD': {
      reference: 'RF-00000040-ADD',
      name: 'Ammonium hydroxide',
      casNumber: '1336-21-6',
      otherNames: [],
      reportable: true
    },
    'RF-00000042-ADD': {
      reference: 'RF-00000042-ADD',
      name: 'Ammonium sulphate',
      casNumber: '7783-20-2',
      otherNames: [],
      reportable: true
    },
    'RF-00000048-NTR': {
      reference: 'RF-00000048-NTR',
      name: 'casein',
      casNumber: '9000-71-9',
      otherNames: [],
      reportable: true
    },
    'RF-00000051-NTR': {
      reference: 'RF-00000051-NTR',
      name: 'cholecalciferol',
      casNumber: '67-97-0',
      otherNames: ['Colecalciferol'],
      reportable: true
    },
    'RF-00000052-ADD': {
      reference: 'RF-00000052-ADD',
      name: 'Benzoic acid',
      casNumber: '65-85-0',
      otherNames: [
        'Benzenecarboxylic acid',
        'phenylcarboxylic acid',
        'carboxybenzene'
      ],
      reportable: true
    },
    'RF-00000056-ADD': {
      reference: 'RF-00000056-ADD',
      name: 'Boric acid',
      casNumber: '11113-50-1',
      otherNames: [],
      reportable: true
    },
    'RF-00000059-NTR': {
      reference: 'RF-00000059-NTR',
      name: 'L-cysteine',
      casNumber: '52-90-4',
      otherNames: ['cysteine, L-cysteine'],
      reportable: true
    },
    'RF-00000069-ADD': {
      reference: 'RF-00000069-ADD',
      name: 'Calcium carbonate',
      casNumber: '471-34-1',
      otherNames: ['Calcite', 'limestone'],
      reportable: true
    },
    'RF-00000071-ADD': {
      reference: 'RF-00000071-ADD',
      name: 'Calcium chloride',
      casNumber: '10043-52-4',
      otherNames: [],
      reportable: true
    },
    'RF-00000079-ADD': {
      reference: 'RF-00000079-ADD',
      name: 'Calcium hydroxide',
      casNumber: '1305-62-0',
      otherNames: [],
      reportable: true
    },
    'RF-00000081-CHE': {
      reference: 'RF-00000081-CHE',
      name: 'Nitrogen (N)',
      casNumber: '7727-37-9',
      otherNames: [],
      reportable: true
    },
    'RF-00000083-ADD': {
      reference: 'RF-00000083-ADD',
      name: 'Calcium phosphates',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00000094-ADD': {
      reference: 'RF-00000094-ADD',
      name: 'Carbon dioxide',
      casNumber: '124-38-9',
      otherNames: [],
      reportable: true
    },
    'RF-00000104-CHE': {
      reference: 'RF-00000104-CHE',
      name: 'Urea',
      casNumber: '57-13-6',
      otherNames: ['Carbamide'],
      reportable: true
    },
    'RF-00000136-CHE': {
      reference: 'RF-00000136-CHE',
      name: 'Dimethylarsinate (DMA))',
      casNumber: '34442-00-7',
      otherNames: ['DMA'],
      reportable: true
    },
    'RF-00000151-ADD': {
      reference: 'RF-00000151-ADD',
      name: 'Hexamethylene tetramine',
      casNumber: '100-97-0',
      otherNames: ['methenamine', 'hexamine'],
      reportable: true
    },
    'RF-00000161-VET': {
      reference: 'RF-00000161-VET',
      name: 'Alpha-cypermethrin',
      casNumber: '67375-30-8',
      otherNames: [
        '(S)-α-cyano-3-phenoxybenzyl (1R,3R)-3-(2,2-dichlorovinyl)-2,2-dimethylcyclopropanecarboxylate'
      ],
      reportable: true
    },
    'RF-00000167-ADD': {
      reference: 'RF-00000167-ADD',
      name: 'Lactic acid',
      casNumber: '50-21-5',
      otherNames: [],
      reportable: true
    },
    'RF-00000171-ADD': {
      reference: 'RF-00000171-ADD',
      name: 'Lecithins',
      casNumber: '8002-43-5',
      otherNames: [],
      reportable: true
    },
    'RF-00000171-VET': {
      reference: 'RF-00000171-VET',
      name: '2,6-dimethylaniline',
      casNumber: '87-62-7',
      otherNames: ['Dimethylanilin', '2,6-dimethylaniline (2,6-Xylidine)'],
      reportable: true
    },
    'RF-00000189-ADD': {
      reference: 'RF-00000189-ADD',
      name: 'Methyl p-hydroxybenzoate',
      casNumber: '99-76-3',
      otherNames: [],
      reportable: true
    },
    'RF-00000208-ADD': {
      reference: 'RF-00000208-ADD',
      name: 'Paprika extract, capsanthin, capsorubin',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00000212-ADD': {
      reference: 'RF-00000212-ADD',
      name: 'Phosphoric acid',
      casNumber: '7664-38-2',
      otherNames: ['orthophosphoric acid'],
      reportable: true
    },
    'RF-00000248-ADD': {
      reference: 'RF-00000248-ADD',
      name: 'Potassium sorbate',
      casNumber: '24634-61-5',
      otherNames: [],
      reportable: true
    },
    'RF-00000248-NTR': {
      reference: 'RF-00000248-NTR',
      name: 'fatty acid 8:0 (caprylic acid)',
      casNumber: '124-07-2',
      otherNames: [],
      reportable: true
    },
    'RF-00000256-ADD': {
      reference: 'RF-00000256-ADD',
      name: 'Propionic acid',
      casNumber: '79-09-4',
      otherNames: [],
      reportable: true
    },
    'RF-00000277-ADD': {
      reference: 'RF-00000277-ADD',
      name: 'Sodium aluminium silicate',
      casNumber: '12003-51-9',
      otherNames: [],
      reportable: true
    },
    'RF-00000288-ADD': {
      reference: 'RF-00000288-ADD',
      name: 'Sodium hydroxide',
      casNumber: '1310-73-2',
      otherNames: [],
      reportable: true
    },
    'RF-00000291-ADD': {
      reference: 'RF-00000291-ADD',
      name: 'Sodium metabisulphite',
      casNumber: '7681-57-4',
      otherNames: [],
      reportable: true
    },
    'RF-00000297-ADD': {
      reference: 'RF-00000297-ADD',
      name: 'Sodium propionate',
      casNumber: '137-40-6',
      otherNames: [],
      reportable: true
    },
    'RF-00000300-NTR': {
      reference: 'RF-00000300-NTR',
      name: 'Gluten',
      casNumber: null,
      otherNames: ['gluten'],
      reportable: true
    },
    'RF-00000307-VET': {
      reference: 'RF-00000307-VET',
      name: 'Thiourea',
      casNumber: '62-56-6',
      otherNames: [],
      reportable: true
    },
    'RF-00000319-NTR': {
      reference: 'RF-00000319-NTR',
      name: 'L-ascorbic acid',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00000325-ADD': {
      reference: 'RF-00000325-ADD',
      name: 'Sulphuric acid',
      casNumber: '7664-93-9',
      otherNames: [],
      reportable: true
    },
    'RF-00000327-ADD': {
      reference: 'RF-00000327-ADD',
      name: 'Talc',
      casNumber: '14807-96-6',
      otherNames: [],
      reportable: true
    },
    'RF-00000353-ORG': {
      reference: 'RF-00000353-ORG',
      name: 'Perfluorohexane sulfonate',
      casNumber: null,
      otherNames: [],
      reportable: false
    },
    'RF-00000354-ORG': {
      reference: 'RF-00000354-ORG',
      name: 'Perfluorooctane sulfonate',
      casNumber: '45298-90-6',
      otherNames: [],
      reportable: false
    },
    'RF-00000360-ORG': {
      reference: 'RF-00000360-ORG',
      name: 'Perfluorononanoic acid',
      casNumber: '375-95-1',
      otherNames: [],
      reportable: false
    },
    'RF-00000361-NTR': {
      reference: 'RF-00000361-NTR',
      name: 'phosphatidyl choline (lecithin)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00000370-ORG': {
      reference: 'RF-00000370-ORG',
      name: 'PFAS-like (C4-C15)',
      casNumber: null,
      otherNames: [],
      reportable: false
    },
    'RF-00000543-VET': {
      reference: 'RF-00000543-VET',
      name: 'Oxytetracycline',
      casNumber: '79-57-2',
      otherNames: [],
      reportable: true
    },
    'RF-00000561-VET': {
      reference: 'RF-00000561-VET',
      name: 'Flumequine',
      casNumber: '42835-25-6',
      otherNames: ['Flumequin'],
      reportable: true
    },
    'RF-00001230-PAR': {
      reference: 'RF-00001230-PAR',
      name: 'Amidosulfuron (sum of amidosulfuron and desmethyl amidosulfuron, expressed as amidosulfuron)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00001407-PAR': {
      reference: 'RF-00001407-PAR',
      name: 'Paraffin oils with carbon chain lengths of C11-C25',
      casNumber: '64742-46-7',
      otherNames: [],
      reportable: true
    },
    'RF-00001408-PAR': {
      reference: 'RF-00001408-PAR',
      name: 'Paraffin oils with carbon chain lengths of C15-C30',
      casNumber: '72623-86-0',
      otherNames: [],
      reportable: true
    },
    'RF-00001409-PAR': {
      reference: 'RF-00001409-PAR',
      name: 'Paraffin oils with carbon chain lengths of C11-C30',
      casNumber: '97862-82-3',
      otherNames: [],
      reportable: true
    },
    'RF-00001410-PAR': {
      reference: 'RF-00001410-PAR',
      name: 'Paraffin oils with carbon chain lengths C18-C30',
      casNumber: '8012-95-1',
      otherNames: [],
      reportable: true
    },
    'RF-00001575-PAR': {
      reference: 'RF-00001575-PAR',
      name: 'Waxes, paraffinic, refined, derived from petroleum based or synthetic hydrocarbon feedstocks',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00001576-PAR': {
      reference: 'RF-00001576-PAR',
      name: 'Petroleum Hydrocarbon Resins (hydrogenated)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00001596-PAR': {
      reference: 'RF-00001596-PAR',
      name: 'Desethyl-hydroxy-terbuthylazine',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00001604-PAR': {
      reference: 'RF-00001604-PAR',
      name: '2,5-Dichlorobenzoic acid methylester',
      casNumber: '2905-69-3',
      otherNames: [],
      reportable: true
    },
    'RF-00001606-PAR': {
      reference: 'RF-00001606-PAR',
      name: 'Sintofen',
      casNumber: '130561-48-7',
      otherNames: ['Cintofen'],
      reportable: true
    },
    'RF-00001608-PAR': {
      reference: 'RF-00001608-PAR',
      name: 'Pepper Dust Extraction Residue',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00001612-PAR': {
      reference: 'RF-00001612-PAR',
      name: 'Pyrimethanil metabolite (AEF132593)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00001688-PAR': {
      reference: 'RF-00001688-PAR',
      name: 'Formetanate hydrochloride',
      casNumber: '23422-53-9',
      otherNames: [
        'N,N-dimethyl-N′-[3-[[(methylamino)carbonyl]oxy]phenyl]methanimidamide hydrochloride (1:1)'
      ],
      reportable: true
    },
    'RF-00001694-PAR': {
      reference: 'RF-00001694-PAR',
      name: 'Heptamaloxyloglucan',
      casNumber: '870721-81-6',
      otherNames: [],
      reportable: true
    },
    'RF-00001703-PAR': {
      reference: 'RF-00001703-PAR',
      name: 'Sea-algae extract',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00001825-PAR': {
      reference: 'RF-00001825-PAR',
      name: 'Trimethylamine hydrochloride',
      casNumber: '593-81-7',
      otherNames: [],
      reportable: true
    },
    'RF-00002580-PAR': {
      reference: 'RF-00002580-PAR',
      name: 'Hydrolysed proteins',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00002582-PAR': {
      reference: 'RF-00002582-PAR',
      name: 'Benzalkonium chloride (mixture of alkylbenzyldimethylammonium chlorides with alkyl chain lengths of C8, C10, C12, C14, C16 and C18)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00002583-PAR': {
      reference: 'RF-00002583-PAR',
      name: 'Mecoprop methylester',
      casNumber: '2786-19-8',
      otherNames: [],
      reportable: true
    },
    'RF-00002584-PAR': {
      reference: 'RF-00002584-PAR',
      name: '3,4-dichloraniline',
      casNumber: '95-76-1',
      otherNames: [],
      reportable: true
    },
    'RF-00002585-PAR': {
      reference: 'RF-00002585-PAR',
      name: 'MCPA-thioethyl',
      casNumber: '25319-90-8',
      otherNames: [],
      reportable: true
    },
    'RF-00002586-PAR': {
      reference: 'RF-00002586-PAR',
      name: 'Triazamate acid',
      casNumber: '110895-51-7',
      otherNames: [],
      reportable: true
    },
    'RF-00002588-PAR': {
      reference: 'RF-00002588-PAR',
      name: '2,4-DB methylester',
      casNumber: '18625-12-2',
      otherNames: ['2,4-dichlophenoxy butanoic acid methyl ester'],
      reportable: true
    },
    'RF-00002589-PAR': {
      reference: 'RF-00002589-PAR',
      name: 'Morpholine',
      casNumber: '110-91-8',
      otherNames: [],
      reportable: true
    },
    'RF-00002590-PAR': {
      reference: 'RF-00002590-PAR',
      name: 'Atrazine, Desisopropyl-2-hydroxy-',
      casNumber: '7313-54-4',
      otherNames: ['DIHA'],
      reportable: true
    },
    'RF-00002591-PAR': {
      reference: 'RF-00002591-PAR',
      name: 'Cyflumetofen',
      casNumber: '400882-07-7',
      otherNames: [],
      reportable: false
    },
    'RF-00002592-PAR': {
      reference: 'RF-00002592-PAR',
      name: 'Demeton-O-methyl',
      casNumber: '867-27-6',
      otherNames: [],
      reportable: true
    },
    'RF-00002593-PAR': {
      reference: 'RF-00002593-PAR',
      name: 'Thiencarbazone-methyl',
      casNumber: '317815-83-1',
      otherNames: [],
      reportable: true
    },
    'RF-00002596-PAR': {
      reference: 'RF-00002596-PAR',
      name: 'Bromadiolone',
      casNumber: '28772-56-7',
      otherNames: [
        "3-[3-(4'-Bromo[1,1'-biphenyl]-4-yl)-3-hydroxy-1-phenylpropyl]-4-hydroxy-2H-1-benzopyran-2-one"
      ],
      reportable: true
    },
    'RF-00002605-PAR': {
      reference: 'RF-00002605-PAR',
      name: '2,4-DB (sum of 2,4-DB and its conjugates, expressed as 2,4-DB)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00002606-PAR': {
      reference: 'RF-00002606-PAR',
      name: 'Ametoctradin, metabolite 4-(7-amino-5-ethyl [1,2,4]triazolo, [1,5-a]pyrimidin-6-yl) butanoic acid (M650F01) and metabolite 6-(7-amino-5-ethyl [1,2,4]triazolo [1,5-a]pyrimidin-6-yl) hexanoic acid (M650F06), expressed as ametoctradin',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00002607-PAR': {
      reference: 'RF-00002607-PAR',
      name: '8-hydroxyquinoline (sum of 8-hydroxyquinoline and its salts, expressed as 8-hydroxyquinoline)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00002608-PAR': {
      reference: 'RF-00002608-PAR',
      name: 'Tembotrione metabolite M5 (Dihydroxy-tembotrione)',
      casNumber: '912654-91-2',
      otherNames: ['Tembotrione metabolite AE 1417268'],
      reportable: true
    },
    'RF-00002609-PAR': {
      reference: 'RF-00002609-PAR',
      name: 'Penthiopyrad',
      casNumber: '183675-82-3',
      otherNames: [],
      reportable: true
    },
    'RF-00002610-PAR': {
      reference: 'RF-00002610-PAR',
      name: 'Fenpyrazamine',
      casNumber: '473798-59-3',
      otherNames: [],
      reportable: true
    },
    'RF-00002611-PAR': {
      reference: 'RF-00002611-PAR',
      name: 'Metolachlor and S-metolachlor (metolachlor including other mixtures of constituent isomers including S-metolachlor (sum of isomers))',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00002612-PAR': {
      reference: 'RF-00002612-PAR',
      name: 'Potassium tri-iodide',
      casNumber: '12298-68-9',
      otherNames: [],
      reportable: true
    },
    'RF-00002835-PAR': {
      reference: 'RF-00002835-PAR',
      name: 'Prothiocarb',
      casNumber: '19622-08-3',
      otherNames: [],
      reportable: true
    },
    'RF-00002836-PAR': {
      reference: 'RF-00002836-PAR',
      name: 'IM-2-1 (N1-[(6-chloro-3-pyridyl)methyl]-N2-cyanoacetamidine),(N-desmethyl-acetamiprid)',
      casNumber: '190604-92-3',
      otherNames: ['IM-2-1', 'N-desmethyl-acetamiprid'],
      reportable: true
    },
    'RF-00002837-PAR': {
      reference: 'RF-00002837-PAR',
      name: '2-chloro-N-(4’-chloro-5-hydroxybiphenyl-2-yl)nicotinamide (M510F01)',
      casNumber: '661463-87-2',
      otherNames: [
        '2-chloro-N-(4’-chloro-5-hydroxybiphenyl-2-yl)nicotinamide (M 510F01)',
        'M 510F01'
      ],
      reportable: true
    },
    'RF-00002838-PAR': {
      reference: 'RF-00002838-PAR',
      name: 'Meptyldinocap',
      casNumber: '131-72-6',
      otherNames: [],
      reportable: true
    },
    'RF-00002840-PAR': {
      reference: 'RF-00002840-PAR',
      name: '2-cyclohexyl-4,6-dinitrophenol',
      casNumber: '131-89-5',
      otherNames: ['Dinex', 'Dinitrocyclohexylphenol'],
      reportable: true
    },
    'RF-00002841-PAR': {
      reference: 'RF-00002841-PAR',
      name: 'Mexacarbate',
      casNumber: '315-18-4',
      otherNames: ['Zectran', '4-dimethylamino-3,5-xylyl methylcarbamate'],
      reportable: true
    },
    'RF-00003017-PAR': {
      reference: 'RF-00003017-PAR',
      name: 'Fenvalerate (sum of fenvalerate (any ratio of constituent isomers including esfenvalerate) and CPIA (chlorophenyl isovaleric acid), expressed as fenvalerate)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003018-PAR': {
      reference: 'RF-00003018-PAR',
      name: 'Milbemectin (sum of milbemycin A4 and milbemycin A3, expressed as milbemectin)',
      casNumber: null,
      otherNames: [
        '(6R,25R)-5-O-demethyl-28-deoxy-6,28-epoxy-25-ethylmilbemycin B mixture with (6R,25R)-5-O-demethyl-28-deoxy-6,28-epoxy-25-methylmilbemycin B'
      ],
      reportable: true
    },
    'RF-00003031-PAR': {
      reference: 'RF-00003031-PAR',
      name: 'Pyriofenone',
      casNumber: '688046-61-9',
      otherNames: [],
      reportable: true
    },
    'RF-00003032-PAR': {
      reference: 'RF-00003032-PAR',
      name: 'Bifenazate-diazene',
      casNumber: '149878-40-0',
      otherNames: [],
      reportable: true
    },
    'RF-00003033-PAR': {
      reference: 'RF-00003033-PAR',
      name: 'Bifenazate (sum of bifenazate plus bifenazate-diazene expressed as bifenazate)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003034-PAR': {
      reference: 'RF-00003034-PAR',
      name: '2-methyl-2-[4-(2-methyl-3- piperidin-1-yl-propyl)-phenyl]propionic acid (CGA289267)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003035-PAR': {
      reference: 'RF-00003035-PAR',
      name: 'Chlorpropham and 3-chloro-4-hydroxyaniline conjugates, expressed as chlorpropham',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003036-PAR': {
      reference: 'RF-00003036-PAR',
      name: '3-chloro-4-hydroxyaniline',
      casNumber: '3964-52-1',
      otherNames: [],
      reportable: true
    },
    'RF-00003037-PAR': {
      reference: 'RF-00003037-PAR',
      name: 'Tebuconazole (sum of tebuconazole, hydroxy-tebuconazole, and their conjugates, expressed as tebuconazole)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003038-PAR': {
      reference: 'RF-00003038-PAR',
      name: 'Hydroxy-tebuconazole',
      casNumber: '212267-64-6',
      otherNames: [],
      reportable: true
    },
    'RF-00003039-PAR': {
      reference: 'RF-00003039-PAR',
      name: 'Tepraloxydim (sum of tepraloxydim and its metabolites that can be hydrolysed either to the moiety 3-(tetrahydro-pyran-4-yl)-glutaric acid or to the moiety 3-hydroxy-(tetrahydro-pyran-4-yl)-glutaric acid, expressed as tepraloxydim)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003040-PAR': {
      reference: 'RF-00003040-PAR',
      name: 'Quassia',
      casNumber: '68915-32-2',
      otherNames: [],
      reportable: true
    },
    'RF-00003041-PAR': {
      reference: 'RF-00003041-PAR',
      name: '2,4,5-T (sum of 2,4,5-T, its salts and esters, expressed as 2,4,5-T)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003320-PAR': {
      reference: 'RF-00003320-PAR',
      name: '1,1-dimethyl-hydrazine (UDHM)',
      casNumber: null,
      otherNames: ['1,1-dimethyl-hydrazine', 'UDHM'],
      reportable: true
    },
    'RF-00003321-PAR': {
      reference: 'RF-00003321-PAR',
      name: '2,3,4,5-TCNB (2,3,4,5-Tetrachloronitrobenzene)',
      casNumber: null,
      otherNames: ['UDHM'],
      reportable: true
    },
    'RF-00003322-PAR': {
      reference: 'RF-00003322-PAR',
      name: '3-OH-carbofuran (free and conjugated) expressed as carbofuran',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003323-PAR': {
      reference: 'RF-00003323-PAR',
      name: '479M04 ([(2,6-dimethylphenyl)(1Hpyrazol-1-ylmethyl)amino](oxo)acetic acid)',
      casNumber: null,
      otherNames: [
        'Metazachlor OXA',
        'Metazachlor oxalic acid',
        '[(2,6-dimethylphenyl)(1Hpyrazol-1-ylmethyl)amino](oxo)acetic acid'
      ],
      reportable: true
    },
    'RF-00003324-PAR': {
      reference: 'RF-00003324-PAR',
      name: '479M08 (2-[(2,6-dimethylphenyl)(1Hpyrazol-1-ylmethyl)amino]-2-oxoethanesulfonic acid)',
      casNumber: null,
      otherNames: [
        'Metazachlor OXA',
        'Metazachlor oxalic acid',
        '[(2,6-dimethylphenyl)(1Hpyrazol-1-ylmethyl)amino](oxo)acetic acid'
      ],
      reportable: true
    },
    'RF-00003325-PAR': {
      reference: 'RF-00003325-PAR',
      name: '479M16 (3-({2-[(2,6-dimethylphenyl)(1H-pyrazol-1-ylmethyl)amino]-2-oxoethyl}sulfinyl)-2-hydroxypropanoic acid)',
      casNumber: null,
      otherNames: [
        'Metazachlor sulfonic acid, 2-[(2,6-dimethylphenyl)(1Hpyrazol-1-ylmethyl)amino]-2-oxoethanesulfonic acid'
      ],
      reportable: true
    },
    'RF-00003326-PAR': {
      reference: 'RF-00003326-PAR',
      name: 'Acetamiprid (sum of acetamiprid and N-desmethyl-acetamiprid (IM-2-1), expressed as acetamiprid)',
      casNumber: null,
      otherNames: [
        '3-({2-[(2,6-dimethylphenyl)(1H-pyrazol-1-ylmethyl)amino]-2-oxoethyl}sulfinyl)-2-hydroxypropanoic acid'
      ],
      reportable: true
    },
    'RF-00003327-PAR': {
      reference: 'RF-00003327-PAR',
      name: 'Bromoxynil and its salts, expressed as bromoxynil',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003328-PAR': {
      reference: 'RF-00003328-PAR',
      name: 'BTS 44595 (N-propyl-N-[2-(2,4,6-trichlorophenoxy)ethyl]-urea)',
      casNumber: null,
      otherNames: ['1-Propyl-1-[2-(2,4,6-trichlorophenoxy)ethyl]urea'],
      reportable: true
    },
    'RF-00003329-PAR': {
      reference: 'RF-00003329-PAR',
      name: "BTS 44596 (N'-Formyl-N-propyl-N-[2-(2,4,6-trichlorophenoxy)ethyl]urea)",
      casNumber: null,
      otherNames: ['1-Propyl-1-[2-(2,4,6-trichlorophenoxy)ethyl]urea'],
      reportable: true
    },
    'RF-00003330-PAR': {
      reference: 'RF-00003330-PAR',
      name: 'BYI08330 enol-glucoside (cis-3-(2,5-Dimethylphenyl)-8-methoxy-2-oxo-1-azaspiro [4.5]dec-3-en-4-yl ß-D-glucopyranoside)',
      casNumber: null,
      otherNames: ['BYI08330 enol-glucoside'],
      reportable: true,
      lmrCanBeOptional: true
    },
    'RF-00003331-PAR': {
      reference: 'RF-00003331-PAR',
      name: 'BYI08330-enol (cis-3-(2,5-dimethylphenyl)-4-hydroxy-8-methoxy-1-azaspiro[4.5]dec-3-en-2-one)',
      casNumber: '382608-09-5',
      otherNames: ['BYI08330 enol-glucoside'],
      reportable: true
    },
    'RF-00003332-PAR': {
      reference: 'RF-00003332-PAR',
      name: 'BYI08330-ketohydroxy ((cis-3-(2,5-Dimethylphenyl)-3-hydroxy-8-methoxy-1-azaspiro[4.5]decane-2,4-dione)',
      casNumber: null,
      otherNames: ['BYI08330-enol'],
      reportable: true
    },
    'RF-00003333-PAR': {
      reference: 'RF-00003333-PAR',
      name: 'BYI08330-monohydroxy (cis-3-(2,5-Dimethylphenyl)-4-hydroxy-8-methoxy-1-azaspiro[4.5]decan-2-one)',
      casNumber: null,
      otherNames: ['BYI08330-ketohydroxy'],
      reportable: true
    },
    'RF-00003334-PAR': {
      reference: 'RF-00003334-PAR',
      name: 'CGA 304075 (Phenol, 4-[(4-cyclopropyl-6-methyl-2-pyrimidinyl) amino]-)',
      casNumber: '195157-66-5',
      otherNames: [],
      reportable: true
    },
    'RF-00003335-PAR': {
      reference: 'RF-00003335-PAR',
      name: 'Chlormethiuron',
      casNumber: null,
      otherNames: ['CGA 13444', 'Chloromethiuron'],
      reportable: true
    },
    'RF-00003336-PAR': {
      reference: 'RF-00003336-PAR',
      name: 'Cyantraniliprole',
      casNumber: '736994-63-1',
      otherNames: [],
      reportable: true
    },
    'RF-00003338-PAR': {
      reference: 'RF-00003338-PAR',
      name: 'Cyprodinil (sum of cyprodinil and CGA 304075 (free and conjugated), expressed as cyprodinil)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003339-PAR': {
      reference: 'RF-00003339-PAR',
      name: 'Daminozide',
      casNumber: '1596-84-5',
      otherNames: [
        'butanedioic acid mono(2,2-dimethylhydrazide)',
        'N-(dimethylamino)succinamic acid',
        '4-(2,2-dimethylhydrazinyl)-4-oxobutanoic acid'
      ],
      reportable: true
    },
    'RF-00003340-PAR': {
      reference: 'RF-00003340-PAR',
      name: 'Demeton-O',
      casNumber: null,
      otherNames: ['Demeton thiono', 'Demetonthione', 'Mercaptofos'],
      reportable: true
    },
    'RF-00003341-PAR': {
      reference: 'RF-00003341-PAR',
      name: 'Demeton-O-sulfoxide',
      casNumber: null,
      otherNames: ['Demeton thiono', 'Demetonthione', 'Mercaptofos'],
      reportable: true
    },
    'RF-00003342-PAR': {
      reference: 'RF-00003342-PAR',
      name: 'Dinoseb (sum of dinoseb, its salts, dinoseb-acetate and binapacryl, expressed as dinoseb)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003343-PAR': {
      reference: 'RF-00003343-PAR',
      name: 'Dinoterb (sum of dinoterb, its salts and esters, expressed as dinoterb)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003344-PAR': {
      reference: 'RF-00003344-PAR',
      name: 'Metazachlor (Sum of metabolites 479M04, 479M08 and 479M16, expressed as metazachlor)',
      casNumber: null,
      otherNames: [
        'Metazachlor (sum of metabolites 479M04, 479M08, 479M16, expresssed as metazachlor)'
      ],
      reportable: true
    },
    'RF-00003345-PAR': {
      reference: 'RF-00003345-PAR',
      name: 'Metazachlor (sum of metazachlor and its metabolites containing the 2,6-dimethylaniline moiety, expressed as metazachlor)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003346-PAR': {
      reference: 'RF-00003346-PAR',
      name: 'Terbumeton desethyl',
      casNumber: null,
      otherNames: ['Desethylterbumeton(e)'],
      reportable: true
    },
    'RF-00003347-PAR': {
      reference: 'RF-00003347-PAR',
      name: 'TFNA-AM (4-(trifluoromethyl)pyridine-3-carboxamide)',
      casNumber: '158062-71-6',
      otherNames: ['Desethylterbumeton(e)'],
      reportable: true,
      //une LMR existe mais uniquement sur les produits animaux
      lmrCanBeOptional: true
    },
    'RF-00003348-PAR': {
      reference: 'RF-00003348-PAR',
      name: 'TNFA (4-(Trifluoromethyl)nicotinic acid)',
      casNumber: null,
      otherNames: ['4-trifluoromethylnicotinamide'],
      reportable: true
    },
    'RF-00003349-PAR': {
      reference: 'RF-00003349-PAR',
      name: 'TNFG (4-(Trifluoromethyl)nicotinoyl glycine)',
      casNumber: null,
      otherNames: ['4-(Trifluoromethyl)nicotinic acid'],
      reportable: true
    },
    'RF-00003350-PAR': {
      reference: 'RF-00003350-PAR',
      name: '8,9-milbemycin A4',
      casNumber: null,
      otherNames: ['8,9-Z-MA4'],
      reportable: true
    },
    'RF-00003351-PAR': {
      reference: 'RF-00003351-PAR',
      name: 'Acibenzolar-S-methyl (sum of acibenzolar-S-methyl and acibenzolar acid (free and conjugated), expressed as acibenzolar-S-methyl)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003352-PAR': {
      reference: 'RF-00003352-PAR',
      name: 'Fludioxonil (sum of fludioxonil and its metabolites oxidized to metabolite 2,2-difluoro-benzo[1,3]dioxole-4 carboxylic acid expressed as fludioxonil)',
      casNumber: null,
      otherNames: [
        'Fludioxonil (sum of fludioxonil and its metabolites oxidized to metabolite 2,2-difluoro-benzo[1,3]dioxole-4 carboxylic acid)'
      ],
      reportable: true
    },
    'RF-00003353-PAR': {
      reference: 'RF-00003353-PAR',
      name: 'Flutolanil (flutolanil and metabolites containing the 2-trifluoromethylbenzoic acid moiety, expressed as flutolanil)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003354-PAR': {
      reference: 'RF-00003354-PAR',
      name: 'FM-6-1 (N-(4-chloro-2-trifluoromethylphenyl)-n-propoxyacetamidine)',
      casNumber: null,
      otherNames: ['109849-99-2'],
      reportable: true
    },
    'RF-00003355-PAR': {
      reference: 'RF-00003355-PAR',
      name: 'Glufosinate',
      casNumber: '51276-47-2',
      otherNames: [],
      reportable: true
    },
    'RF-00003356-PAR': {
      reference: 'RF-00003356-PAR',
      name: 'Isouron',
      casNumber: null,
      otherNames: ['Isoxyl'],
      reportable: true
    },
    'RF-00003357-PAR': {
      reference: 'RF-00003357-PAR',
      name: 'Mesotrione',
      casNumber: '104206-82-8',
      otherNames: [
        'Isoxyl',
        '2-(4-methylsulfonyl-2-nitrobenzoyl)cyclohexane-1,3-dione'
      ],
      reportable: true
    },
    'RF-00003358-PAR': {
      reference: 'RF-00003358-PAR',
      name: 'Methoxychlorolefin',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003360-PAR': {
      reference: 'RF-00003360-PAR',
      name: 'MPP (3-Methylphosphinicopropionic acid)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003361-PAR': {
      reference: 'RF-00003361-PAR',
      name: 'NAG (N-acetyl-glufosinate)',
      casNumber: '73634-73-8',
      otherNames: ['N-acetylglufosinate'],
      reportable: true
    },
    'RF-00003362-PAR': {
      reference: 'RF-00003362-PAR',
      name: 'Penflufen',
      casNumber: '494793-67-8',
      otherNames: ['N-acetylglufosinate'],
      reportable: true
    },
    'RF-00003364-PAR': {
      reference: 'RF-00003364-PAR',
      name: 'N-oxide propamocarb',
      casNumber: null,
      otherNames: ['Propyl [3-(methylamino)propyl]carbamate'],
      reportable: true
    },
    'RF-00003365-PAR': {
      reference: 'RF-00003365-PAR',
      name: 'Pymetrozine, 6-hydroxymethylpymetrozine and its phosphate conjugate, expressed as pymetrozine',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003366-PAR': {
      reference: 'RF-00003366-PAR',
      name: 'Pyraflufen',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003367-PAR': {
      reference: 'RF-00003367-PAR',
      name: 'Pyraflufen-ethyl (sum of pyraflufen-ethyl and pyraflufen, expressed as pyraflufen-ethyl)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003368-PAR': {
      reference: 'RF-00003368-PAR',
      name: 'Spirotetramat',
      casNumber: '203313-25-1',
      otherNames: [],
      reportable: true
    },
    'RF-00003369-PAR': {
      reference: 'RF-00003369-PAR',
      name: 'Sum of bentazone, its salts and 6-hydroxy bentazone (free and conjugated), expressed as bentazone',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003370-PAR': {
      reference: 'RF-00003370-PAR',
      name: 'Sum of pyrimethanil and 2-(4-hydroxyanilino)-4.6-dimethylpyrimidine, expressed as pyrimethanil',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003371-PAR': {
      reference: 'RF-00003371-PAR',
      name: 'Sum of pyrimethanil and 2-anilino-4.6-dimethylpyrimidine-5-ol, expressed as pyrimethanil',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003374-PAR': {
      reference: 'RF-00003374-PAR',
      name: 'Carbofuran (sum of carbofuran (including any carbofuran generated from carbosulfan, benfuracarb or furathiocarb) and 3-OH carbofuran expressed as carbofuran)',
      casNumber: null,
      otherNames: [
        '5-(4-chlorophenyl)-2,2-dimethyl-3-(1H-1,2,4-triazol-1-ylmethyl)pentane-1,3-diol'
      ],
      reportable: true
    },
    'RF-00003375-PAR': {
      reference: 'RF-00003375-PAR',
      name: 'Sum of iprodione and all metabolites containing the 3,5-dichloroaniline moiety expressed as iprodione',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003376-PAR': {
      reference: 'RF-00003376-PAR',
      name: 'BAC 8',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003377-PAR': {
      reference: 'RF-00003377-PAR',
      name: 'Desmethyl-bixafen',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003378-PAR': {
      reference: 'RF-00003378-PAR',
      name: 'Cyhalofop-butyl',
      casNumber: '122008-85-9',
      otherNames: [],
      reportable: true
    },
    'RF-00003379-PAR': {
      reference: 'RF-00003379-PAR',
      name: 'IN-F7321 ([bis-(4-fluorophenyl)methyl]silanol) expressed as flusilazole)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00003380-PAR': {
      reference: 'RF-00003380-PAR',
      name: 'Trifloxystrobin metabolite (CGA 321113)',
      casNumber: '252913-85-2',
      otherNames: ['M5'],
      reportable: true
    },
    'RF-00003386-PAR': {
      reference: 'RF-00003386-PAR',
      name: 'Benzovindiflupyr',
      casNumber: '1072957-71-1',
      otherNames: [],
      reportable: true
    },
    'RF-00003387-PAR': {
      reference: 'RF-00003387-PAR',
      name: '4-bromophenylurea',
      casNumber: '1967-25-5',
      otherNames: [],
      reportable: true
    },
    'RF-00003483-PAR': {
      reference: 'RF-00003483-PAR',
      name: 'Matrine',
      casNumber: null,
      otherNames: ['matrine'],
      reportable: true
    },
    'RF-00003591-PAR': {
      reference: 'RF-00003591-PAR',
      name: 'strychnine',
      casNumber: '57-24-9',
      otherNames: [],
      reportable: true
    },
    'RF-00003683-PAR': {
      reference: 'RF-00003683-PAR',
      name: 'anethole',
      casNumber: '4180-23-8',
      otherNames: ['trans-Anethole'],
      reportable: true
    },
    'RF-00003707-PAR': {
      reference: 'RF-00003707-PAR',
      name: '2-undecanone',
      casNumber: '112-12-9',
      otherNames: [
        'Methyl nonyl ketone',
        '2-Hendecanone',
        '2-Oxoundecane',
        'Rue ketone'
      ],
      reportable: true
    },
    'RF-00003742-PAR': {
      reference: 'RF-00003742-PAR',
      name: 'cinnamaldehyde',
      casNumber: '104-55-2',
      otherNames: [
        '3-Phenyl-2-propenal',
        'Benzylidene acetaldehyde',
        'Cassia aldehyde',
        'Cinnamal',
        'Cinnamic aldehyde',
        'beta-Phenylacrolein',
        'Zimtaldehyde'
      ],
      reportable: true
    },
    'RF-00003744-PAR': {
      reference: 'RF-00003744-PAR',
      name: 'indole-3-acetic acid',
      casNumber: '87-51-4',
      otherNames: ['Indolylacetic acid'],
      reportable: true
    },
    'RF-00004266-PAR': {
      reference: 'RF-00004266-PAR',
      name: 'delta 3-carene',
      casNumber: '13466-78-9',
      otherNames: [],
      reportable: true
    },
    'RF-00004538-PAR': {
      reference: 'RF-00004538-PAR',
      name: 'Formaldehyde',
      casNumber: '50-00-0',
      otherNames: [],
      reportable: true
    },
    'RF-00004643-PAR': {
      reference: 'RF-00004643-PAR',
      name: '2,2-difluoro-benzo[1,3]dioxole-4 carboxylic acid',
      casNumber: '126120-85-2',
      otherNames: [],
      reportable: true
    },
    'RF-00004644-PAR': {
      reference: 'RF-00004644-PAR',
      name: '2,4 DNOP',
      casNumber: '4467-92-9',
      otherNames: [],
      reportable: true
    },
    'RF-00004645-PAR': {
      reference: 'RF-00004645-PAR',
      name: '2,4 DNOPC',
      casNumber: '49794-90-3',
      otherNames: [],
      reportable: true
    },
    'RF-00004646-PAR': {
      reference: 'RF-00004646-PAR',
      name: '2,4-DB',
      casNumber: '94-82-6',
      otherNames: [],
      reportable: true
    },
    'RF-00004647-PAR': {
      reference: 'RF-00004647-PAR',
      name: '2,4-Dichlorobenzamide',
      casNumber: '2447-79-2',
      otherNames: [],
      reportable: true
    },
    'RF-00004648-PAR': {
      reference: 'RF-00004648-PAR',
      name: '2-hydroxypropoxycarbazone',
      casNumber: '496925-02-1',
      otherNames: [],
      reportable: true
    },
    'RF-00004649-PAR': {
      reference: 'RF-00004649-PAR',
      name: '3-iodo-2-propynyl butyl carbamate',
      casNumber: '55406-53-6',
      otherNames: [],
      reportable: true
    },
    'RF-00004650-PAR': {
      reference: 'RF-00004650-PAR',
      name: '3-OH THPI',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004651-PAR': {
      reference: 'RF-00004651-PAR',
      name: '4–chlorophenylurea',
      casNumber: '140-38-5',
      otherNames: ['4 –chlorophenylurea'],
      reportable: true
    },
    'RF-00004652-PAR': {
      reference: 'RF-00004652-PAR',
      name: '4-hydroxychlorpropham-O-sulphonic acid (4-HSA)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004653-PAR': {
      reference: 'RF-00004653-PAR',
      name: '505M09, expressed as dimoxystrobin',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004654-PAR': {
      reference: 'RF-00004654-PAR',
      name: '5-OH THPI',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004655-PAR': {
      reference: 'RF-00004655-PAR',
      name: 'Abamectin (sum of avermectin B1a, avermectin B1b and delta-8,9 isomer of avermectin B1a, expressed as avermectin B1a)',
      casNumber: null,
      otherNames: [
        'Abamectin (sum of avermectin B1a, avermectinB1b and delta-8,9 isomer of avermectin B1a, expressed as avermectin B1a)'
      ],
      reportable: true
    },
    'RF-00004656-PAR': {
      reference: 'RF-00004656-PAR',
      name: 'Benthiavalicarb (Benthiavalicarb-isopropyl(KIF-230 R-L) and its enantiomer (KIF-230 S-D) and its diastereomers(KIF-230 S-L and KIF-230 R-D), expressed as benthiavalicarb-isopropyl)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004657-PAR': {
      reference: 'RF-00004657-PAR',
      name: 'CPIA (chlorophenyl isovaleric acid)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004658-PAR': {
      reference: 'RF-00004658-PAR',
      name: 'Desmethyl amidosulfuron (AE F101630)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004659-PAR': {
      reference: 'RF-00004659-PAR',
      name: 'Dichlorprop (Sum of dichlorprop (including dichlorprop-P), its salts, esters and conjugates, expressed as dichlorprop)',
      casNumber: null,
      otherNames: [
        'Dichlorprop (Sum of dichlorprop (including dichlorprop-P), its salts, esters and conjugates, expressed as dichlorprop'
      ],
      reportable: true
    },
    'RF-00004660-PAR': {
      reference: 'RF-00004660-PAR',
      name: 'Difluoroacetic acid (DFA)',
      casNumber: '381-73-7',
      otherNames: [],
      reportable: true
    },
    'RF-00004661-PAR': {
      reference: 'RF-00004661-PAR',
      name: 'Fluopyram-benzamide (M25)',
      casNumber: '360-64-5',
      otherNames: [],
      reportable: true
    },
    'RF-00004662-PAR': {
      reference: 'RF-00004662-PAR',
      name: 'Flupyradifurone',
      casNumber: '951659-40-8',
      otherNames: [],
      reportable: true
    },
    'RF-00004663-PAR': {
      reference: 'RF-00004663-PAR',
      name: 'Fluroxypyr (sum of fluroxypyr, its salts, its esters, and its conjugates, expressed as fluroxypyr)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004664-PAR': {
      reference: 'RF-00004664-PAR',
      name: 'Guazatine (guazatine acetate, sum of components)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004665-PAR': {
      reference: 'RF-00004665-PAR',
      name: 'Halauxifen (X11393729)',
      casNumber: '943832-60-8',
      otherNames: [],
      reportable: true
    },
    'RF-00004666-PAR': {
      reference: 'RF-00004666-PAR',
      name: 'Halauxifen-methyl (sum of halauxifen-methyl and X11393729 (halauxifen), expressed as halauxifen-methyl)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004667-PAR': {
      reference: 'RF-00004667-PAR',
      name: 'Haloxyfop (Sum of haloxyfop, its esters, salts and conjugates expressed as haloxyfop (sum of the R- and S- isomers at any ratio))',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004668-PAR': {
      reference: 'RF-00004668-PAR',
      name: 'Indolylbutyric acid',
      casNumber: '133-32-4',
      otherNames: ['1H-indole-3-butanoic acid'],
      reportable: true
    },
    'RF-00004669-PAR': {
      reference: 'RF-00004669-PAR',
      name: 'M650F01 (4-(7-amino-5-ethyl [1,2,4]triazolo, [1,5-a]pyrimidin-6-yl) butanoic acid)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004670-PAR': {
      reference: 'RF-00004670-PAR',
      name: 'M650F06 (6-(7-amino-5-ethyl [1,2,4]triazolo [1,5-a]pyrimidin-6-yl) hexanoic acid)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004671-PAR': {
      reference: 'RF-00004671-PAR',
      name: 'Mandestrobin',
      casNumber: '173662-97-0',
      otherNames: [],
      reportable: true
    },
    'RF-00004672-PAR': {
      reference: 'RF-00004672-PAR',
      name: 'Mevinphos E-isomer',
      casNumber: '26718-65-0',
      otherNames: [],
      reportable: true
    },
    'RF-00004673-PAR': {
      reference: 'RF-00004673-PAR',
      name: 'Mevinphos Z-isomer',
      casNumber: '338-45-4',
      otherNames: [],
      reportable: true
    },
    'RF-00004674-PAR': {
      reference: 'RF-00004674-PAR',
      name: 'N-acetyl glyphosate',
      casNumber: '129660-96-4',
      otherNames: [],
      reportable: true
    },
    'RF-00004675-PAR': {
      reference: 'RF-00004675-PAR',
      name: 'Phosphonic acid',
      casNumber: '13598-36-2',
      otherNames: [],
      reportable: true
    },
    'RF-00004676-PAR': {
      reference: 'RF-00004676-PAR',
      name: 'Pyribencarb',
      casNumber: '799247-52-2',
      otherNames: [],
      reportable: true
    },
    'RF-00004677-PAR': {
      reference: 'RF-00004677-PAR',
      name: 'RPA 202248 diketonitrile-metabolite',
      casNumber: '143701-75-1',
      otherNames: [],
      reportable: true
    },
    'RF-00004679-PAR': {
      reference: 'RF-00004679-PAR',
      name: 'Sulfoxaflor (sum of isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004681-PAR': {
      reference: 'RF-00004681-PAR',
      name: 'Captan (sum of captan and THPI, expressed as captan)',
      casNumber: null,
      otherNames: ['Sum of captan and THPI, expressed as captan'],
      reportable: true
    },
    'RF-00004682-PAR': {
      reference: 'RF-00004682-PAR',
      name: 'Sum of dichlorprop (including dichlorprop-P) and its salts, expressed as dichlorprop',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004683-PAR': {
      reference: 'RF-00004683-PAR',
      name: 'Flonicamid (sum of flonicamid, TFNA and TFNG expressed as flonicamid)',
      casNumber: null,
      otherNames: [
        'Flonicamid (sum of flonicamid, TNFG and TNFA expressed as flonicamid)'
      ],
      reportable: true
    },
    'RF-00004684-PAR': {
      reference: 'RF-00004684-PAR',
      name: 'Sum of haloxyfop, its salts and conjugates expressed as haloxyfop (sum of the R- and S- isomers at any ratio)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004685-PAR': {
      reference: 'RF-00004685-PAR',
      name: 'Sum of THPI, 3-OH THPI and 5-OH THPI, expressed as captan',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004686-PAR': {
      reference: 'RF-00004686-PAR',
      name: 'THPI',
      casNumber: '85-40-5',
      otherNames: [],
      reportable: true,
      lmrCanBeOptional: true
    },
    'RF-00004687-PAR': {
      reference: 'RF-00004687-PAR',
      name: 'Folpet (sum of folpet and phthalimide, expressed as folpet)',
      casNumber: null,
      otherNames: ['Sum of folpet and phthalimide, expressed as folpet'],
      reportable: true
    },
    'RF-00004688-PAR': {
      reference: 'RF-00004688-PAR',
      name: 'Phthalimide, expressed as folpet',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004728-PAR': {
      reference: 'RF-00004728-PAR',
      name: '1,4-Dimethylnaphthalene',
      casNumber: '571-58-4',
      otherNames: [],
      reportable: true
    },
    'RF-00004758-PAR': {
      reference: 'RF-00004758-PAR',
      name: 'Tricalcium phosphate',
      casNumber: '7758-87-4',
      otherNames: [],
      reportable: true
    },
    'RF-00004816-PAR': {
      reference: 'RF-00004816-PAR',
      name: 'Saflufenacil',
      casNumber: '372137-35-4',
      otherNames: [],
      reportable: true
    },
    'RF-00004817-PAR': {
      reference: 'RF-00004817-PAR',
      name: 'Saflufenacil (sum of saflufenacil, M800H11 and M800H35, expressed as saflufenacil)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00004818-PAR': {
      reference: 'RF-00004818-PAR',
      name: 'BTS 40348 (N-[2-(2,4,6-Trichlorophenoxy)ethyl]propylamine)',
      casNumber: '67747-01-7',
      otherNames: [],
      reportable: true
    },
    'RF-00004827-PAR': {
      reference: 'RF-00004827-PAR',
      name: '24-Epibrassinolide',
      casNumber: '78821-43-9',
      otherNames: [
        '(3aS,5S,6R,7aR,7bS,9aS,10R,12aS,12bS)-10-[(2S,3R,4R,5R)-3,4-dihydroxy-5,6-dimethylheptan-2-yl]-5,6-dihydroxy-7a,9a-dimethylhexadecahydro-3H-benzo[c]indeno[5,4-e]oxepin-3-one'
      ],
      reportable: true
    },
    'RF-00004850-PAR': {
      reference: 'RF-00004850-PAR',
      name: 'Isopropyl alcohol',
      casNumber: '67-63-0',
      otherNames: [
        '2-Propanol',
        'Isopropanol',
        '1-Methylethanol',
        'Avantin',
        'Propol',
        'Dimethylcarbinol sec-Propyl alcohol'
      ],
      reportable: true
    },
    'RF-00004913-PAR': {
      reference: 'RF-00004913-PAR',
      name: 'Thyme oil',
      casNumber: '8007-46-3',
      otherNames: [
        'Thymus vulgaris oil',
        'Thymolum',
        '2-izopropil-5-metil-fenol',
        '2-isopropil-methylphenol'
      ],
      reportable: true
    },
    'RF-00005711-PAR': {
      reference: 'RF-00005711-PAR',
      name: '2-amino-4-methoxy-6-(trifluormethyl)-1,3,5-triazine (AMTT), resulting from the use of tritosulfuron',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005712-PAR': {
      reference: 'RF-00005712-PAR',
      name: 'Chloridazon (chloridazon-desphenyl, expressed as chloridazon)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005713-PAR': {
      reference: 'RF-00005713-PAR',
      name: 'Tralkoxydim (sum of the constituent isomers of tralkoxydim)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005714-PAR': {
      reference: 'RF-00005714-PAR',
      name: 'Fluroxypyr (sum of fluroxypyr and its salts, expressed as fluroxypyr)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005715-PAR': {
      reference: 'RF-00005715-PAR',
      name: 'Sum of boscalid and its hydroxy metabolite 2-chloro-N-(4′-chloro-5-hydroxybiphenyl-2-yl)nicotinamide (free and conjugated) expressed as boscalid',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005716-PAR': {
      reference: 'RF-00005716-PAR',
      name: 'Triflusulfuron (6-(2,2,2-trifluoroethoxy)-1,3,5-triazine-2,4-diamine (IN-M7222))',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005717-PAR': {
      reference: 'RF-00005717-PAR',
      name: 'Triadimenol (any ratio of constituent isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005718-PAR': {
      reference: 'RF-00005718-PAR',
      name: 'CMBA (2-chloro-4-(methylsulfonyl)benzoic acid)',
      casNumber: '53250-83-2',
      otherNames: ['CMBA', 'M01'],
      reportable: true
    },
    'RF-00005719-PAR': {
      reference: 'RF-00005719-PAR',
      name: 'Phosphane and phosphide salts (sum of phosphane and phosphane generators (relevant phosphide salts), determined and expressed as phosphane)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005720-PAR': {
      reference: 'RF-00005720-PAR',
      name: 'Fluoxastrobin (sum of fluoxastrobin and its Z-isomer)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005721-PAR': {
      reference: 'RF-00005721-PAR',
      name: 'Mepiquat (sum of mepiquat and its salts, expressed as mepiquat chloride)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005722-PAR': {
      reference: 'RF-00005722-PAR',
      name: 'Fluoxastrobin (sum of fluoxastrobin, its Z-isomer and its metabolite 6-(2-chlorophenoxy)-5-fluoro-4-pyrimidinol, expressed as fluoxastrobin)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005723-PAR': {
      reference: 'RF-00005723-PAR',
      name: 'Fenpyroximate (metabolite M-3, expressed as fenpyroximate)',
      casNumber: '111812-58-9',
      otherNames: [],
      reportable: true
    },
    'RF-00005724-PAR': {
      reference: 'RF-00005724-PAR',
      name: 'Ethofumesate (Sum of ethofumesate, 2-keto–ethofumesate, open-ring-2-keto-ethofumesate and its conjugate, expressed as ethofumesate)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005725-PAR': {
      reference: 'RF-00005725-PAR',
      name: 'Diquat (sum of diquat and its salts, expressed as diquat)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005726-PAR': {
      reference: 'RF-00005726-PAR',
      name: 'Sodium 5-nitroguaiacolate, sodium o-nitrophenolate and sodium p-nitrophenolate (Sum of sodium 5-nitroguaiacolate, sodium o-nitrophenolate and sodium p-nitrophenolate, expressed as sodium 5-nitroguaiacolate)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005727-PAR': {
      reference: 'RF-00005727-PAR',
      name: 'Chlormequat (sum of chlormequat and its salts, expressed as chlormequat-chloride)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005728-PAR': {
      reference: 'RF-00005728-PAR',
      name: '1-Naphthylacetamide and 1-naphthylacetic acid (sum of 1-naphthylacetamide and 1-naphthylacetic acid and its salts, expressed as 1-naphythlacetic acid)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005729-PAR': {
      reference: 'RF-00005729-PAR',
      name: 'Chloridazon (sum of chloridazon and chloridazon-desphenyl, expressed as chloridazon)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005730-PAR': {
      reference: 'RF-00005730-PAR',
      name: 'Fluazifop-P (sum of all the constituent isomers of fluazifop, its esters and its conjugates, expressed as fluazifop)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005775-PAR': {
      reference: 'RF-00005775-PAR',
      name: 'Sodium hypochlorite',
      casNumber: '7681-52-9',
      otherNames: [],
      reportable: true
    },
    'RF-00005776-PAR': {
      reference: 'RF-00005776-PAR',
      name: 'Sodium 5-nitroguaiacolate',
      casNumber: '67233-85-6',
      otherNames: [],
      reportable: true
    },
    'RF-00005777-PAR': {
      reference: 'RF-00005777-PAR',
      name: 'Sodium o-nitrophenolate',
      casNumber: '824-39-5',
      otherNames: [],
      reportable: true
    },
    'RF-00005778-PAR': {
      reference: 'RF-00005778-PAR',
      name: 'Sodium p-nitrophenolate',
      casNumber: '824-78-2',
      otherNames: [],
      reportable: true
    },
    'RF-00005781-PAR': {
      reference: 'RF-00005781-PAR',
      name: 'Sodium silver thiosulfate',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005782-PAR': {
      reference: 'RF-00005782-PAR',
      name: 'S-abscisic acid',
      casNumber: '21293-29-8',
      otherNames: [],
      reportable: true
    },
    'RF-00005783-PAR': {
      reference: 'RF-00005783-PAR',
      name: 'Potassium phosphonates',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005784-PAR': {
      reference: 'RF-00005784-PAR',
      name: 'Orange oil',
      casNumber: '8026-46-8',
      otherNames: [],
      reportable: true
    },
    'RF-00005787-PAR': {
      reference: 'RF-00005787-PAR',
      name: '4-methyl-1-naphthoic acid',
      casNumber: '4488-40-8',
      otherNames: [],
      reportable: true
    },
    'RF-00005797-PAR': {
      reference: 'RF-00005797-PAR',
      name: '2-dodecyl-3-hydroxy-1,4-naphthoquinone',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005835-PAR': {
      reference: 'RF-00005835-PAR',
      name: '2-ethylhexyl (2,4-dichlorophenoxy)acetate',
      casNumber: '1928-43-4',
      otherNames: [],
      reportable: true
    },
    'RF-00005866-PAR': {
      reference: 'RF-00005866-PAR',
      name: 'De-ethyl-bupirimate',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00005868-PAR': {
      reference: 'RF-00005868-PAR',
      name: 'De-ethyl-ethirimol',
      casNumber: '4038-64-6',
      otherNames: ['Desethyl ethirimol'],
      reportable: true
    },
    'RF-00005982-PAR': {
      reference: 'RF-00005982-PAR',
      name: 'Carboxin Sulfoxide',
      casNumber: '17757-70-9',
      otherNames: [
        '2-methyl-N-phenyl-5,6-dihydro-1,4-oxathiine-3-carboxamide 4-oxide',
        '1,4-Oxathiin-3-carboxamide, 5,6-dihydro-2-methyl-N-phenyl-, 4-oxide'
      ],
      reportable: true
    },
    'RF-00006186-PAR': {
      reference: 'RF-00006186-PAR',
      name: 'Chloridazon-desphenyl',
      casNumber: '6339-19-1',
      otherNames: ['5-amino-4-chloro-3(2H)-pyridazinone'],
      reportable: true
    },
    'RF-00006204-PAR': {
      reference: 'RF-00006204-PAR',
      name: 'Alpha,alpha,alpha-trifluoro-o-toluic acid',
      casNumber: '433-97-6',
      otherNames: [],
      reportable: true
    },
    'RF-00006227-PAR': {
      reference: 'RF-00006227-PAR',
      name: '3-(3-thianyl)glutaric acid S-dioxide',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00006240-PAR': {
      reference: 'RF-00006240-PAR',
      name: '3-hydroxy-3-(3-thianyl)glutaric acid S-dioxide',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00006266-PAR': {
      reference: 'RF-00006266-PAR',
      name: 'Tralopyril',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00006293-PAR': {
      reference: 'RF-00006293-PAR',
      name: '1,3-dimethylthiourea',
      casNumber: '534-13-4',
      otherNames: [],
      reportable: true
    },
    'RF-00006322-PAR': {
      reference: 'RF-00006322-PAR',
      name: 'Oxine copper',
      casNumber: '10380-28-6',
      otherNames: [],
      reportable: true
    },
    'RF-00006326-PAR': {
      reference: 'RF-00006326-PAR',
      name: 'Trifluoroacetic acid',
      casNumber: '76-05-1',
      otherNames: [],
      reportable: true
    },
    'RF-00006543-PAR': {
      reference: 'RF-00006543-PAR',
      name: '4-bromoaniline',
      casNumber: '106-40-1',
      otherNames: [],
      reportable: false
    },
    'RF-00006545-PAR': {
      reference: 'RF-00006545-PAR',
      name: '1-(4-bromophenyl)-3-methylurea',
      casNumber: '20680-07-3',
      otherNames: ['CGA 18236'],
      reportable: false
    },
    'RF-00006668-PAR': {
      reference: 'RF-00006668-PAR',
      name: '3-[(6-iodo-4-oxo-3-propyl-3,4-dihydroquinazolin-2-yl)oxy]propanoic acid',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00006758-PAR': {
      reference: 'RF-00006758-PAR',
      name: '2,6-dinitro-4-[(4RS)-octan-4-yl]phenyl (2E)-but-2-enoate',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00006771-PAR': {
      reference: 'RF-00006771-PAR',
      name: '6-hydroxymethyl-pymetrozine',
      casNumber: null,
      otherNames: ['CGA313124'],
      reportable: true
    },
    'RF-00006809-PAR': {
      reference: 'RF-00006809-PAR',
      name: '2,4,6-trichlorophenoxyacetic acid',
      casNumber: '575-89-3',
      otherNames: [],
      reportable: true
    },
    'RF-00006819-PAR': {
      reference: 'RF-00006819-PAR',
      name: 'Pinoxaden metabolite (SYN 502836)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00006827-PAR': {
      reference: 'RF-00006827-PAR',
      name: 'Pinoxaden metabolite (SYN 505164)',
      casNumber: '881376-41-6',
      otherNames: [],
      reportable: true
    },
    'RF-00006971-PAR': {
      reference: 'RF-00006971-PAR',
      name: 'Iprodione metabolite (RP30228)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00006994-PAR': {
      reference: 'RF-00006994-PAR',
      name: 'Trichloracetic acid',
      casNumber: '76-03-9',
      otherNames: [],
      reportable: true
    },
    'RF-00007162-PAR': {
      reference: 'RF-00007162-PAR',
      name: '4-hydroxy-3-mesityl-1-oxaspiro[4.4]non-3-en-2-one',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007253-PAR': {
      reference: 'RF-00007253-PAR',
      name: 'phenoxy-hydroxypyrimidine',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007283-PAR': {
      reference: 'RF-00007283-PAR',
      name: '7-chloroquinoline-3,8-dicarboxylic acid',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007284-PAR': {
      reference: 'RF-00007284-PAR',
      name: '7-chloro-3-(hydroxymethyl)quinoline-8-carboxylic acid',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007436-PAR': {
      reference: 'RF-00007436-PAR',
      name: 'Glyphosate isopropyl amine salt',
      casNumber: '38641-94-0',
      otherNames: [],
      reportable: true
    },
    'RF-00007489-PAR': {
      reference: 'RF-00007489-PAR',
      name: 'DDAC-C12',
      casNumber: '3401-74-9',
      otherNames: ['Didodecyldimethylammonium chloride'],
      reportable: true
    },
    'RF-00007495-PAR': {
      reference: 'RF-00007495-PAR',
      name: 'DDAC-C08',
      casNumber: '5538-94-3',
      otherNames: ['Dimethyldioctylammonium chloride'],
      reportable: true
    },
    'RF-00007584-PAR': {
      reference: 'RF-00007584-PAR',
      name: 'Halauxifen-methyl',
      casNumber: '943831-98-9',
      otherNames: [],
      reportable: true
    },
    'RF-00007585-PAR': {
      reference: 'RF-00007585-PAR',
      name: 'Isofetamid',
      casNumber: '875915-78-9',
      otherNames: [],
      reportable: true
    },
    'RF-00007586-PAR': {
      reference: 'RF-00007586-PAR',
      name: 'Fenpropidin',
      casNumber: '67306-00-7',
      otherNames: [],
      reportable: true
    },
    'RF-00007587-PAR': {
      reference: 'RF-00007587-PAR',
      name: 'Trinexapac',
      casNumber: '104273-73-6',
      otherNames: [],
      reportable: false
    },
    'RF-00007588-PAR': {
      reference: 'RF-00007588-PAR',
      name: 'sum of chlorpyrifos-methyl and desmethyl chlorpyrifos-methyl, expressed as chlorpyrifos-methyl',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007589-PAR': {
      reference: 'RF-00007589-PAR',
      name: 'Metaflumizone',
      casNumber: '139968-49-3',
      otherNames: [],
      reportable: true
    },
    'RF-00007590-PAR': {
      reference: 'RF-00007590-PAR',
      name: 'Metaflumizone (Z-isomer)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007594-PAR': {
      reference: 'RF-00007594-PAR',
      name: 'Ferric pyrophosphate',
      casNumber: '10058-44-3',
      otherNames: [],
      reportable: true
    },
    'RF-00007608-PAR': {
      reference: 'RF-00007608-PAR',
      name: 'DDAC-C14  (Alkyl-quaternary ammonium salts with alkyl chain lengths of C14)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007610-PAR': {
      reference: 'RF-00007610-PAR',
      name: 'Dinocap-4-(1-ethyl hexyl)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007611-PAR': {
      reference: 'RF-00007611-PAR',
      name: 'Dinocap-4-(1-methyl heptyl)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007612-PAR': {
      reference: 'RF-00007612-PAR',
      name: 'Dinocap-6-(1-ethyl hexyl)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007614-PAR': {
      reference: 'RF-00007614-PAR',
      name: 'Open-ring-2-keto-ethofumesate',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007615-PAR': {
      reference: 'RF-00007615-PAR',
      name: 'N-Fluorophenyl-N-isopropyl',
      casNumber: '70441-63-3',
      otherNames: [],
      reportable: true
    },
    'RF-00007617-PAR': {
      reference: 'RF-00007617-PAR',
      name: 'Propylenediamine',
      casNumber: '109-76-2',
      otherNames: [],
      reportable: true
    },
    'RF-00007618-PAR': {
      reference: 'RF-00007618-PAR',
      name: '3,5-Dichlorobenzoic acid',
      casNumber: '75248-87-2',
      otherNames: [],
      reportable: true
    },
    'RF-00007619-PAR': {
      reference: 'RF-00007619-PAR',
      name: 'Phosphate conjugate of 6-hydroxymethylpymetrozine',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007620-PAR': {
      reference: 'RF-00007620-PAR',
      name: '2-(4-Hydroxyanilino)-4,6-dimethylpyrimidine',
      casNumber: '81261-84-9',
      otherNames: [],
      reportable: true
    },
    'RF-00007621-PAR': {
      reference: 'RF-00007621-PAR',
      name: '2-Anilino-4,6-dimethylpyrimidine-5-ol',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007622-PAR': {
      reference: 'RF-00007622-PAR',
      name: "M800H11 (N'-[2-chloro-5-(2,6-dioxo-4-(trifluoromethyl)-3,6-dihydro-1(2H)-pyrimidinyl)-4-fluorobenzoyl]-N-isopropylsulfamide)",
      casNumber: '1246768-30-8',
      otherNames: [],
      reportable: true
    },
    'RF-00007623-PAR': {
      reference: 'RF-00007623-PAR',
      name: 'M800H35 (N-[4-chloro-2-fluoro-5-({[(isopropylamino) sulfonyl]amino} carbonyl)phenyl] urea)',
      casNumber: '1246768-31-9',
      otherNames: [],
      reportable: true
    },
    'RF-00007625-PAR': {
      reference: 'RF-00007625-PAR',
      name: '3-(Tetrahydro-pyran-4-yl)-glutaric acid (GP)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007626-PAR': {
      reference: 'RF-00007626-PAR',
      name: '3-Hydroxy-(tetrahydro-pyran-4-yl)-glutaric acid (5-OH-DP)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007627-PAR': {
      reference: 'RF-00007627-PAR',
      name: 'DDAC-C10',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007628-PAR': {
      reference: 'RF-00007628-PAR',
      name: 'Sum of metalaxyl (sum of isomers) and its metabolites containing the 2,6-dimethylaniline moiety, expressed as metalaxyl',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007629-PAR': {
      reference: 'RF-00007629-PAR',
      name: 'Thiabendazole (sum of thiabendazole and 5-hydroxythiabendazole, expressed as thiabendazole)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007630-PAR': {
      reference: 'RF-00007630-PAR',
      name: 'Thiabendazole (sum of thiabendazole, 5-hydroxythiabendazole and its sulfate conjugate, expressed as thiabendazole)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007631-PAR': {
      reference: 'RF-00007631-PAR',
      name: '5-Hydroxythiabendazole O-sulfate conjugate',
      casNumber: '962-28-7',
      otherNames: [],
      reportable: true
    },
    'RF-00007633-PAR': {
      reference: 'RF-00007633-PAR',
      name: '2-Phenylphenol (sum of 2-phenylphenol and its conjugates, expressed as 2-phenylphenol)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00007634-PAR': {
      reference: 'RF-00007634-PAR',
      name: '(3E) 3-decen-2-one',
      casNumber: '18402-84-1',
      otherNames: [
        '3-Decenone-2',
        'Heptylidene acetone',
        'Oenanthylidene acetone',
        'Enanthylidene acetone'
      ],
      reportable: true
    },
    'RF-00007693-PAR': {
      reference: 'RF-00007693-PAR',
      name: 'Terpinolene',
      casNumber: '586-62-9',
      otherNames: [],
      reportable: true
    },
    'RF-00007714-PAR': {
      reference: 'RF-00007714-PAR',
      name: 'Myrcenol',
      casNumber: '543-39-5',
      otherNames: [],
      reportable: true
    },
    'RF-00007749-PAR': {
      reference: 'RF-00007749-PAR',
      name: '1-Decanol',
      casNumber: '112-30-1',
      otherNames: [],
      reportable: true
    },
    'RF-00008038-PAR': {
      reference: 'RF-00008038-PAR',
      name: 'Ethanethiol',
      casNumber: '75-08-1',
      otherNames: [],
      reportable: true
    },
    'RF-00008056-PAR': {
      reference: 'RF-00008056-PAR',
      name: '1,3,5-Trioxane',
      casNumber: '110-88-3',
      otherNames: [],
      reportable: true
    },
    'RF-00008085-PAR': {
      reference: 'RF-00008085-PAR',
      name: 'sec-Butylamine',
      casNumber: '13952-84-6',
      otherNames: [],
      reportable: true
    },
    'RF-00008156-PAR': {
      reference: 'RF-00008156-PAR',
      name: 'Choline chloride',
      casNumber: '67-48-1',
      otherNames: [],
      reportable: true
    },
    'RF-00008184-PAR': {
      reference: 'RF-00008184-PAR',
      name: 'Glutaraldehyde',
      casNumber: '111-30-8',
      otherNames: [],
      reportable: true
    },
    'RF-00008325-PAR': {
      reference: 'RF-00008325-PAR',
      name: '4-Hydroxybenzoic acid',
      casNumber: '99-96-7',
      otherNames: [],
      reportable: true
    },
    'RF-00008405-PAR': {
      reference: 'RF-00008405-PAR',
      name: 'Ethyl hexanoate',
      casNumber: '123-66-0',
      otherNames: [],
      reportable: true
    },
    'RF-00008425-PAR': {
      reference: 'RF-00008425-PAR',
      name: 'Phthalide',
      casNumber: '87-41-2',
      otherNames: [],
      reportable: true
    },
    'RF-00008451-PAR': {
      reference: 'RF-00008451-PAR',
      name: 'p-Tolyl acetate',
      casNumber: '140-39-6',
      otherNames: [],
      reportable: true
    },
    'RF-00008596-PAR': {
      reference: 'RF-00008596-PAR',
      name: 'Calcium carbide',
      casNumber: '75-20-7',
      otherNames: [],
      reportable: true
    },
    'RF-00008597-PAR': {
      reference: 'RF-00008597-PAR',
      name: 'Ammonium acetate',
      casNumber: '631-61-8',
      otherNames: [],
      reportable: true
    },
    'RF-00008598-PAR': {
      reference: 'RF-00008598-PAR',
      name: 'Potassium hydrogen carbonate',
      casNumber: '298-14-6',
      otherNames: [],
      reportable: true
    },
    'RF-00008601-PAR': {
      reference: 'RF-00008601-PAR',
      name: 'Maltodextrin',
      casNumber: '9050-36-6',
      otherNames: [],
      reportable: true
    },
    'RF-00008854-PAR': {
      reference: 'RF-00008854-PAR',
      name: 'Valifenalate acid (IR5839)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00008893-PAR': {
      reference: 'RF-00008893-PAR',
      name: 'Z,Z,Z,Z-7,13,16,19-docosatetraen-1-yl isobutyrate',
      casNumber: '135459-81-3',
      otherNames: [],
      reportable: true
    },
    'RF-00008904-PAR': {
      reference: 'RF-00008904-PAR',
      name: 'Flutianil',
      casNumber: '958647-10-4',
      otherNames: [
        '(2Z)-2-[2-fluoro-5-(trifluoromethyl)phenyl]sulfanyl-2-[3-(2-methoxyphenyl)-1,3-thiazolidin-2-ylidene]acetonitrile'
      ],
      reportable: true
    },
    'RF-00008948-PAR': {
      reference: 'RF-00008948-PAR',
      name: 'Cyclaniliprole',
      casNumber: '1031756-98-5',
      otherNames: [],
      reportable: true
    },
    'RF-00008949-PAR': {
      reference: 'RF-00008949-PAR',
      name: 'Oxathiapiprolin',
      casNumber: '1003318-67-9',
      otherNames: [],
      reportable: true
    },
    'RF-00008987-PAR': {
      reference: 'RF-00008987-PAR',
      name: 'Laminarin',
      casNumber: '9008-22-4',
      otherNames: [],
      reportable: true
    },
    'RF-00009154-PAR': {
      reference: 'RF-00009154-PAR',
      name: 'AMPA-N-acetyl',
      casNumber: '57637-97-5',
      otherNames: [],
      reportable: true
    },
    'RF-00009174-PAR': {
      reference: 'RF-00009174-PAR',
      name: 'Sodium chloride',
      casNumber: '7647-14-5',
      otherNames: [],
      reportable: true
    },
    'RF-00009184-PAR': {
      reference: 'RF-00009184-PAR',
      name: 'Ethyl formate',
      casNumber: '109-94-4',
      otherNames: [],
      reportable: true
    },
    'RF-00009238-PAR': {
      reference: 'RF-00009238-PAR',
      name: '1-Methyl-3-trifluoromethyl-1H-pyrazole-4-carboxamide',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00009240-PAR': {
      reference: 'RF-00009240-PAR',
      name: 'Spinetoram-L',
      casNumber: '187166-15-0',
      otherNames: [],
      reportable: true
    },
    'RF-00009258-PAR': {
      reference: 'RF-00009258-PAR',
      name: 'Spirotetramat-ketohydroxy',
      casNumber: null,
      otherNames: [],
      reportable: false,
      lmrCanBeOptional: true
    },
    'RF-00009261-PAR': {
      reference: 'RF-00009261-PAR',
      name: 'Spirotetramat-monohydroxy',
      casNumber: null,
      otherNames: [],
      reportable: false,
      lmrCanBeOptional: true
    },
    'RF-00009274-PAR': {
      reference: 'RF-00009274-PAR',
      name: 'Rescalure',
      casNumber: '67601-06-3',
      otherNames: [],
      reportable: true
    },
    'RF-00009360-PAR': {
      reference: 'RF-00009360-PAR',
      name: 'Mefentrifluconazole',
      casNumber: '1417782-03-6',
      otherNames: [],
      reportable: true
    },
    'RF-00009395-PAR': {
      reference: 'RF-00009395-PAR',
      name: 'Tall oil crude',
      casNumber: '8002-26-4',
      otherNames: [],
      reportable: true
    },
    'RF-00009403-PAR': {
      reference: 'RF-00009403-PAR',
      name: 'White mineral oil (petroleum)',
      casNumber: '8042-47-5',
      otherNames: [
        'white mineral oils, paraffinic, derived from petroleum-based hydrocarbon feedstocks'
      ],
      reportable: true
    },
    'RF-00009486-PAR': {
      reference: 'RF-00009486-PAR',
      name: 'Pydiflumetofen',
      casNumber: '1228284-64-7',
      otherNames: [
        '3-(difluoromethyl)-N-methoxy-1-methyl-N-[(RS)-1-methyl-2-(2,4,6-trichlorophenyl)ethyl]-1H-pyrazole-4-carboxamide'
      ],
      reportable: true
    },
    'RF-00009487-PAR': {
      reference: 'RF-00009487-PAR',
      name: 'Tolpyralate',
      casNumber: '1101132-67-5',
      otherNames: [
        '(RS)-1-{1-ethyl-4-[4-mesyl-3-(2-methoxyethoxy)-o-toluoyl]-1H-pyrazol-5-yloxy}ethyl methyl carbonate'
      ],
      reportable: true
    },
    'RF-00009593-PAR': {
      reference: 'RF-00009593-PAR',
      name: 'Z-13-hexadecen-11-yn-1-yl acetate',
      casNumber: '78617-58-0',
      otherNames: [],
      reportable: true
    },
    'RF-00009781-PAR': {
      reference: 'RF-00009781-PAR',
      name: 'Terpenoid blend QRD 460',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00009800-PAR': {
      reference: 'RF-00009800-PAR',
      name: 'Reynoutria sachalinensis extract',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00009870-PAR': {
      reference: 'RF-00009870-PAR',
      name: 'Desmethyl chlorpyrifos-methyl',
      casNumber: '58997-13-0',
      otherNames: [],
      reportable: true
    },
    'RF-00009913-PAR': {
      reference: 'RF-00009913-PAR',
      name: 'Sodium tetraborate',
      casNumber: '1330-43-4',
      otherNames: [],
      reportable: true
    },
    'RF-0001-001-PPP': {
      reference: 'RF-0001-001-PPP',
      name: '1,1-dichloro-2,2-bis(4-ethylphenyl)ethane',
      casNumber: '72-56-0',
      otherNames: [],
      reportable: true
    },
    'RF-00010022-PAR': {
      reference: 'RF-00010022-PAR',
      name: 'Mercurous chloride',
      casNumber: '10112-91-1',
      otherNames: [],
      reportable: true
    },
    'RF-00010068-PAR': {
      reference: 'RF-00010068-PAR',
      name: 'Chlorine dioxide',
      casNumber: '10049-04-4',
      otherNames: [],
      reportable: true
    },
    'RF-00010077-PAR': {
      reference: 'RF-00010077-PAR',
      name: 'Gibberellin A4',
      casNumber: '468-44-0',
      otherNames: [],
      reportable: true
    },
    'RF-00010217-PAR': {
      reference: 'RF-00010217-PAR',
      name: 'Fenpicoxamid',
      casNumber: '517875-34-2',
      otherNames: [],
      reportable: true
    },
    'RF-00010219-PAR': {
      reference: 'RF-00010219-PAR',
      name: 'Nerolidol',
      casNumber: '7212-44-4',
      otherNames: [],
      reportable: true
    },
    'RF-00010235-PAR': {
      reference: 'RF-00010235-PAR',
      name: 'Ethylene',
      casNumber: '74-85-1',
      otherNames: [],
      reportable: true
    },
    'RF-00010250-PAR': {
      reference: 'RF-00010250-PAR',
      name: 'Citral',
      casNumber: '5392-40-5',
      otherNames: ['3,7-dimethyl-2,6-Octadienal'],
      reportable: true
    },
    'RF-00010264-PAR': {
      reference: 'RF-00010264-PAR',
      name: 'Napropamide-M',
      casNumber: '41643-35-0',
      otherNames: [],
      reportable: true
    },
    'RF-00010369-PAR': {
      reference: 'RF-00010369-PAR',
      name: 'Quartz sand',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00010375-PAR': {
      reference: 'RF-00010375-PAR',
      name: 'Spinetoram-J',
      casNumber: '187166-40-1',
      otherNames: [],
      reportable: true
    },
    'RF-00010380-PAR': {
      reference: 'RF-00010380-PAR',
      name: 'Limestone',
      casNumber: '1317-65-3',
      otherNames: [],
      reportable: true
    },
    'RF-00010416-PAR': {
      reference: 'RF-00010416-PAR',
      name: 'Florpyrauxifen-benzyl',
      casNumber: '1390661-72-9',
      otherNames: [],
      reportable: true
    },
    'RF-00010739-PAR': {
      reference: 'RF-00010739-PAR',
      name: 'Soybean oil',
      casNumber: '8001-22-7',
      otherNames: [
        'acids, C2-C24, aliphatic, linear, monocarboxylic from natural oils and fats, and their mono-, di- and triglycerol esters (branched fatty acids at naturally occuring levels are included); acids, C2-C24, aliphatic, linear, monocarboxylic, synthetic and thei'
      ],
      reportable: true
    },
    'RF-00010786-PAR': {
      reference: 'RF-00010786-PAR',
      name: 'Isoflucypram',
      casNumber: '1255734-28-1',
      otherNames: [
        'N-{[5-chloro-2-(propan-2-yl)phenyl]methyl}-N-cyclopropyl-3-(difluoromethyl)-5-fluoro-1-methyl-1H-pyrazole-4-carboxamide',
        'N-[[5-chloro-2-(1-methylethyl)phenyl]methyl]-N-cyclopropyl-3-(difluoromethyl)-5-fluoro-1-methyl-1H-pyrazole-4-carboxamide'
      ],
      reportable: true
    },
    'RF-00010939-PAR': {
      reference: 'RF-00010939-PAR',
      name: 'Oxymatrine',
      casNumber: '16837-52-8',
      otherNames: [],
      reportable: true
    },
    'RF-00011191-PAR': {
      reference: 'RF-00011191-PAR',
      name: 'Karanjin',
      casNumber: '521-88-0',
      otherNames: [],
      reportable: true
    },
    'RF-00011505-PAR': {
      reference: 'RF-00011505-PAR',
      name: 'Preparation of essential oil from oregano (Origanum vulgare L.), essential oil  from caraway seed (Carum carvi L.) and carvacrol, methyl salicylate and L-menthol (Biomin DC-C)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00011514-PAR': {
      reference: 'RF-00011514-PAR',
      name: 'Bicyclopyrone',
      casNumber: '352010-68-5',
      otherNames: [],
      reportable: true
    },
    'RF-00011515-PAR': {
      reference: 'RF-00011515-PAR',
      name: 'Bicyclopyrone (sum of bicyclopyrone and its structurally related metabolites determined as the sum of the common moieties (SYN503780) and (CSCD686480)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00011516-PAR': {
      reference: 'RF-00011516-PAR',
      name: '2-(2- methoxyethoxymethyl)-6-(trifluoromethyl) pyridine-3-carboxylic acid (SYN503780)',
      casNumber: '380355-55-5',
      otherNames: [],
      reportable: true
    },
    'RF-00011517-PAR': {
      reference: 'RF-00011517-PAR',
      name: '2-(2-hydroxyethoxymethyl)-6- (trifluoromethyl)pyridine-3-carboxylic acid (CSCD686480)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00011518-PAR': {
      reference: 'RF-00011518-PAR',
      name: 'bone oil',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00011519-PAR': {
      reference: 'RF-00011519-PAR',
      name: 'Triflumezopyrim',
      casNumber: '1263133-33-0',
      otherNames: [],
      reportable: true
    },
    'RF-00011521-PAR': {
      reference: 'RF-00011521-PAR',
      name: 'X12326349 expressed as fenpicoxamid',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00011559-PAR': {
      reference: 'RF-00011559-PAR',
      name: 'Carboxin (carboxin plus its metabolites carboxin sulfoxide and oxycarboxin (carboxin sulfone), expressed as carboxin)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00011560-PAR': {
      reference: 'RF-00011560-PAR',
      name: 'Ioxynil (sum of ioxynil and its salts, expressed as ioxynil)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00011590-PAR': {
      reference: 'RF-00011590-PAR',
      name: 'Carbon monoxide',
      casNumber: '630-08-0',
      otherNames: [],
      reportable: true
    },
    'RF-00011591-PAR': {
      reference: 'RF-00011591-PAR',
      name: 'Fluensulfone',
      casNumber: '318290-98-1',
      otherNames: [],
      reportable: true
    },
    'RF-00011592-PAR': {
      reference: 'RF-00011592-PAR',
      name: 'Indaziflam',
      casNumber: '950782-86-2',
      otherNames: [],
      reportable: true
    },
    'RF-00011610-PAR': {
      reference: 'RF-00011610-PAR',
      name: 'Lavandulyl senecioate',
      casNumber: '23960-07-8',
      otherNames: [
        '(RS)-5-methyl-2-(prop-1-en-2-yl)hex-4-en-1-yl 3-methylbut-2-enoate'
      ],
      reportable: true
    },
    'RF-00011881-PAR': {
      reference: 'RF-00011881-PAR',
      name: 'Flurochloridone (sum of cis- and trans- isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00011882-PAR': {
      reference: 'RF-00011882-PAR',
      name: 'Quizalofop (sum of quizalofop, its salts, its esters (including propaquizafop) and its conjugates, expressed as quizalofop (any ratio of constituent isomers))',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00011965-PAR': {
      reference: 'RF-00011965-PAR',
      name: 'Emamectin benzoate B1b',
      casNumber: '138511-98-5',
      otherNames: [],
      reportable: true
    },
    'RF-00011995-PAR': {
      reference: 'RF-00011995-PAR',
      name: '8-Methyl-2-decanol propanoate',
      casNumber: '81931-28-4',
      otherNames: [],
      reportable: true
    },
    'RF-00011996-PAR': {
      reference: 'RF-00011996-PAR',
      name: 'Afidopyropen',
      casNumber: '915972-17-7',
      otherNames: [],
      reportable: true
    },
    'RF-00011997-PAR': {
      reference: 'RF-00011997-PAR',
      name: 'Bacillus paralicheniformis FMCH001',
      casNumber: null,
      otherNames: ['Bacillus licheniformis FMCH001'],
      reportable: true
    },
    'RF-00011998-PAR': {
      reference: 'RF-00011998-PAR',
      name: 'Sum of imazalil and metabolite FK-772 (any ratio of constituent isomers), expressed as imazalil',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00011999-PAR': {
      reference: 'RF-00011999-PAR',
      name: 'Bacillus subtilis FMCH002',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012000-PAR': {
      reference: 'RF-00012000-PAR',
      name: 'Bacillus subtilis IAB/BS03',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012001-PAR': {
      reference: 'RF-00012001-PAR',
      name: 'Bacillus subtilis RTI477',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012002-PAR': {
      reference: 'RF-00012002-PAR',
      name: 'Bacillus thuringiensis',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012003-PAR': {
      reference: 'RF-00012003-PAR',
      name: 'Bacillus thuringiensis ssp. Aizawai',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012004-PAR': {
      reference: 'RF-00012004-PAR',
      name: 'Bacillus thuringiensis ssp. Aizawai ABTS-1857',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012005-PAR': {
      reference: 'RF-00012005-PAR',
      name: 'Bacillus thuringiensis ssp. Aizawai GC-91',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012006-PAR': {
      reference: 'RF-00012006-PAR',
      name: 'Bacillus thuringiensis ssp. Aizawai ABTS-1857, GC-91',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012007-PAR': {
      reference: 'RF-00012007-PAR',
      name: 'Bacillus thuringiensis ssp. Kurstaki',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012008-PAR': {
      reference: 'RF-00012008-PAR',
      name: 'Bacillus thuringiensis ssp. Kurstaki ABTS 351',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012009-PAR': {
      reference: 'RF-00012009-PAR',
      name: 'Bacillus thuringiensis ssp. Kurstaki EG 2348',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012010-PAR': {
      reference: 'RF-00012010-PAR',
      name: 'Bacillus thuringiensis ssp. Kurstaki PB 54',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012011-PAR': {
      reference: 'RF-00012011-PAR',
      name: 'Bacillus thuringiensis ssp. Kurstaki SA 11',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012012-PAR': {
      reference: 'RF-00012012-PAR',
      name: 'Bacillus thuringiensis ssp. Kurstaki SA 12',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012013-PAR': {
      reference: 'RF-00012013-PAR',
      name: 'Bacillus velezensis',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012014-PAR': {
      reference: 'RF-00012014-PAR',
      name: 'Bacillus velezensis RTI301',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012015-PAR': {
      reference: 'RF-00012015-PAR',
      name: 'Allium cepa extract',
      casNumber: null,
      otherNames: ['Allium cepa L. bulb extract'],
      reportable: true
    },
    'RF-00012016-PAR': {
      reference: 'RF-00012016-PAR',
      name: 'BAS 684 H',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012017-PAR': {
      reference: 'RF-00012017-PAR',
      name: 'Bixlozone',
      casNumber: '81777-95-9',
      otherNames: [],
      reportable: true
    },
    'RF-00012018-PAR': {
      reference: 'RF-00012018-PAR',
      name: 'Cow Milk',
      casNumber: '8049-98-7',
      otherNames: [],
      reportable: true
    },
    'RF-00012019-PAR': {
      reference: 'RF-00012019-PAR',
      name: 'Fluindapyr',
      casNumber: '1383809-87-7',
      otherNames: [],
      reportable: true
    },
    'RF-00012020-PAR': {
      reference: 'RF-00012020-PAR',
      name: 'Inpyrfluxam (S-2399)',
      casNumber: '1352994-67-2',
      otherNames: [],
      reportable: true
    },
    'RF-00012021-PAR': {
      reference: 'RF-00012021-PAR',
      name: 'Ipflufenoquin',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012022-PAR': {
      reference: 'RF-00012022-PAR',
      name: 'Pentapotassium bis(peroxymonosulphate) bis(sulphate)',
      casNumber: '70693-62-8',
      otherNames: [],
      reportable: true
    },
    'RF-00012023-PAR': {
      reference: 'RF-00012023-PAR',
      name: 'Propolis (Water soluble extract)',
      casNumber: '85665-41-4',
      otherNames: ['Propolis extract'],
      reportable: true
    },
    'RF-00012024-PAR': {
      reference: 'RF-00012024-PAR',
      name: 'Willow bark and stem extract',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012025-PAR': {
      reference: 'RF-00012025-PAR',
      name: 'Monomethylarsonic acid',
      casNumber: '124-58-3',
      otherNames: [],
      reportable: true
    },
    'RF-00012026-PAR': {
      reference: 'RF-00012026-PAR',
      name: 'Akanthomyces muscarius Ve6',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012027-PAR': {
      reference: 'RF-00012027-PAR',
      name: 'Beauveria bassiana GHA',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012028-PAR': {
      reference: 'RF-00012028-PAR',
      name: 'Grape cane tannins',
      casNumber: '84929-27-1',
      otherNames: [],
      reportable: true
    },
    'RF-00012029-PAR': {
      reference: 'RF-00012029-PAR',
      name: 'Swinglea glutinosa extract',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012032-PAR': {
      reference: 'RF-00012032-PAR',
      name: 'Prochloraz (sum of prochloraz, BTS 44595 (M201-04) and BTS 44596 (M201-03), expressed as prochloraz)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012033-PAR': {
      reference: 'RF-00012033-PAR',
      name: 'Isotianil',
      casNumber: '224049-04-1',
      otherNames: [],
      reportable: true
    },
    'RF-00012034-PAR': {
      reference: 'RF-00012034-PAR',
      name: 'Orysastrobin',
      casNumber: '248593-16-0',
      otherNames: [],
      reportable: true
    },
    'RF-00012035-PAR': {
      reference: 'RF-00012035-PAR',
      name: 'Oxpoconazole',
      casNumber: '134074-64-9',
      otherNames: [],
      reportable: true
    },
    'RF-00012036-PAR': {
      reference: 'RF-00012036-PAR',
      name: 'Pefurazoate',
      casNumber: '101903-30-4',
      otherNames: [],
      reportable: true
    },
    'RF-00012037-PAR': {
      reference: 'RF-00012037-PAR',
      name: 'Tiadinil',
      casNumber: '223580-51-6',
      otherNames: [],
      reportable: true
    },
    'RF-00012042-PAR': {
      reference: 'RF-00012042-PAR',
      name: 'FK-772',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012043-PAR': {
      reference: 'RF-00012043-PAR',
      name: 'Paclobutrazol (sum of constituent isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012044-PAR': {
      reference: 'RF-00012044-PAR',
      name: 'Carbetamide (sum of carbetamide and its S isomer)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012045-PAR': {
      reference: 'RF-00012045-PAR',
      name: 'Fenbuconazole (sum of constituent enantiomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012046-PAR': {
      reference: 'RF-00012046-PAR',
      name: 'Imazalil (any ratio of constituent isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012047-PAR': {
      reference: 'RF-00012047-PAR',
      name: 'Mandipropamid (any ratio of constituent isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012291-PAR': {
      reference: 'RF-00012291-PAR',
      name: 'Sum of cyflufenamid (Z-isomer), its E-isomer and metabolite 149-F1, expressed as cyflufenamid',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012292-PAR': {
      reference: 'RF-00012292-PAR',
      name: 'Cyflufenamid metabolite 149-F1',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012293-PAR': {
      reference: 'RF-00012293-PAR',
      name: 'Tembotrione (Sum of parent tembotrione (AE 0172747) and its metabolite M5 (4,6-dihydroxy tembotrione), expressed as tembotrione)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012298-PAR': {
      reference: 'RF-00012298-PAR',
      name: 'EDTA',
      casNumber: '139-33-3',
      otherNames: [],
      reportable: true
    },
    'RF-00012328-PAR': {
      reference: 'RF-00012328-PAR',
      name: 'Mevinphos',
      casNumber: '7786-34-7',
      otherNames: [],
      reportable: false
    },
    'RF-00012333-PAR': {
      reference: 'RF-00012333-PAR',
      name: 'Spinosad',
      casNumber: '168316-95-8',
      otherNames: [],
      reportable: false
    },
    'RF-00012362-PAR': {
      reference: 'RF-00012362-PAR',
      name: 'Ethaboxam',
      casNumber: '162650-77-3',
      otherNames: [],
      reportable: true
    },
    'RF-00012363-PAR': {
      reference: 'RF-00012363-PAR',
      name: 'Pyriminostrobin',
      casNumber: '1257598-43-8',
      otherNames: [],
      reportable: true
    },
    'RF-00012364-PAR': {
      reference: 'RF-00012364-PAR',
      name: 'Tioxazafen',
      casNumber: '330459-31-9',
      otherNames: [],
      reportable: true
    },
    'RF-00012370-PAR': {
      reference: 'RF-00012370-PAR',
      name: 'Denatonium benzoate (sum of denatonium and its salts, expressed as denatonium benzoate)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012386-PAR': {
      reference: 'RF-00012386-PAR',
      name: '2,5-dichlorobenzoic acid methylester (sum of 2,5-dichlorobenzoic acid and its ester expressed as 2,5-dichlorobenzoic acid methylester)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012387-PAR': {
      reference: 'RF-00012387-PAR',
      name: '2,5-Dichlorobenzoic acid',
      casNumber: '50-79-3',
      otherNames: [],
      reportable: true
    },
    'RF-00012800-PAR': {
      reference: 'RF-00012800-PAR',
      name: 'Fluvalinate (sum of isomers) resulting from the use of tau-fluvalinate',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012801-PAR': {
      reference: 'RF-00012801-PAR',
      name: 'Myclobutanil (sum of constituent isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012802-PAR': {
      reference: 'RF-00012802-PAR',
      name: 'Napropamide (sum of isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012803-PAR': {
      reference: 'RF-00012803-PAR',
      name: 'Pencycuron (sum of pencycuron and pencycuron-PB-amine, expressed as pencycuron)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012804-PAR': {
      reference: 'RF-00012804-PAR',
      name: 'pencycuron-PB-amine',
      casNumber: '66063-15-8',
      otherNames: [],
      reportable: true
    },
    'RF-00012866-PAR': {
      reference: 'RF-00012866-PAR',
      name: 'Bacillus pumilus QST 2808',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012867-PAR': {
      reference: 'RF-00012867-PAR',
      name: 'Metschnikowia fructicola NRRL Y-27328',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012868-PAR': {
      reference: 'RF-00012868-PAR',
      name: 'Pseudomonas sp. strain DSMZ 13134',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012869-PAR': {
      reference: 'RF-00012869-PAR',
      name: 'Sedaxane (sum of isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012870-PAR': {
      reference: 'RF-00012870-PAR',
      name: 'Penflufen (sum of isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012871-PAR': {
      reference: 'RF-00012871-PAR',
      name: 'Spirotetramat-enol expressed as spirotetramat',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012873-PAR': {
      reference: 'RF-00012873-PAR',
      name: 'Bacillus amyloliquefaciens AH2',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012874-PAR': {
      reference: 'RF-00012874-PAR',
      name: 'Carfentrazone-ethyl (sum of carfentrazone-ethyl and carfentrazone, expressed as carfentrazone-ethyl)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012875-PAR': {
      reference: 'RF-00012875-PAR',
      name: 'Sum of diclofop-methyl, diclofop acid and its salts, expressed as diclofop-methyl (sum of isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012896-PAR': {
      reference: 'RF-00012896-PAR',
      name: 'Dichloroctylisothiazolinon',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00012898-PAR': {
      reference: 'RF-00012898-PAR',
      name: 'Sum of Proquinazid and metabolite (3-[(6-iodo-4-oxo-3-propyl-3,4-dihydroquinazolin-2-yl)oxy]propanoic acid (IN-MU210)) expressed as proquinazid',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00013000-PAR': {
      reference: 'RF-00013000-PAR',
      name: 'Sum of terbuthylazine and desethyl-terbuthylazine, expressed as terbuthylazine',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00013001-PAR': {
      reference: 'RF-00013001-PAR',
      name: 'Free and conjugated forms of alpha-(3-hydroxybutyl) - alpha - (4-chloro-phenyl) - 1H - 1,2,4 - triazole -1-propanenitrile (RH9090) expressed as myclobutanil',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00013155-PAR': {
      reference: 'RF-00013155-PAR',
      name: 'Metyltetraprole',
      casNumber: '1472649-01-6',
      otherNames: [
        '1-[2-[[1-(4-chlorophenyl)pyrazol-3-yl]oxymethyl]-3-methylphenyl]-4-methyltetrazol-5-one'
      ],
      reportable: false
    },
    'RF-00013218-PAR': {
      reference: 'RF-00013218-PAR',
      name: 'Lemon, ext.',
      casNumber: '84929-31-7',
      otherNames: [],
      reportable: true
    },
    'RF-00013247-PAR': {
      reference: 'RF-00013247-PAR',
      name: 'Spinetoram (sum of spinetoram-J and spinetoram-L)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00013315-PAR': {
      reference: 'RF-00013315-PAR',
      name: 'Cycloheximide',
      casNumber: '66-81-9',
      otherNames: [],
      reportable: true
    },
    'RF-00013414-PAR': {
      reference: 'RF-00013414-PAR',
      name: 'Fluazaindolizine',
      casNumber: '1254304-22-7',
      otherNames: [],
      reportable: true
    },
    'RF-00013459-PAR': {
      reference: 'RF-00013459-PAR',
      name: 'Methylisothiocyanate (resulting from the use of dazomet or metam)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00013463-PAR': {
      reference: 'RF-00013463-PAR',
      name: 'Tefluthrin (tefluthrin including other mixtures of constituent isomers (sum of isomers))',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00013471-PAR': {
      reference: 'RF-00013471-PAR',
      name: 'Aminopyralid (sum of aminopyralid, its salts and its conjugates, expressed as aminopyralid)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00013472-PAR': {
      reference: 'RF-00013472-PAR',
      name: 'Hexythiazox (any ratio of constituent isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00013598-PAR': {
      reference: 'RF-00013598-PAR',
      name: 'Chlorothalonil metabolite (R471811)',
      casNumber: '1418094-02-95',
      otherNames: [],
      reportable: true
    },
    'RF-00013599-PAR': {
      reference: 'RF-00013599-PAR',
      name: 'Pirimiphos-methyl metabolite (R36341)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00013608-PAR': {
      reference: 'RF-00013608-PAR',
      name: 'Tetraconazole (sum of constituent isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00013630-PAR': {
      reference: 'RF-00013630-PAR',
      name: 'Novaluron (sum of constituent isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00013741-PAR': {
      reference: 'RF-00013741-PAR',
      name: 'Yucca schidigera, ext.',
      casNumber: '223749-05-1',
      otherNames: [],
      reportable: true
    },
    'RF-00014144-PAR': {
      reference: 'RF-00014144-PAR',
      name: 'Aminocyclopyrachlor',
      casNumber: '858956-08-8',
      otherNames: [],
      reportable: true
    },
    'RF-00014206-PAR': {
      reference: 'RF-00014206-PAR',
      name: 'Sum of 1,4-dimethylnaphthalene and its metabolite M23 free and conjugated, expressed as 1,4-dimethylnaphthalene',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00014207-PAR': {
      reference: 'RF-00014207-PAR',
      name: 'Quinmerac (sum of quinmerac and its metabolites BH 518-2 and BH 518-4 expressed as quinmerac)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00014208-PAR': {
      reference: 'RF-00014208-PAR',
      name: 'Sum of M4 and M6 (both free and conjugated), expressed as pinoxaden',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00014209-PAR': {
      reference: 'RF-00014209-PAR',
      name: 'M4 (free and conjugated), expressed as pinoxaden',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00014210-PAR': {
      reference: 'RF-00014210-PAR',
      name: 'Pinoxaden metabolite (SYN 505164) (DISMISSED)',
      casNumber: null,
      otherNames: [],
      reportable: false
    },
    'RF-00014211-PAR': {
      reference: 'RF-00014211-PAR',
      name: 'Valifenalate and valifenalate acid (IR5839)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00014212-PAR': {
      reference: 'RF-00014212-PAR',
      name: 'Emamectin B1a and its salts, expressed as emamectin B1a (free base)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00014213-PAR': {
      reference: 'RF-00014213-PAR',
      name: 'Pyrifluquinazon',
      casNumber: '337458-27-2',
      otherNames: [],
      reportable: true
    },
    'RF-00014255-PAR': {
      reference: 'RF-00014255-PAR',
      name: 'Broflanilide',
      casNumber: '1207727-04-5',
      otherNames: [],
      reportable: true
    },
    'RF-00014256-PAR': {
      reference: 'RF-00014256-PAR',
      name: 'Cycloxydim including degradation and reaction products which can be determined as 3-(3-thianyl)glutaric acid S-dioxide (BH 517-TGSO2) and/or 3-hydroxy-3-(3-thianyl)glutaric acid S-dioxide (BH 517-5-OH-TGSO2) or derivatives thereof, calculated in total as',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00014257-PAR': {
      reference: 'RF-00014257-PAR',
      name: 'Cyflumetofen (sum of isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00014293-PAR': {
      reference: 'RF-00014293-PAR',
      name: 'Flufenacet oxalate (M1)',
      casNumber: '201668-31-7',
      otherNames: ['FOE oxalate (M01, BCS-AB16305)'],
      reportable: true
    },
    'RF-00014294-PAR': {
      reference: 'RF-00014294-PAR',
      name: 'Flufenacet sulfonic acid (M2)',
      casNumber: '201668-32-8',
      otherNames: ['FOE sulfonic acid (M02, WAK6222)'],
      reportable: true
    },
    'RF-00014452-PAR': {
      reference: 'RF-00014452-PAR',
      name: 'Flufenacet thioglycolate sulfoxide (M4)',
      casNumber: '201668-33-9',
      otherNames: [],
      reportable: true
    },
    'RF-00014532-PAR': {
      reference: 'RF-00014532-PAR',
      name: 'Sum of metobromuron and 4-bromophenylurea, expressed as metobromuron',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00014535-PAR': {
      reference: 'RF-00014535-PAR',
      name: 'Purpureocillium lilacinum strain PL11',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00014539-PAR': {
      reference: 'RF-00014539-PAR',
      name: 'RPA 104615',
      casNumber: '209248-72-6',
      otherNames: [
        '5-amino-3-cyano-1-[2,6-dichloro-4-(trifluoromethyl)phenyl]-1H-pyrazole-4-sulfonic acid'
      ],
      reportable: true
    },
    'RF-00014542-PAR': {
      reference: 'RF-00014542-PAR',
      name: 'Ethylene Chlorobromide',
      casNumber: '107-04-0',
      otherNames: [],
      reportable: true
    },
    'RF-00014543-PAR': {
      reference: 'RF-00014543-PAR',
      name: 'p-Chloronitrobenzene',
      casNumber: '100-00-5',
      otherNames: ['p-Nitrochlorobenzene'],
      reportable: true
    },
    'RF-00014544-PAR': {
      reference: 'RF-00014544-PAR',
      name: 'Tetrachlorethane',
      casNumber: '79-34-5',
      otherNames: [],
      reportable: true
    },
    'RF-00014551-PAR': {
      reference: 'RF-00014551-PAR',
      name: 'Iprodione metabolite',
      casNumber: '27387-87-7',
      otherNames: [],
      reportable: true
    },
    'RF-00014552-PAR': {
      reference: 'RF-00014552-PAR',
      name: 'Imiprothrin',
      casNumber: '72963-72-5',
      otherNames: [],
      reportable: true
    },
    'RF-00015306-PAR': {
      reference: 'RF-00015306-PAR',
      name: 'Potassium permanganate',
      casNumber: '7722-64-7',
      otherNames: [],
      reportable: true
    },
    'RF-00015695-PAR': {
      reference: 'RF-00015695-PAR',
      name: 'Sum of metalaxyl (sum of enantiomers) and metabolites (free + conjugated) M3 (N- (2,6-dimethylphenyl)-N-(hydroxyacetyl)alanine methyl ester) and M8 (N-(2-hydroxymethyl-6- methylphenyl)-N-(methoxyacetyl)alanine methyl ester (sum of enantiomers), expressed as metalaxyl',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-00015696-PAR': {
      reference: 'RF-00015696-PAR',
      name: 'Metalaxyl Metabolite M3',
      casNumber: '66637-79-4',
      otherNames: [],
      reportable: true
    },
    'RF-00015697-PAR': {
      reference: 'RF-00015697-PAR',
      name: 'Metalaxyl Metabolite M8',
      casNumber: '85933-49-9',
      otherNames: [],
      reportable: true
    },
    'RF-0002-001-PPP': {
      reference: 'RF-0002-001-PPP',
      name: '1,2-dibromoethane (ethylene dibromide)',
      casNumber: '106-93-4',
      otherNames: [],
      reportable: true
    },
    'RF-0003-001-PPP': {
      reference: 'RF-0003-001-PPP',
      name: '1,2-dichloroethane (ethylene dichloride)',
      casNumber: '107-06-2',
      otherNames: [],
      reportable: true
    },
    'RF-0004-001-PPP': {
      reference: 'RF-0004-001-PPP',
      name: '1,3-dichloropropene',
      casNumber: '542-75-6',
      otherNames: [],
      reportable: true
    },
    'RF-0005-001-PPP': {
      reference: 'RF-0005-001-PPP',
      name: '1-methylcyclopropene',
      casNumber: '3100-04-7',
      otherNames: ['1-methylcycloprop-1-ene', '1-MCP'],
      reportable: true
    },
    'RF-0006-001-PPP': {
      reference: 'RF-0006-001-PPP',
      name: '1-naphthylacetamide',
      casNumber: '86-86-2',
      otherNames: [],
      reportable: true
    },
    'RF-0007-001-PPP': {
      reference: 'RF-0007-001-PPP',
      name: '1-naphthylacetic acid',
      casNumber: '86-87-3',
      otherNames: [],
      reportable: true
    },
    'RF-0008-001-PPP': {
      reference: 'RF-0008-001-PPP',
      name: '2,4-DB (sum of 2,4-DB, its salts, its esters and its conjugates, expressed as 2,4-DB)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0009-001-PPP': {
      reference: 'RF-0009-001-PPP',
      name: '2,4,5-T',
      casNumber: '93-76-5',
      otherNames: [],
      reportable: true
    },
    'RF-0010-001-PPP': {
      reference: 'RF-0010-001-PPP',
      name: '2,4-D (sum of 2,4-D, its salts, its esters and its conjugates, expressed as 2,4-D)',
      casNumber: null,
      otherNames: ['2,4-D (sum of 2,4-D and its esters expressed as 2,4-D)'],
      reportable: true
    },
    'RF-0010-002-PPP': {
      reference: 'RF-0010-002-PPP',
      name: '2,4-D-Methylester',
      casNumber: '1928-38-7',
      otherNames: [],
      reportable: true
    },
    'RF-0010-003-PPP': {
      reference: 'RF-0010-003-PPP',
      name: '2,4-D',
      casNumber: '94-75-7',
      otherNames: [],
      reportable: true
    },
    'RF-0011-002-PPP': {
      reference: 'RF-0011-002-PPP',
      name: 'Avermectin B1a, delta-8,9 isomer',
      casNumber: '113665-89-7',
      otherNames: [],
      reportable: true
    },
    'RF-0011-003-PPP': {
      reference: 'RF-0011-003-PPP',
      name: 'Avermectin B1a',
      casNumber: '65195-55-3',
      otherNames: ['5-O-demethyl-avermectin A1a'],
      reportable: true
    },
    'RF-0011-004-PPP': {
      reference: 'RF-0011-004-PPP',
      name: 'Avermectin B1b',
      casNumber: '65195-56-4',
      otherNames: [
        '5-O-demethyl-25-de(1-methylpropyl)-25-(1-methylethyl)-avermectin A1a'
      ],
      reportable: true
    },
    'RF-0012-001-PPP': {
      reference: 'RF-0012-001-PPP',
      name: 'Acephate',
      casNumber: '30560-19-1',
      otherNames: [],
      reportable: true
    },
    'RF-0013-001-PPP': {
      reference: 'RF-0013-001-PPP',
      name: 'Acequinocyl',
      casNumber: '57960-19-7',
      otherNames: [],
      reportable: true
    },
    'RF-0014-001-PPP': {
      reference: 'RF-0014-001-PPP',
      name: 'Acetamiprid',
      casNumber: '135410-20-7',
      otherNames: [],
      reportable: true
    },
    'RF-0015-001-PPP': {
      reference: 'RF-0015-001-PPP',
      name: 'Acetochlor',
      casNumber: '34256-82-1',
      otherNames: [],
      reportable: true
    },
    'RF-0016-002-PPP': {
      reference: 'RF-0016-002-PPP',
      name: 'Acibenzolar-S-methyl',
      casNumber: '135158-54-2',
      otherNames: [],
      reportable: true
    },
    'RF-0016-003-PPP': {
      reference: 'RF-0016-003-PPP',
      name: 'Acibenzolar acid (CGA 210007)',
      casNumber: '126448-41-7',
      otherNames: [],
      reportable: true
    },
    'RF-0017-001-PPP': {
      reference: 'RF-0017-001-PPP',
      name: 'Aclonifen',
      casNumber: '74070-46-5',
      otherNames: [],
      reportable: true
    },
    'RF-0018-001-PPP': {
      reference: 'RF-0018-001-PPP',
      name: 'Acrinathrin',
      casNumber: '101007-06-1',
      otherNames: [],
      reportable: true
    },
    'RF-0019-001-PPP': {
      reference: 'RF-0019-001-PPP',
      name: 'Alachlor',
      casNumber: '15972-60-8',
      otherNames: [],
      reportable: true
    },
    'RF-0020-001-PPP': {
      reference: 'RF-0020-001-PPP',
      name: 'Aldicarb (sum of Aldicarb, its sulfoxide and its sulfone, expressed as Aldicarb)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0020-002-PPP': {
      reference: 'RF-0020-002-PPP',
      name: 'Aldicarb',
      casNumber: '116-06-3',
      otherNames: [],
      reportable: true
    },
    'RF-0020-003-PPP': {
      reference: 'RF-0020-003-PPP',
      name: 'Aldicarb-Sulfoxide',
      casNumber: '1646-87-3',
      otherNames: [],
      reportable: true
    },
    'RF-0020-004-PPP': {
      reference: 'RF-0020-004-PPP',
      name: 'Aldicarb-Sulfone',
      casNumber: '1646-88-4',
      otherNames: [],
      reportable: true
    },
    'RF-0021-001-PPP': {
      reference: 'RF-0021-001-PPP',
      name: 'Aldrin and Dieldrin (Aldrin and dieldrin combined expressed as dieldrin)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0021-002-PPP': {
      reference: 'RF-0021-002-PPP',
      name: 'Aldrin',
      casNumber: '309-00-2',
      otherNames: [],
      reportable: true
    },
    'RF-0021-003-PPP': {
      reference: 'RF-0021-003-PPP',
      name: 'Dieldrin',
      casNumber: '60-57-1',
      otherNames: [],
      reportable: true
    },
    'RF-0022-001-PPP': {
      reference: 'RF-0022-001-PPP',
      name: 'Amidosulfuron',
      casNumber: '120923-37-7',
      otherNames: [
        '1-(4,6-dimethoxypyrimidin-2-yl)-3-(N-methyl-N-methylsulfonylaminosulfonyl)urea'
      ],
      reportable: true
    },
    'RF-0023-001-PPP': {
      reference: 'RF-0023-001-PPP',
      name: 'Aminopyralid',
      casNumber: '150114-71-9',
      otherNames: [],
      reportable: true
    },
    'RF-0024-001-PPP': {
      reference: 'RF-0024-001-PPP',
      name: 'Amitraz (amitraz including the metabolites containing the 2,4 -dimethylaniline moiety expressed as amitraz)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0024-002-PPP': {
      reference: 'RF-0024-002-PPP',
      name: 'Amitraz',
      casNumber: '33089-61-1',
      otherNames: [],
      reportable: true
    },
    'RF-0024-003-PPP': {
      reference: 'RF-0024-003-PPP',
      name: 'Dimethylphenylformamide, 2,4-',
      casNumber: '60397-77-5',
      otherNames: [],
      reportable: true
    },
    'RF-0024-004-PPP': {
      reference: 'RF-0024-004-PPP',
      name: 'Dimethylphenyl-N-methylformamidine, N-2,4-',
      casNumber: '33089-74-6',
      otherNames: [],
      reportable: true
    },
    'RF-0025-001-PPP': {
      reference: 'RF-0025-001-PPP',
      name: 'Amitrole',
      casNumber: '61-82-5',
      otherNames: [],
      reportable: true
    },
    'RF-0026-001-PPP': {
      reference: 'RF-0026-001-PPP',
      name: 'Anilazine',
      casNumber: '101-05-3',
      otherNames: [],
      reportable: true
    },
    'RF-0027-001-PPP': {
      reference: 'RF-0027-001-PPP',
      name: 'Aramite',
      casNumber: '140-57-8',
      otherNames: [],
      reportable: true
    },
    'RF-0028-001-PPP': {
      reference: 'RF-0028-001-PPP',
      name: 'Asulam',
      casNumber: '3337-71-1',
      otherNames: [],
      reportable: true
    },
    'RF-0029-001-PPP': {
      reference: 'RF-0029-001-PPP',
      name: 'Atrazine',
      casNumber: '1912-24-9',
      otherNames: [],
      reportable: true
    },
    'RF-0030-001-PPP': {
      reference: 'RF-0030-001-PPP',
      name: 'Azadirachtin',
      casNumber: '11141-17-6',
      otherNames: ['Azadirachtin A'],
      reportable: true
    },
    'RF-0031-001-PPP': {
      reference: 'RF-0031-001-PPP',
      name: 'Azimsulfuron',
      casNumber: '120162-55-2',
      otherNames: [],
      reportable: true
    },
    'RF-0032-001-PPP': {
      reference: 'RF-0032-001-PPP',
      name: 'Azinphos-ethyl',
      casNumber: '2642-71-9',
      otherNames: [],
      reportable: true
    },
    'RF-0033-001-PPP': {
      reference: 'RF-0033-001-PPP',
      name: 'Azinphos-methyl',
      casNumber: '86-50-0',
      otherNames: [],
      reportable: true
    },
    'RF-0034-001-PPP': {
      reference: 'RF-0034-001-PPP',
      name: 'Azocyclotin and Cyhexatin (sum of azocyclotin and cyhexatin expressed as cyhexatin)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0034-002-PPP': {
      reference: 'RF-0034-002-PPP',
      name: 'Cyhexatin',
      casNumber: '13121-70-5',
      otherNames: [],
      reportable: true
    },
    'RF-0034-003-PPP': {
      reference: 'RF-0034-003-PPP',
      name: 'Azocyclotin',
      casNumber: '41083-11-8',
      otherNames: [],
      reportable: true
    },
    'RF-0035-001-PPP': {
      reference: 'RF-0035-001-PPP',
      name: 'Azoxystrobin',
      casNumber: '131860-33-8',
      otherNames: [],
      reportable: true
    },
    'RF-0036-001-PPP': {
      reference: 'RF-0036-001-PPP',
      name: 'Barban',
      casNumber: '101-27-9',
      otherNames: [],
      reportable: true
    },
    'RF-0037-001-PPP': {
      reference: 'RF-0037-001-PPP',
      name: 'Beflubutamid',
      casNumber: '113614-08-7',
      otherNames: [],
      reportable: true
    },
    'RF-0038-001-PPP': {
      reference: 'RF-0038-001-PPP',
      name: 'Benalaxyl including other mixtures of constituent isomers including benalaxyl-M (sum of isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0039-001-PPP': {
      reference: 'RF-0039-001-PPP',
      name: 'Benfluralin',
      casNumber: '1861-40-1',
      otherNames: [
        'N-butyl-N-ethyl-α,α,α-trifluoro-2,6-dinitro-p-toluidine',
        'N-butyl-N-ethyl-2,6-dinitro-4-(trifluoromethyl)benzenamine'
      ],
      reportable: true
    },
    'RF-0040-001-PPP': {
      reference: 'RF-0040-001-PPP',
      name: 'Benfuracarb',
      casNumber: '82560-54-1',
      otherNames: [],
      reportable: true
    },
    'RF-0041-001-PPP': {
      reference: 'RF-0041-001-PPP',
      name: 'Carbendazim and benomyl (sum of benomyl and carbendazim expressed as carbendazim)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0041-002-PPP': {
      reference: 'RF-0041-002-PPP',
      name: 'Carbendazim',
      casNumber: '10605-21-7',
      otherNames: [],
      reportable: true
    },
    'RF-0041-003-PPP': {
      reference: 'RF-0041-003-PPP',
      name: 'Benomyl',
      casNumber: '17804-35-2',
      otherNames: [],
      reportable: true
    },
    'RF-0042-001-PPP': {
      reference: 'RF-0042-001-PPP',
      name: 'Bentazone (Sum of bentazone, its salts and 6-hydroxy (free and conjugated) and 8-hydroxy bentazone (free and conjugated), expressed as bentazone)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0042-002-PPP': {
      reference: 'RF-0042-002-PPP',
      name: 'Bentazone',
      casNumber: '25057-89-0',
      otherNames: [],
      reportable: true
    },
    'RF-0042-003-PPP': {
      reference: 'RF-0042-003-PPP',
      name: 'Bentazone-8-hydroxy',
      casNumber: '60374-43-8',
      otherNames: ['8-hydroxy-bentazone'],
      reportable: true
    },
    'RF-0042-004-PPP': {
      reference: 'RF-0042-004-PPP',
      name: 'Bentazone-6-hydroxy',
      casNumber: '60374-42-7',
      otherNames: [],
      reportable: true
    },
    'RF-0044-001-PPP': {
      reference: 'RF-0044-001-PPP',
      name: 'Bifenazate',
      casNumber: '149877-41-8',
      otherNames: ['propan-2-yl N-(2-methoxy-5-phenylanilino)carbamate'],
      reportable: true
    },
    'RF-0045-001-PPP': {
      reference: 'RF-0045-001-PPP',
      name: 'Bifenox',
      casNumber: '42576-02-3',
      otherNames: [],
      reportable: true
    },
    'RF-0046-001-PPP': {
      reference: 'RF-0046-001-PPP',
      name: 'Bifenthrin (sum of isomers)',
      casNumber: '82657-04-3',
      otherNames: [],
      reportable: true
    },
    'RF-0047-001-PPP': {
      reference: 'RF-0047-001-PPP',
      name: 'Binapacryl',
      casNumber: '485-31-4',
      otherNames: [],
      reportable: true
    },
    'RF-0048-001-PPP': {
      reference: 'RF-0048-001-PPP',
      name: 'Bitertanol (sum of isomers)',
      casNumber: '55179-31-2',
      otherNames: [
        "β-([1,1'-biphenyl]-4-yloxy)-α-tert-butyl-1H-1,2,4-triazol-1-ethanol"
      ],
      reportable: true
    },
    'RF-0049-001-PPP': {
      reference: 'RF-0049-001-PPP',
      name: 'Boscalid',
      casNumber: '188425-85-6',
      otherNames: [],
      reportable: true
    },
    'RF-0050-001-PPP': {
      reference: 'RF-0050-001-PPP',
      name: 'Bromide ion',
      casNumber: '24959-67-9',
      otherNames: [],
      reportable: true
    },
    'RF-0051-001-PPP': {
      reference: 'RF-0051-001-PPP',
      name: 'Bromophos-ethyl',
      casNumber: '4824-78-6',
      otherNames: [],
      reportable: true
    },
    'RF-0052-001-PPP': {
      reference: 'RF-0052-001-PPP',
      name: 'Bromopropylate',
      casNumber: '18181-80-1',
      otherNames: [],
      reportable: true
    },
    'RF-0053-003-PPP': {
      reference: 'RF-0053-003-PPP',
      name: 'Bromoxynil-methyl ether',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0053-004-PPP': {
      reference: 'RF-0053-004-PPP',
      name: 'Bromoxynil octanoate',
      casNumber: '1689-99-2',
      otherNames: [],
      reportable: true
    },
    'RF-0054-001-PPP': {
      reference: 'RF-0054-001-PPP',
      name: 'Bromuconazole (sum of diasteroisomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0055-001-PPP': {
      reference: 'RF-0055-001-PPP',
      name: 'Bupirimate',
      casNumber: '41483-43-6',
      otherNames: [],
      reportable: true
    },
    'RF-0056-001-PPP': {
      reference: 'RF-0056-001-PPP',
      name: 'Buprofezin',
      casNumber: '69327-76-0',
      otherNames: [],
      reportable: true
    },
    'RF-0057-001-PPP': {
      reference: 'RF-0057-001-PPP',
      name: 'Butralin',
      casNumber: '33629-47-9',
      otherNames: [],
      reportable: true
    },
    'RF-0058-001-PPP': {
      reference: 'RF-0058-001-PPP',
      name: 'Butylate',
      casNumber: '2008-41-5',
      otherNames: [],
      reportable: true
    },
    'RF-0059-001-PPP': {
      reference: 'RF-0059-001-PPP',
      name: 'Camphechlor (Toxaphene)',
      casNumber: '8001-35-2',
      otherNames: [],
      reportable: true
    },
    'RF-0059-003-PPP': {
      reference: 'RF-0059-003-PPP',
      name: 'Camphechlor (Sum of the three indicator compounds Parlar No 26, 50 and 62)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0059-004-PPP': {
      reference: 'RF-0059-004-PPP',
      name: 'Parlar No 26',
      casNumber: '142534-71-2',
      otherNames: [],
      reportable: true
    },
    'RF-0059-005-PPP': {
      reference: 'RF-0059-005-PPP',
      name: 'Parlar No 62',
      casNumber: '154159-06-5',
      otherNames: [],
      reportable: true
    },
    'RF-0059-006-PPP': {
      reference: 'RF-0059-006-PPP',
      name: 'Parlar No 50',
      casNumber: '66860-80-8',
      otherNames: [],
      reportable: true
    },
    'RF-0060-001-PPP': {
      reference: 'RF-0060-001-PPP',
      name: 'Captafol',
      casNumber: '2425-06-1',
      otherNames: [],
      reportable: true
    },
    'RF-0061-001-PPP': {
      reference: 'RF-0061-001-PPP',
      name: 'Captan',
      casNumber: '133-06-2',
      otherNames: [
        'N-(trichloromethylthio)cyclohex-4-ene-1,2-dicarboximide',
        '3a,4,7,7a-tetrahydro-2-[(trichloromethyl)thio]-1H-isoindole-1,3(2H)-dione'
      ],
      reportable: true
    },
    'RF-0062-001-PPP': {
      reference: 'RF-0062-001-PPP',
      name: 'Carbaryl',
      casNumber: '63-25-2',
      otherNames: [],
      reportable: true
    },
    'RF-0065-002-PPP': {
      reference: 'RF-0065-002-PPP',
      name: 'Carbofuran, 3-hydroxy',
      casNumber: '16655-82-6',
      otherNames: [],
      reportable: true
    },
    'RF-0065-003-PPP': {
      reference: 'RF-0065-003-PPP',
      name: 'Carbofuran',
      casNumber: '1563-66-2',
      otherNames: ['2,3-dihydro-2,2-dimethylbenzofuran-7-yl methylcarbamate'],
      reportable: true
    },
    'RF-0067-001-PPP': {
      reference: 'RF-0067-001-PPP',
      name: 'Carbon tetrachloride',
      casNumber: '56-23-5',
      otherNames: [],
      reportable: true
    },
    'RF-0068-001-PPP': {
      reference: 'RF-0068-001-PPP',
      name: 'Carbosulfan',
      casNumber: '55285-14-8',
      otherNames: [],
      reportable: true
    },
    'RF-0069-001-PPP': {
      reference: 'RF-0069-001-PPP',
      name: 'Carboxin',
      casNumber: '5234-68-4',
      otherNames: [],
      reportable: true
    },
    'RF-0070-002-PPP': {
      reference: 'RF-0070-002-PPP',
      name: 'Carfentrazone',
      casNumber: '128621-72-7',
      otherNames: [],
      reportable: true
    },
    'RF-0070-003-PPP': {
      reference: 'RF-0070-003-PPP',
      name: 'Carfentrazone-ethyl',
      casNumber: '128639-02-1',
      otherNames: [],
      reportable: true
    },
    'RF-0071-001-PPP': {
      reference: 'RF-0071-001-PPP',
      name: 'Cartap',
      casNumber: '15263-53-3',
      otherNames: [],
      reportable: true
    },
    'RF-0072-001-PPP': {
      reference: 'RF-0072-001-PPP',
      name: 'Chlorantraniliprole',
      casNumber: '500008-45-7',
      otherNames: [
        '3-bromo-N-[4-chloro-2-methyl-6-[(methylamino)carbonyl]phenyl]-1-(3-chloro-2-pyridinyl)-1H-pyrazole-5-carboxamide',
        '(DPX E-2Y45)'
      ],
      reportable: true
    },
    'RF-0073-001-PPP': {
      reference: 'RF-0073-001-PPP',
      name: 'Chlorbenside',
      casNumber: '103-17-3',
      otherNames: [],
      reportable: true
    },
    'RF-0074-001-PPP': {
      reference: 'RF-0074-001-PPP',
      name: 'Chlorbufam',
      casNumber: '1967-16-4',
      otherNames: [],
      reportable: true
    },
    'RF-0075-001-PPP': {
      reference: 'RF-0075-001-PPP',
      name: 'Chlordane (sum of cis- and trans-chlordane)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0075-003-PPP': {
      reference: 'RF-0075-003-PPP',
      name: 'Chlordane, trans-',
      casNumber: '5103-74-2',
      otherNames: [],
      reportable: true
    },
    'RF-0075-004-PPP': {
      reference: 'RF-0075-004-PPP',
      name: 'Chlordane, cis-',
      casNumber: '5103-71-9',
      otherNames: [],
      reportable: true
    },
    'RF-0075-005-PPP': {
      reference: 'RF-0075-005-PPP',
      name: 'Chlordane (sum of cis- and trans-isomers and oxychlordane expressed as chlordane)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0076-001-PPP': {
      reference: 'RF-0076-001-PPP',
      name: 'Chlordecone',
      casNumber: '143-50-0',
      otherNames: [],
      reportable: true
    },
    'RF-0077-001-PPP': {
      reference: 'RF-0077-001-PPP',
      name: 'Chlorfenapyr',
      casNumber: '122453-73-0',
      otherNames: [],
      reportable: true
    },
    'RF-0078-001-PPP': {
      reference: 'RF-0078-001-PPP',
      name: 'Chlorfenson',
      casNumber: '80-33-1',
      otherNames: [],
      reportable: true
    },
    'RF-0079-001-PPP': {
      reference: 'RF-0079-001-PPP',
      name: 'Chlorfenvinphos',
      casNumber: '470-90-6',
      otherNames: [],
      reportable: true
    },
    'RF-0080-001-PPP': {
      reference: 'RF-0080-001-PPP',
      name: 'Chloridazon',
      casNumber: '1698-60-8',
      otherNames: [],
      reportable: true
    },
    'RF-0082-001-PPP': {
      reference: 'RF-0082-001-PPP',
      name: 'Chlorobenzilate',
      casNumber: '510-15-6',
      otherNames: [],
      reportable: true
    },
    'RF-0083-001-PPP': {
      reference: 'RF-0083-001-PPP',
      name: 'Chloropicrin',
      casNumber: '76-06-2',
      otherNames: ['Chloropicrine', 'Trichloronitromethane', 'Dolochlor'],
      reportable: true
    },
    'RF-0084-001-PPP': {
      reference: 'RF-0084-001-PPP',
      name: 'Chlorothalonil',
      casNumber: '1897-45-6',
      otherNames: [],
      reportable: true
    },
    'RF-0085-001-PPP': {
      reference: 'RF-0085-001-PPP',
      name: 'Chloroxuron',
      casNumber: '1982-47-4',
      otherNames: [],
      reportable: true
    },
    'RF-0086-002-PPP': {
      reference: 'RF-0086-002-PPP',
      name: 'Chloroaniline, 3-',
      casNumber: '108-42-9',
      otherNames: [],
      reportable: true
    },
    'RF-0086-003-PPP': {
      reference: 'RF-0086-003-PPP',
      name: 'Chlorpropham',
      casNumber: '101-21-3',
      otherNames: [],
      reportable: true
    },
    'RF-0086-004-PPP': {
      reference: 'RF-0086-004-PPP',
      name: 'Chlorpropham and 4-hydroxychlorpropham-O-sulphonic acid (4-HSA),expressed as chlorpropham',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0087-001-PPP': {
      reference: 'RF-0087-001-PPP',
      name: 'Chlorpyrifos',
      casNumber: '2921-88-2',
      otherNames: [
        'O,O-diethyl O-3,5,6-trichloro-2-pyridyl phosphorothioate',
        'O,O-diethyl O-(3,5,6-trichloro-2-pyridinyl) phosphorothioate'
      ],
      reportable: true
    },
    'RF-0088-001-PPP': {
      reference: 'RF-0088-001-PPP',
      name: 'Chlorpyrifos-methyl',
      casNumber: '5598-13-0',
      otherNames: [
        'O,O-dimethyl O-(3,5,6-trichloropyridin-2-yl) phosphorothioate',
        'O,O-dimethyl O-(3,5,6-trichloro-2-pyridinyl) phosphorothioate'
      ],
      reportable: true
    },
    'RF-0089-001-PPP': {
      reference: 'RF-0089-001-PPP',
      name: 'Chlorsulfuron',
      casNumber: '64902-72-3',
      otherNames: [],
      reportable: true
    },
    'RF-0090-001-PPP': {
      reference: 'RF-0090-001-PPP',
      name: 'Chlorthal-dimethyl',
      casNumber: '1861-32-1',
      otherNames: [],
      reportable: true
    },
    'RF-0091-001-PPP': {
      reference: 'RF-0091-001-PPP',
      name: 'Chlorthiamid',
      casNumber: '1918-13-4',
      otherNames: [],
      reportable: true
    },
    'RF-0092-001-PPP': {
      reference: 'RF-0092-001-PPP',
      name: 'Chlorotoluron',
      casNumber: '15545-48-9',
      otherNames: ['N′-(3-chloro-4-methylphenyl)-N,N-dimethylurea'],
      reportable: true
    },
    'RF-0093-001-PPP': {
      reference: 'RF-0093-001-PPP',
      name: 'Chlozolinate',
      casNumber: '84332-86-5',
      otherNames: [],
      reportable: true
    },
    'RF-0094-001-PPP': {
      reference: 'RF-0094-001-PPP',
      name: 'Chromafenozide',
      casNumber: '143807-66-3',
      otherNames: [],
      reportable: true
    },
    'RF-0095-001-PPP': {
      reference: 'RF-0095-001-PPP',
      name: 'Cinidon-ethyl (sum of cinidon ethyl and its E-isomer)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0096-001-PPP': {
      reference: 'RF-0096-001-PPP',
      name: 'Clethodim (sum of Sethoxydim and Clethodim including degradation products calculated as Sethoxydim)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0096-002-PPP': {
      reference: 'RF-0096-002-PPP',
      name: 'Clethodim-Sulfon',
      casNumber: '111031-17-5',
      otherNames: [],
      reportable: true
    },
    'RF-0096-003-PPP': {
      reference: 'RF-0096-003-PPP',
      name: 'Sethoxydim',
      casNumber: '74051-80-2',
      otherNames: [],
      reportable: true
    },
    'RF-0096-004-PPP': {
      reference: 'RF-0096-004-PPP',
      name: 'Clethodim-Sulfoxid',
      casNumber: '111031-14-2',
      otherNames: [],
      reportable: true
    },
    'RF-0096-005-PPP': {
      reference: 'RF-0096-005-PPP',
      name: 'Clethodim',
      casNumber: '99129-21-2',
      otherNames: [],
      reportable: true
    },
    'RF-0096-006-PPP': {
      reference: 'RF-0096-006-PPP',
      name: 'Clethodim-Imin-Sulfoxid',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0096-007-PPP': {
      reference: 'RF-0096-007-PPP',
      name: 'Clethodim-Imin-Sulfon',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0096-009-PPP': {
      reference: 'RF-0096-009-PPP',
      name: 'Clethodim, 5-Hydroxy-Sulfon',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0097-001-PPP': {
      reference: 'RF-0097-001-PPP',
      name: 'Clodinafop and its S-isomers, expressed as clodinafop',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0098-001-PPP': {
      reference: 'RF-0098-001-PPP',
      name: 'Clofentezine',
      casNumber: '74115-24-5',
      otherNames: [],
      reportable: true
    },
    'RF-0098-002-PPP': {
      reference: 'RF-0098-002-PPP',
      name: 'Clofentezine (sum of all compounds containing the 2-chlorobenzoyl moiety expressed as clofentezine)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0099-001-PPP': {
      reference: 'RF-0099-001-PPP',
      name: 'Clomazone',
      casNumber: '81777-89-1',
      otherNames: [],
      reportable: true
    },
    'RF-0100-001-PPP': {
      reference: 'RF-0100-001-PPP',
      name: 'Clopyralid',
      casNumber: '1702-17-6',
      otherNames: [],
      reportable: true
    },
    'RF-0101-001-PPP': {
      reference: 'RF-0101-001-PPP',
      name: 'Clothianidin',
      casNumber: '210880-92-5',
      otherNames: [],
      reportable: true
    },
    'RF-0102-001-PPP': {
      reference: 'RF-0102-001-PPP',
      name: 'Copper',
      casNumber: '7440-50-8',
      otherNames: [],
      reportable: true
    },
    'RF-0103-001-PPP': {
      reference: 'RF-0103-001-PPP',
      name: 'Cyanamide including salts expressed as cyanamide',
      casNumber: '420-04-2',
      otherNames: [],
      reportable: true
    },
    'RF-0104-001-PPP': {
      reference: 'RF-0104-001-PPP',
      name: 'Cyazofamid',
      casNumber: '120116-88-3',
      otherNames: [
        '4-chloro-2-cyano-N,N-dimethyl-5-(4-methylphenyl)-1H-imidazole-1-sulfonamide'
      ],
      reportable: true
    },
    'RF-0105-001-PPP': {
      reference: 'RF-0105-001-PPP',
      name: 'Cyclanilide',
      casNumber: '113136-77-9',
      otherNames: [],
      reportable: true
    },
    'RF-0106-001-PPP': {
      reference: 'RF-0106-001-PPP',
      name: 'Cycloxydim including degradation and reaction products which can be determined as 3-(3-thianyl)glutaric acid S-dioxide (BH 517-TGSO2) and/or 3-hydroxy-3-(3-thianyl)glutaric acid S-dioxide (BH 517-5-OH-TGSO2) or methyl esters thereof, calculated in total a',
      casNumber: null,
      otherNames: [],
      reportable: false
    },
    'RF-0106-002-PPP': {
      reference: 'RF-0106-002-PPP',
      name: 'Cycloxydim',
      casNumber: '101205-02-1',
      otherNames: [],
      reportable: true
    },
    'RF-0107-001-PPP': {
      reference: 'RF-0107-001-PPP',
      name: 'Cyflufenamid (sum of cyflufenamid (Z-isomer) and its E-isomer, expressed as cyflufenamid)',
      casNumber: null,
      otherNames: ['Cyflufenamid'],
      reportable: true
    },
    'RF-0108-001-PPP': {
      reference: 'RF-0108-001-PPP',
      name: 'Cyfluthrin (Cyfluthrin including other mixtures of constituent isomers (sum of isomers))',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0111-001-PPP': {
      reference: 'RF-0111-001-PPP',
      name: 'Cymoxanil',
      casNumber: '57966-95-7',
      otherNames: [
        '2-cyano-N-[(ethylamino)carbonyl]-2-(methoxyimino)acetamide'
      ],
      reportable: true
    },
    'RF-0112-001-PPP': {
      reference: 'RF-0112-001-PPP',
      name: 'Cypermethrin (Cypermethrin including other mixtures of constituent isomers (sum of isomers))',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0112-003-PPP': {
      reference: 'RF-0112-003-PPP',
      name: 'Beta-cypermethrin',
      casNumber: '65731-84-2',
      otherNames: [],
      reportable: true
    },
    'RF-0112-004-PPP': {
      reference: 'RF-0112-004-PPP',
      name: 'Cypermethrin',
      casNumber: '52315-07-8',
      otherNames: [],
      reportable: true
    },
    'RF-0112-005-PPP': {
      reference: 'RF-0112-005-PPP',
      name: 'Zeta-cypermethrin',
      casNumber: '1315501-18-8',
      otherNames: ['Zeta-Cypermethrin'],
      reportable: true
    },
    'RF-0113-001-PPP': {
      reference: 'RF-0113-001-PPP',
      name: 'Cyproconazole',
      casNumber: '94361-06-5',
      otherNames: [
        '(2RS,3RS;2RS,3SR)-2-(4-chlorophenyl)-3-cyclopropyl-1-(1H-1,2,4-triazol-1-yl)butan-2-ol'
      ],
      reportable: true
    },
    'RF-0114-001-PPP': {
      reference: 'RF-0114-001-PPP',
      name: 'Cyprodinil',
      casNumber: '121552-61-2',
      otherNames: [
        '4-cyclopropyl-6-methyl-N-phenyl-2-pyrimidinamine',
        '(4-cyclopropyl-6-methyl-pyrimidin-2-yl)-phenyl-amine'
      ],
      reportable: true
    },
    'RF-0114-002-PPP': {
      reference: 'RF-0114-002-PPP',
      name: 'Cyprodinil (sum of cyprodinil and CGA 304075 (free), expressed as cyprodinil)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0115-001-PPP': {
      reference: 'RF-0115-001-PPP',
      name: 'Cyromazine',
      casNumber: '66215-27-8',
      otherNames: [],
      reportable: true
    },
    'RF-0116-001-PPP': {
      reference: 'RF-0116-001-PPP',
      name: 'Dalapon',
      casNumber: '75-99-0',
      otherNames: [],
      reportable: true
    },
    'RF-0117-001-PPP': {
      reference: 'RF-0117-001-PPP',
      name: 'Daminozide (sum of daminozide and 1,1-dimethyl-hydrazine (UDHM), expressed as daminozide)',
      casNumber: null,
      otherNames: [
        'Daminozide (sum of daminozide and 1,1-dimethyl-hydrazine, expressed as daminazide)'
      ],
      reportable: true
    },
    'RF-0118-001-PPP': {
      reference: 'RF-0118-001-PPP',
      name: 'Methylisothiocyanate (resulting from the use of dazomet and metam)',
      casNumber: null,
      otherNames: [
        'Dazomet (Methylisothiocyanate resulting from the use of dazomet and metam)',
        'Dazomet (Methylisothiocyanate resulting from the use of dazomet and metam)'
      ],
      reportable: false
    },
    'RF-0118-003-PPP': {
      reference: 'RF-0118-003-PPP',
      name: 'Dazomet',
      casNumber: '533-74-4',
      otherNames: [],
      reportable: false
    },
    'RF-0119-001-PPP': {
      reference: 'RF-0119-001-PPP',
      name: "DDT (sum of p,p'-DDT, o,p'-DDT, p-p'-DDE and p,p'-TDE (DDD) expressed as DDT)",
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0119-002-PPP': {
      reference: 'RF-0119-002-PPP',
      name: 'DDE, p,p-',
      casNumber: '72-55-9',
      otherNames: [],
      reportable: true
    },
    'RF-0119-003-PPP': {
      reference: 'RF-0119-003-PPP',
      name: 'DDT, o,p-',
      casNumber: '789-02-6',
      otherNames: [],
      reportable: true
    },
    'RF-0119-004-PPP': {
      reference: 'RF-0119-004-PPP',
      name: 'DDD, p,p-',
      casNumber: '72-54-8',
      otherNames: [],
      reportable: true
    },
    'RF-0119-005-PPP': {
      reference: 'RF-0119-005-PPP',
      name: 'DDD, o,p-',
      casNumber: '53-19-0',
      otherNames: [],
      reportable: true
    },
    'RF-0119-006-PPP': {
      reference: 'RF-0119-006-PPP',
      name: 'DDT, p,p-',
      casNumber: '50-29-3',
      otherNames: [],
      reportable: true
    },
    'RF-0119-007-PPP': {
      reference: 'RF-0119-007-PPP',
      name: 'DDE, o,p-',
      casNumber: '3424-82-6',
      otherNames: [],
      reportable: true
    },
    'RF-0120-001-PPP': {
      reference: 'RF-0120-001-PPP',
      name: 'Deltamethrin (cis-deltamethrin)',
      casNumber: '52918-63-5',
      otherNames: [
        '(S)-cyano(3-phenoxyphenyl)methyl (1R,3R)-3-(2,2-dibromoethenyl)-2,2-dimethylcyclopropanecarboxylate'
      ],
      reportable: true
    },
    'RF-0121-001-PPP': {
      reference: 'RF-0121-001-PPP',
      name: 'Desmedipham',
      casNumber: '13684-56-5',
      otherNames: [],
      reportable: true
    },
    'RF-0122-001-PPP': {
      reference: 'RF-0122-001-PPP',
      name: 'Di-allate (sum of isomers)',
      casNumber: '2303-16-4',
      otherNames: [],
      reportable: true
    },
    'RF-0123-001-PPP': {
      reference: 'RF-0123-001-PPP',
      name: 'Diazinon',
      casNumber: '333-41-5',
      otherNames: [],
      reportable: true
    },
    'RF-0124-001-PPP': {
      reference: 'RF-0124-001-PPP',
      name: 'Dicamba',
      casNumber: '1918-00-9',
      otherNames: ['3,6-dichloro-o-anisic acid'],
      reportable: true
    },
    'RF-0125-001-PPP': {
      reference: 'RF-0125-001-PPP',
      name: 'Dichlobenil',
      casNumber: '1194-65-6',
      otherNames: [],
      reportable: true
    },
    'RF-0126-002-PPP': {
      reference: 'RF-0126-002-PPP',
      name: 'Dichlorprop',
      casNumber: '120-36-5',
      otherNames: [],
      reportable: true
    },
    'RF-0126-003-PPP': {
      reference: 'RF-0126-003-PPP',
      name: 'Dichlorprop-p',
      casNumber: '15165-67-0',
      otherNames: [],
      reportable: true
    },
    'RF-0127-001-PPP': {
      reference: 'RF-0127-001-PPP',
      name: 'Dichlorvos',
      casNumber: '62-73-7',
      otherNames: [],
      reportable: true
    },
    'RF-0128-002-PPP': {
      reference: 'RF-0128-002-PPP',
      name: 'Diclofop',
      casNumber: '40843-25-2',
      otherNames: [],
      reportable: true
    },
    'RF-0128-003-PPP': {
      reference: 'RF-0128-003-PPP',
      name: 'Diclofop-Methyl',
      casNumber: '51338-27-3',
      otherNames: [],
      reportable: true
    },
    'RF-0129-001-PPP': {
      reference: 'RF-0129-001-PPP',
      name: 'Dicloran',
      casNumber: '99-30-9',
      otherNames: [],
      reportable: true
    },
    'RF-0130-001-PPP': {
      reference: 'RF-0130-001-PPP',
      name: "Dicofol (sum of p, p' and o,p' isomers)",
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0130-002-PPP': {
      reference: 'RF-0130-002-PPP',
      name: "Dicofol p, p'",
      casNumber: '115-32-2',
      otherNames: [],
      reportable: true
    },
    'RF-0130-003-PPP': {
      reference: 'RF-0130-003-PPP',
      name: "Dicofol o, p'",
      casNumber: '10606-46-9',
      otherNames: [],
      reportable: true
    },
    'RF-0132-001-PPP': {
      reference: 'RF-0132-001-PPP',
      name: 'Diethofencarb',
      casNumber: '87130-20-9',
      otherNames: [],
      reportable: true
    },
    'RF-0133-001-PPP': {
      reference: 'RF-0133-001-PPP',
      name: 'Difenoconazole',
      casNumber: '119446-68-3',
      otherNames: [
        '1-({2-[(2,4)-2-chloro-4-(4-chlorophenoxy)phenyl]-4-methyl-1,3-dioxolan-2-yl}methyl)-1H-1,2,4-triazole',
        '1-[[2-[2-chloro-4-(4-chlorophenoxy)phenyl]-4-methyl-1,3-dioxolan-2-yl]methyl]-1H-1,2,4-triazole'
      ],
      reportable: true
    },
    'RF-0134-001-PPP': {
      reference: 'RF-0134-001-PPP',
      name: 'Diflubenzuron',
      casNumber: '35367-38-5',
      otherNames: [
        '1-(4-chlorophenyl)-3-(2,6-difluorobenzoyl)urea',
        'N-[[(4-chlorophenyl)amino]carbonyl]-2,6-difluorobenzamide'
      ],
      reportable: true
    },
    'RF-0134-002-PPP': {
      reference: 'RF-0134-002-PPP',
      name: 'Diflubenzuron (sum of Diflubenzuron and 4-chlorophenylurea expressed as Diflubenzuron)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0135-001-PPP': {
      reference: 'RF-0135-001-PPP',
      name: 'Diflufenican',
      casNumber: '83164-33-4',
      otherNames: [],
      reportable: true
    },
    'RF-0136-001-PPP': {
      reference: 'RF-0136-001-PPP',
      name: 'Dimethachlor',
      casNumber: '50563-36-5',
      otherNames: ['2-chloro-N-(2-methoxyethyl) acet-2´,6´-xylidide'],
      reportable: true
    },
    'RF-0137-002-PPP': {
      reference: 'RF-0137-002-PPP',
      name: 'Dimethenamid including other mixtures of constituent isomers including dimethenamid-P (sum of isomers)',
      casNumber: null,
      otherNames: [
        'Dimethenamid-p (Dimethenamid-p including other mixtures of constituent isomers (sum of isomers))'
      ],
      reportable: true
    },
    'RF-0138-001-PPP': {
      reference: 'RF-0138-001-PPP',
      name: 'Dimethipin',
      casNumber: '55290-64-7',
      otherNames: [],
      reportable: true
    },
    'RF-0139-002-PPP': {
      reference: 'RF-0139-002-PPP',
      name: 'Omethoate',
      casNumber: '1113-02-6',
      otherNames: [],
      reportable: true
    },
    'RF-0139-003-PPP': {
      reference: 'RF-0139-003-PPP',
      name: 'Dimethoate',
      casNumber: '60-51-5',
      otherNames: [],
      reportable: true
    },
    'RF-0140-001-PPP': {
      reference: 'RF-0140-001-PPP',
      name: 'Dimethomorph (sum of isomers)',
      casNumber: null,
      otherNames: [
        'Dimethomorph',
        '(2)-3-(4-chlorophenyl)-3-(3,4-dimethoxyphenyl)-1-(morpholin-4-yl)prop-2-en-1-one',
        '4-[3-(4-chlorophenyl)-3-(3,4-dimethoxyphenyl)-1-oxo-2-propen-1-yl]morpholine'
      ],
      reportable: true
    },
    'RF-0141-001-PPP': {
      reference: 'RF-0141-001-PPP',
      name: 'Dimoxystrobin',
      casNumber: '149961-52-4',
      otherNames: [],
      reportable: true
    },
    'RF-0142-001-PPP': {
      reference: 'RF-0142-001-PPP',
      name: 'Diniconazole (sum of isomers)',
      casNumber: null,
      otherNames: ['Diniconazole'],
      reportable: true
    },
    'RF-0143-001-PPP': {
      reference: 'RF-0143-001-PPP',
      name: 'Dinocap (sum of dinocap isomers and their corresponding phenols expressed as dinocap)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0143-002-PPP': {
      reference: 'RF-0143-002-PPP',
      name: 'Dinocap',
      casNumber: '39300-45-3',
      otherNames: [],
      reportable: true
    },
    'RF-0144-001-PPP': {
      reference: 'RF-0144-001-PPP',
      name: 'Dinoseb',
      casNumber: '88-85-7',
      otherNames: [],
      reportable: true
    },
    'RF-0145-001-PPP': {
      reference: 'RF-0145-001-PPP',
      name: 'Dinoterb',
      casNumber: '1420-07-1',
      otherNames: [],
      reportable: true
    },
    'RF-0146-001-PPP': {
      reference: 'RF-0146-001-PPP',
      name: 'Dioxathion (sum of isomers)',
      casNumber: '78-34-2',
      otherNames: [],
      reportable: true
    },
    'RF-0147-001-PPP': {
      reference: 'RF-0147-001-PPP',
      name: 'Diphenylamine',
      casNumber: '122-39-4',
      otherNames: [],
      reportable: true
    },
    'RF-0149-001-PPP': {
      reference: 'RF-0149-001-PPP',
      name: 'Disulfoton (sum of disulfoton, disulfoton sulfoxide and disulfoton sulfone expressed as disulfoton)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0149-002-PPP': {
      reference: 'RF-0149-002-PPP',
      name: 'Disulfoton',
      casNumber: '298-04-4',
      otherNames: [],
      reportable: true
    },
    'RF-0149-003-PPP': {
      reference: 'RF-0149-003-PPP',
      name: 'Disulfoton-Sulfoxid',
      casNumber: '2497-07-6',
      otherNames: [],
      reportable: true
    },
    'RF-0149-004-PPP': {
      reference: 'RF-0149-004-PPP',
      name: 'Disulfoton-Sulfon',
      casNumber: '2497-06-5',
      otherNames: [],
      reportable: true
    },
    'RF-0150-001-PPP': {
      reference: 'RF-0150-001-PPP',
      name: 'Dithianon',
      casNumber: '3347-22-6',
      otherNames: [],
      reportable: true
    },
    'RF-0151-001-PPP': {
      reference: 'RF-0151-001-PPP',
      name: 'Dithiocarbamates (Dithiocarbamates expressed as CS2, including Maneb, Mancozeb, Metiram, Propineb, Thiram and Ziram)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0151-005-PPP': {
      reference: 'RF-0151-005-PPP',
      name: 'Carbon disulphide',
      casNumber: '75-15-0',
      otherNames: [],
      reportable: true
    },
    'RF-0152-002-PPP': {
      reference: 'RF-0152-002-PPP',
      name: 'Diuron',
      casNumber: '330-54-1',
      otherNames: ['N′-(3,4-dichlorophenyl)-N,N-dimethylurea'],
      reportable: true
    },
    'RF-0153-001-PPP': {
      reference: 'RF-0153-001-PPP',
      name: 'DNOC',
      casNumber: '534-52-1',
      otherNames: [],
      reportable: true
    },
    'RF-0154-001-PPP': {
      reference: 'RF-0154-001-PPP',
      name: 'Dodine',
      casNumber: '2439-10-3',
      otherNames: [],
      reportable: true
    },
    'RF-0155-001-PPP': {
      reference: 'RF-0155-001-PPP',
      name: 'Endosulfan (sum of alpha- and beta-isomers and endosulfan-sulphate expressed as endosulfan)',
      casNumber: null,
      otherNames: [
        'Endosulfan (sum of alpha- and beta-isomers and endosulfan-sulphate expresses as endosulfan)'
      ],
      reportable: true
    },
    'RF-0155-002-PPP': {
      reference: 'RF-0155-002-PPP',
      name: 'Endosulfansulfate',
      casNumber: '1031-07-8',
      otherNames: [],
      reportable: true
    },
    'RF-0155-003-PPP': {
      reference: 'RF-0155-003-PPP',
      name: 'Endosulfan, beta-',
      casNumber: '33213-65-9',
      otherNames: [],
      reportable: true
    },
    'RF-0155-004-PPP': {
      reference: 'RF-0155-004-PPP',
      name: 'Endosulfan, alpha-',
      casNumber: '959-98-8',
      otherNames: [],
      reportable: true
    },
    'RF-0156-001-PPP': {
      reference: 'RF-0156-001-PPP',
      name: 'Endrin',
      casNumber: '72-20-8',
      otherNames: [],
      reportable: true
    },
    'RF-0157-001-PPP': {
      reference: 'RF-0157-001-PPP',
      name: 'Epoxiconazole',
      casNumber: '133855-98-8',
      otherNames: [
        'rac-1-{[(2R,3S)-3-(2-chlorophenyl)-2-(4-fluorophenyl)oxiran-2-yl]methyl}-1H-1,2,4-triazole',
        'rel-1-[[(2R,3S)-3-(2-chlorophenyl)-2-(4-fluorophenyl)-2-oxiranyl]methyl]-1H-1,2,4-triazole'
      ],
      reportable: true
    },
    'RF-0158-001-PPP': {
      reference: 'RF-0158-001-PPP',
      name: 'EPTC (ethyl dipropylthiocarbamate)',
      casNumber: '759-94-4',
      otherNames: [],
      reportable: true
    },
    'RF-0159-001-PPP': {
      reference: 'RF-0159-001-PPP',
      name: 'Ethalfluralin',
      casNumber: '55283-68-6',
      otherNames: [],
      reportable: true
    },
    'RF-0160-001-PPP': {
      reference: 'RF-0160-001-PPP',
      name: 'Ethephon',
      casNumber: '16672-87-0',
      otherNames: [
        '2-chloroethylphosphonic acid',
        '(P)-(2-chloroethyl)phosphonic acid'
      ],
      reportable: true
    },
    'RF-0161-001-PPP': {
      reference: 'RF-0161-001-PPP',
      name: 'Ethion',
      casNumber: '563-12-2',
      otherNames: [],
      reportable: true
    },
    'RF-0162-001-PPP': {
      reference: 'RF-0162-001-PPP',
      name: 'Ethirimol',
      casNumber: '23947-60-6',
      otherNames: [],
      reportable: true
    },
    'RF-0163-002-PPP': {
      reference: 'RF-0163-002-PPP',
      name: 'Ethofumesate',
      casNumber: '26225-79-6',
      otherNames: [],
      reportable: true
    },
    'RF-0164-001-PPP': {
      reference: 'RF-0164-001-PPP',
      name: 'Ethoprophos',
      casNumber: '13194-48-4',
      otherNames: [],
      reportable: true
    },
    'RF-0165-001-PPP': {
      reference: 'RF-0165-001-PPP',
      name: 'Ethoxyquin',
      casNumber: '91-53-2',
      otherNames: ['1,2-Dihydro-2,2,4-trimethyl-6-ethoxyquinoline'],
      reportable: true
    },
    'RF-0166-001-PPP': {
      reference: 'RF-0166-001-PPP',
      name: 'Ethoxysulfuron',
      casNumber: '126801-58-9',
      otherNames: [],
      reportable: true
    },
    'RF-0167-001-PPP': {
      reference: 'RF-0167-001-PPP',
      name: 'Ethylene oxide (sum of ethylene oxide and 2-chloro-ethanol expressed as ethylene oxide)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0167-002-PPP': {
      reference: 'RF-0167-002-PPP',
      name: 'Chlorethanol, 2-',
      casNumber: '107-07-3',
      otherNames: [],
      reportable: true
    },
    'RF-0167-003-PPP': {
      reference: 'RF-0167-003-PPP',
      name: 'Ethylene oxide',
      casNumber: '75-21-8',
      otherNames: [],
      reportable: true
    },
    'RF-0168-001-PPP': {
      reference: 'RF-0168-001-PPP',
      name: 'Etofenprox',
      casNumber: '80844-07-1',
      otherNames: [],
      reportable: true
    },
    'RF-0169-001-PPP': {
      reference: 'RF-0169-001-PPP',
      name: 'Etoxazole',
      casNumber: '153233-91-1',
      otherNames: [],
      reportable: true
    },
    'RF-0170-001-PPP': {
      reference: 'RF-0170-001-PPP',
      name: 'Etridiazole',
      casNumber: '2593-15-9',
      otherNames: [],
      reportable: true
    },
    'RF-0171-001-PPP': {
      reference: 'RF-0171-001-PPP',
      name: 'Famoxadone',
      casNumber: '131807-57-3',
      otherNames: [],
      reportable: true
    },
    'RF-0172-001-PPP': {
      reference: 'RF-0172-001-PPP',
      name: 'Fenamidone',
      casNumber: '161326-34-7',
      otherNames: [],
      reportable: true
    },
    'RF-0173-001-PPP': {
      reference: 'RF-0173-001-PPP',
      name: 'Fenamiphos (sum of fenamiphos and its sulphoxide and sulphone expressed as fenamiphos)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0173-002-PPP': {
      reference: 'RF-0173-002-PPP',
      name: 'Fenamiphos-Sulfoxid',
      casNumber: '31972-43-7',
      otherNames: [],
      reportable: true
    },
    'RF-0173-003-PPP': {
      reference: 'RF-0173-003-PPP',
      name: 'Fenamiphos-Sulfon',
      casNumber: '31972-44-8',
      otherNames: [],
      reportable: true
    },
    'RF-0173-004-PPP': {
      reference: 'RF-0173-004-PPP',
      name: 'Fenamiphos',
      casNumber: '22224-92-6',
      otherNames: [],
      reportable: true
    },
    'RF-0174-001-PPP': {
      reference: 'RF-0174-001-PPP',
      name: 'Fenarimol',
      casNumber: '60168-88-9',
      otherNames: [],
      reportable: true
    },
    'RF-0175-001-PPP': {
      reference: 'RF-0175-001-PPP',
      name: 'Fenazaquin',
      casNumber: '120928-09-8',
      otherNames: [],
      reportable: true
    },
    'RF-0177-001-PPP': {
      reference: 'RF-0177-001-PPP',
      name: 'Fenbutatin oxide',
      casNumber: '13356-08-6',
      otherNames: ['bis[tris(2-methyl-2-phenylpropyl)tin] oxide'],
      reportable: true
    },
    'RF-0178-001-PPP': {
      reference: 'RF-0178-001-PPP',
      name: 'Fenchlorphos (sum of fenchlorphos and fenchlorphos oxon expressed as fenchlorphos)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0178-002-PPP': {
      reference: 'RF-0178-002-PPP',
      name: 'Fenchlorphos',
      casNumber: '299-84-3',
      otherNames: [],
      reportable: true
    },
    'RF-0178-003-PPP': {
      reference: 'RF-0178-003-PPP',
      name: 'Fenchlorphos-oxon',
      casNumber: '3983-45-7',
      otherNames: [],
      reportable: true
    },
    'RF-0179-001-PPP': {
      reference: 'RF-0179-001-PPP',
      name: 'Fenhexamid',
      casNumber: '126833-17-8',
      otherNames: [],
      reportable: true
    },
    'RF-0180-001-PPP': {
      reference: 'RF-0180-001-PPP',
      name: 'Fenitrothion',
      casNumber: '122-14-5',
      otherNames: [],
      reportable: true
    },
    'RF-0181-001-PPP': {
      reference: 'RF-0181-001-PPP',
      name: 'Fenoxaprop-P',
      casNumber: '113158-40-0',
      otherNames: [],
      reportable: true
    },
    'RF-0182-001-PPP': {
      reference: 'RF-0182-001-PPP',
      name: 'Fenoxycarb',
      casNumber: '72490-01-8',
      otherNames: [],
      reportable: true
    },
    'RF-0183-001-PPP': {
      reference: 'RF-0183-001-PPP',
      name: 'Fenpropathrin',
      casNumber: '39515-41-8',
      otherNames: [],
      reportable: true
    },
    'RF-0184-001-PPP': {
      reference: 'RF-0184-001-PPP',
      name: 'Fenpropidin (sum of fenpropidin and its salts, expressed as fenpropidin)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0184-002-PPP': {
      reference: 'RF-0184-002-PPP',
      name: 'Fenpropidin (sum of fenpropidin, 2-methyl-2-[4-(2-methyl-3- piperidin-1-yl-propyl)-phenyl]propionic acid, and their salts, expressed as fenpropidin)',
      casNumber: null,
      otherNames: [
        'Fenpropidin (sum of fenpropidin, 2-methyl-2-[4-(2-methyl-3- piperidin-1-yl-propyl)-phenyl]propionic acid, and their salts, expressed as fenpropidin',
        'Fenpropidin (sum of fenpropidin and CGA289267 expressed as fenpropidin)'
      ],
      reportable: true
    },
    'RF-0185-001-PPP': {
      reference: 'RF-0185-001-PPP',
      name: 'Fenpropimorph (sum of isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0185-002-PPP': {
      reference: 'RF-0185-002-PPP',
      name: 'Fenpropimorph carboxylic acid (BF 421-2) expressed as fenpropimorph',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0186-001-PPP': {
      reference: 'RF-0186-001-PPP',
      name: 'Fenpyroximate',
      casNumber: '134098-61-6',
      otherNames: [
        'tert-butyl 4-[({[(E)-(1,3-dimethyl-5-phenoxy-1H-pyrazol-4-yl)methylidene]amino}oxy)methyl]benzoate',
        '1,1-dimethylethyl 4-[[[(E)-[(1,3-dimethyl-5-phenoxy-1H-pyrazol-4-yl)methylene]amino]oxy]methyl]benzoate'
      ],
      reportable: true
    },
    'RF-0187-001-PPP': {
      reference: 'RF-0187-001-PPP',
      name: 'Fenthion (fenthion and its oxigen analogue, their sulfoxides and sulfone expressed as parent)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0187-002-PPP': {
      reference: 'RF-0187-002-PPP',
      name: 'Fenthion-Sulfoxide',
      casNumber: '3761-41-9',
      otherNames: [],
      reportable: true
    },
    'RF-0187-003-PPP': {
      reference: 'RF-0187-003-PPP',
      name: 'Fenthion-Sulfon',
      casNumber: '3761-42-0',
      otherNames: [],
      reportable: true
    },
    'RF-0187-004-PPP': {
      reference: 'RF-0187-004-PPP',
      name: 'Fenthion-Oxon',
      casNumber: '6552-12-1',
      otherNames: [],
      reportable: true
    },
    'RF-0187-005-PPP': {
      reference: 'RF-0187-005-PPP',
      name: 'Fenthion-Oxonsulfoxide',
      casNumber: '6552-13-2',
      otherNames: [],
      reportable: true
    },
    'RF-0187-006-PPP': {
      reference: 'RF-0187-006-PPP',
      name: 'Fenthion',
      casNumber: '55-38-9',
      otherNames: [],
      reportable: true
    },
    'RF-0187-007-PPP': {
      reference: 'RF-0187-007-PPP',
      name: 'Fenthion oxon sulfone',
      casNumber: '14086-35-2',
      otherNames: [],
      reportable: true
    },
    'RF-0192-001-PPP': {
      reference: 'RF-0192-001-PPP',
      name: 'Fipronil (sum fipronil + sulfone metabolite (MB46136) expressed as fipronil)',
      casNumber: null,
      otherNames: [
        'Fipronil (sum Fipronil and sulfone metabolite (MB46136) expressed as Fipronil)'
      ],
      reportable: true
    },
    'RF-0192-002-PPP': {
      reference: 'RF-0192-002-PPP',
      name: 'Fipronil-Sulfone',
      casNumber: '120068-36-2',
      otherNames: [],
      reportable: true
    },
    'RF-0192-003-PPP': {
      reference: 'RF-0192-003-PPP',
      name: 'Fipronil',
      casNumber: '120068-37-3',
      otherNames: [],
      reportable: true
    },
    'RF-0193-001-PPP': {
      reference: 'RF-0193-001-PPP',
      name: 'Flazasulfuron',
      casNumber: '104040-78-0',
      otherNames: [],
      reportable: true
    },
    'RF-0194-002-PPP': {
      reference: 'RF-0194-002-PPP',
      name: 'Flonicamid',
      casNumber: '158062-67-0',
      otherNames: [],
      reportable: true
    },
    'RF-0195-001-PPP': {
      reference: 'RF-0195-001-PPP',
      name: 'Florasulam',
      casNumber: '145701-23-1',
      otherNames: [],
      reportable: true
    },
    'RF-0196-001-PPP': {
      reference: 'RF-0196-001-PPP',
      name: 'Forchlorfenuron',
      casNumber: '68157-60-8',
      otherNames: [],
      reportable: true
    },
    'RF-0197-002-PPP': {
      reference: 'RF-0197-002-PPP',
      name: 'Fluazifop-P-butyl',
      casNumber: '79241-46-6',
      otherNames: [],
      reportable: true
    },
    'RF-0198-001-PPP': {
      reference: 'RF-0198-001-PPP',
      name: 'Fluazinam',
      casNumber: '79622-59-6',
      otherNames: [
        '3-chloro-N-[3-chloro-2,6-dinitro-4-(trifluoromethyl)phenyl]-5-(trifluoromethyl)pyridin-2-amine',
        '3-chloro-N-[3-chloro-2,6-dinitro-4-(trifluoromethyl)phenyl]-5-(trifluoromethyl)-2-pyridinamine'
      ],
      reportable: true
    },
    'RF-0199-001-PPP': {
      reference: 'RF-0199-001-PPP',
      name: 'Flubendiamide',
      casNumber: '272451-65-7',
      otherNames: [
        'N2-[1,1-dimethyl-2-(methylsulfonyl)ethyl]-3-iodo-N1-[2-methyl-4-[1,2,2,2-tetrafluoro-1-(trifluoromethyl)ethyl]phenyl]-1,2-benzenedicarboxamide'
      ],
      reportable: true
    },
    'RF-0200-001-PPP': {
      reference: 'RF-0200-001-PPP',
      name: 'Flucycloxuron',
      casNumber: '94050-52-9',
      otherNames: [],
      reportable: true
    },
    'RF-0201-002-PPP': {
      reference: 'RF-0201-002-PPP',
      name: 'Flucythrinate (flucythrinate including other mixtures of consitutent isomers (sum of isomers))',
      casNumber: null,
      otherNames: ['Flucythrinate (sum of isomers expressed as flucythrinate)'],
      reportable: true
    },
    'RF-0202-001-PPP': {
      reference: 'RF-0202-001-PPP',
      name: 'Fludioxonil',
      casNumber: '131341-86-1',
      otherNames: [],
      reportable: true
    },
    'RF-0203-001-PPP': {
      reference: 'RF-0203-001-PPP',
      name: 'Flufenacet (sum of all compounds containing the N fluorophenyl-N-isopropyl moiety expressed as flufenacet)',
      casNumber: null,
      otherNames: [
        'Flufenacet (sum of all compounds containing the N fluorophenyl-N-isopropyl moiety expressed as flufenacet equivalent)'
      ],
      reportable: true
    },
    'RF-0203-002-PPP': {
      reference: 'RF-0203-002-PPP',
      name: 'Flufenacet',
      casNumber: '142459-58-3',
      otherNames: [
        'N-(4-fluorophenyl)-N-(1-methylethyl)-2-[[5-(trifluoromethyl)-1,3,4-thiadiazol-2-yl]oxy]acetamide'
      ],
      reportable: true
    },
    'RF-0204-001-PPP': {
      reference: 'RF-0204-001-PPP',
      name: 'Flufenoxuron',
      casNumber: '101463-69-8',
      otherNames: [],
      reportable: true
    },
    'RF-0205-001-PPP': {
      reference: 'RF-0205-001-PPP',
      name: 'Flufenzin',
      casNumber: '162320-67-4',
      otherNames: [],
      reportable: true
    },
    'RF-0206-001-PPP': {
      reference: 'RF-0206-001-PPP',
      name: 'Flumioxazin',
      casNumber: '103361-09-7',
      otherNames: [],
      reportable: true
    },
    'RF-0207-001-PPP': {
      reference: 'RF-0207-001-PPP',
      name: 'Fluometuron',
      casNumber: '2164-17-2',
      otherNames: [],
      reportable: true
    },
    'RF-0208-001-PPP': {
      reference: 'RF-0208-001-PPP',
      name: 'Fluopicolide',
      casNumber: '239110-15-7',
      otherNames: [],
      reportable: true
    },
    'RF-0209-001-PPP': {
      reference: 'RF-0209-001-PPP',
      name: 'Fluoride ion',
      casNumber: '16984-48-8',
      otherNames: [],
      reportable: true
    },
    'RF-0210-001-PPP': {
      reference: 'RF-0210-001-PPP',
      name: 'Fluoroglycofene',
      casNumber: '77501-60-1',
      otherNames: [],
      reportable: true
    },
    'RF-0211-001-PPP': {
      reference: 'RF-0211-001-PPP',
      name: 'Fluoxastrobin',
      casNumber: '361377-29-9',
      otherNames: [
        '(E)-1-[2-[6-(2-chlorophenoxy)-5-fluoropyrimidin-4-yl]oxyphenyl]-1-(5,6-dihydro-1,4,2-dioxazin-3-yl)-N-methoxymethanimine'
      ],
      reportable: true
    },
    'RF-0212-001-PPP': {
      reference: 'RF-0212-001-PPP',
      name: 'Flupyrsulfuron-methyl',
      casNumber: '144740-54-5',
      otherNames: ['flupyrsulfuron-methyl-sodium'],
      reportable: true
    },
    'RF-0213-001-PPP': {
      reference: 'RF-0213-001-PPP',
      name: 'Fluquinconazole',
      casNumber: '136426-54-5',
      otherNames: [],
      reportable: true
    },
    'RF-0215-002-PPP': {
      reference: 'RF-0215-002-PPP',
      name: 'Fluroxypyr-Meptyl',
      casNumber: '81406-37-3',
      otherNames: [],
      reportable: true
    },
    'RF-0215-003-PPP': {
      reference: 'RF-0215-003-PPP',
      name: 'Fluroxypyr',
      casNumber: '69377-81-7',
      otherNames: [],
      reportable: true
    },
    'RF-0216-001-PPP': {
      reference: 'RF-0216-001-PPP',
      name: 'Flurprimidol',
      casNumber: '56425-91-3',
      otherNames: [],
      reportable: true
    },
    'RF-0217-001-PPP': {
      reference: 'RF-0217-001-PPP',
      name: 'Flurtamone',
      casNumber: '96525-23-4',
      otherNames: [],
      reportable: true
    },
    'RF-0218-001-PPP': {
      reference: 'RF-0218-001-PPP',
      name: 'Flusilazole',
      casNumber: '85509-19-9',
      otherNames: [],
      reportable: true
    },
    'RF-0218-002-PPP': {
      reference: 'RF-0218-002-PPP',
      name: 'Flusilazole (sum of flusilazole and its metabolite IN-F7321 ([bis-(4-fluorophenyl)methyl]silanol) expressed as flusilazole)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0219-001-PPP': {
      reference: 'RF-0219-001-PPP',
      name: 'Flutolanil',
      casNumber: '66332-96-5',
      otherNames: [],
      reportable: true
    },
    'RF-0220-001-PPP': {
      reference: 'RF-0220-001-PPP',
      name: 'Flutriafol',
      casNumber: '76674-21-0',
      otherNames: [],
      reportable: true
    },
    'RF-0221-001-PPP': {
      reference: 'RF-0221-001-PPP',
      name: 'Folpet',
      casNumber: '133-07-3',
      otherNames: [
        'N-(trichloromethylthio)phthalimide',
        '2-[(trichloromethyl)thio]-1H-isoindole-1,3(2H)-dione'
      ],
      reportable: true
    },
    'RF-0222-001-PPP': {
      reference: 'RF-0222-001-PPP',
      name: 'Foramsulfuron',
      casNumber: '173159-57-4',
      otherNames: [
        '1-(4,6-dimethoxypyrimidin-2-yl)-3-(2-dimethylcarbamoyl-5-formamidophenylsulfonyl)urea'
      ],
      reportable: true
    },
    'RF-0223-001-PPP': {
      reference: 'RF-0223-001-PPP',
      name: 'Formetanate: Sum of formetanate and its salts expressed as formetanate(hydrochloride)',
      casNumber: null,
      otherNames: [
        'Formetanate Sum of formetanate and its salts expressed as formetanate(hydrochloride)'
      ],
      reportable: true
    },
    'RF-0223-002-PPP': {
      reference: 'RF-0223-002-PPP',
      name: 'Formetanate',
      casNumber: '22259-30-9',
      otherNames: [],
      reportable: true
    },
    'RF-0224-001-PPP': {
      reference: 'RF-0224-001-PPP',
      name: 'Formothion',
      casNumber: '2540-82-1',
      otherNames: [],
      reportable: true
    },
    'RF-0225-001-PPP': {
      reference: 'RF-0225-001-PPP',
      name: 'Fosetyl-Al (sum of fosetyl, phosphonic acid and their salts, expressed as fosetyl)',
      casNumber: null,
      otherNames: [],
      reportable: true,
      //Le fosetyl a changé de définition le 29 avril 2025
      //
      // Avant: fosetyl-Al (somme du fosétyl, de l'acide phosphonique et de leurs sels, exprimée en fosétyl)
      // Après: acide phosphonique et ses sels, exprimés en acide phosphonique
      lmrCanBeOptional: true,
      deprecated: true
    },
    'RF-0226-001-PPP': {
      reference: 'RF-0226-001-PPP',
      name: 'Fosthiazate',
      casNumber: '98886-44-3',
      otherNames: [],
      reportable: true
    },
    'RF-0227-001-PPP': {
      reference: 'RF-0227-001-PPP',
      name: 'Fuberidazole',
      casNumber: '3878-19-1',
      otherNames: [],
      reportable: true
    },
    'RF-0228-001-PPP': {
      reference: 'RF-0228-001-PPP',
      name: 'Furathiocarb',
      casNumber: '65907-30-4',
      otherNames: [],
      reportable: true
    },
    'RF-0229-001-PPP': {
      reference: 'RF-0229-001-PPP',
      name: 'Furconazole',
      casNumber: '112839-33-5',
      otherNames: [],
      reportable: true
    },
    'RF-0230-001-PPP': {
      reference: 'RF-0230-001-PPP',
      name: 'Gibberellic acid',
      casNumber: '77-06-5',
      otherNames: [],
      reportable: true
    },
    'RF-0231-001-PPP': {
      reference: 'RF-0231-001-PPP',
      name: 'Glufosinate-ammonium',
      casNumber: '77182-82-2',
      otherNames: [],
      reportable: true
    },
    'RF-0232-001-PPP': {
      reference: 'RF-0232-001-PPP',
      name: 'Glufosinate (sum of glufosinate isomers, its salts and its metabolites 3-[hydroxy(methyl)phosphinoyl]propionic acid (MPP) and N-acetyl-glufosinate (NAG), expressed as glufosinate)',
      casNumber: null,
      otherNames: [
        'Glufosinate-ammonium (sum of glufosinate, its salts, MPP and NAG expressed as glufosinate equivalents)'
      ],
      reportable: true
    },
    'RF-0233-001-PPP': {
      reference: 'RF-0233-001-PPP',
      name: 'Guazatine',
      casNumber: '13516-27-3',
      otherNames: [],
      reportable: true
    },
    'RF-0234-001-PPP': {
      reference: 'RF-0234-001-PPP',
      name: 'Halosulfuron methyl',
      casNumber: '100784-20-1',
      otherNames: [],
      reportable: true
    },
    'RF-0235-002-PPP': {
      reference: 'RF-0235-002-PPP',
      name: 'Haloxyfop-Methyl',
      casNumber: '69806-40-2',
      otherNames: [],
      reportable: true
    },
    'RF-0235-003-PPP': {
      reference: 'RF-0235-003-PPP',
      name: 'Haloxyfop-Ethoxyethylester',
      casNumber: '87237-48-7',
      otherNames: [],
      reportable: true
    },
    'RF-0235-004-PPP': {
      reference: 'RF-0235-004-PPP',
      name: 'Haloxyfop',
      casNumber: '69806-34-4',
      otherNames: [],
      reportable: true
    },
    'RF-0235-006-PPP': {
      reference: 'RF-0235-006-PPP',
      name: 'Haloxyfop-P',
      casNumber: '95977-29-0',
      otherNames: [],
      reportable: true
    },
    'RF-0235-007-PPP': {
      reference: 'RF-0235-007-PPP',
      name: 'Haloxyfop-P-methyl',
      casNumber: '72619-32-0',
      otherNames: [],
      reportable: true
    },
    'RF-0236-001-PPP': {
      reference: 'RF-0236-001-PPP',
      name: 'Heptachlor (sum of heptachlor and heptachlor epoxide expressed as heptachlor)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0236-004-PPP': {
      reference: 'RF-0236-004-PPP',
      name: 'Heptachlor',
      casNumber: '76-44-8',
      otherNames: [],
      reportable: true
    },
    'RF-0236-005-PPP': {
      reference: 'RF-0236-005-PPP',
      name: 'Heptachlor epoxide',
      casNumber: '1024-57-3',
      otherNames: [],
      reportable: true
    },
    'RF-0236-007-PPP': {
      reference: 'RF-0236-007-PPP',
      name: 'Heptachlor endo-epoxide',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0236-008-PPP': {
      reference: 'RF-0236-008-PPP',
      name: 'Heptachlor exo-epoxide',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0237-001-PPP': {
      reference: 'RF-0237-001-PPP',
      name: 'Hexachlorobenzene',
      casNumber: '118-74-1',
      otherNames: [],
      reportable: true
    },
    'RF-0238-001-PPP': {
      reference: 'RF-0238-001-PPP',
      name: 'Hexachlorocyclohexane (HCH), alpha-isomer',
      casNumber: '319-84-6',
      otherNames: [],
      reportable: true
    },
    'RF-0239-002-PPP': {
      reference: 'RF-0239-002-PPP',
      name: 'Hexachlorocyclohexane (HCH), beta-isomer',
      casNumber: '319-85-7',
      otherNames: [],
      reportable: true
    },
    'RF-0240-004-PPP': {
      reference: 'RF-0240-004-PPP',
      name: 'HCH-epsilon',
      casNumber: '6108-10-7',
      otherNames: [],
      reportable: true
    },
    'RF-0241-001-PPP': {
      reference: 'RF-0241-001-PPP',
      name: 'Hexaconazole',
      casNumber: '79983-71-4',
      otherNames: [],
      reportable: true
    },
    'RF-0243-001-PPP': {
      reference: 'RF-0243-001-PPP',
      name: 'Hydrogen cyanide (cyanides expressed as hydrogen cyanide)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0245-001-PPP': {
      reference: 'RF-0245-001-PPP',
      name: 'Hymexazol',
      casNumber: '10004-44-1',
      otherNames: [],
      reportable: true
    },
    'RF-0246-001-PPP': {
      reference: 'RF-0246-001-PPP',
      name: 'Imazalil',
      casNumber: '35554-44-0',
      otherNames: [],
      reportable: true
    },
    'RF-0247-001-PPP': {
      reference: 'RF-0247-001-PPP',
      name: 'Imazamox (sum of imazamox and its salts, expressed as imazamox)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0248-001-PPP': {
      reference: 'RF-0248-001-PPP',
      name: 'Imazaquin',
      casNumber: '81335-37-7',
      otherNames: [],
      reportable: true
    },
    'RF-0249-001-PPP': {
      reference: 'RF-0249-001-PPP',
      name: 'Imazosulfuron',
      casNumber: '122548-33-8',
      otherNames: [],
      reportable: true
    },
    'RF-0250-001-PPP': {
      reference: 'RF-0250-001-PPP',
      name: 'Imidacloprid',
      casNumber: '138261-41-3',
      otherNames: [],
      reportable: true
    },
    'RF-0251-001-PPP': {
      reference: 'RF-0251-001-PPP',
      name: 'Indoxacarb (sum of indoxacarb and its R enantiomer)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0252-001-PPP': {
      reference: 'RF-0252-001-PPP',
      name: 'Iodosulfuron-methyl (iodosulfuron-methyl including salts, expressed as iodosulfuron-methyl)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0253-003-PPP': {
      reference: 'RF-0253-003-PPP',
      name: 'Ioxynil octanoate',
      casNumber: '3861-47-0',
      otherNames: [],
      reportable: true
    },
    'RF-0254-001-PPP': {
      reference: 'RF-0254-001-PPP',
      name: 'Ipconazole',
      casNumber: '125225-28-7',
      otherNames: [
        '(1RS,2SR,5RS;1RS,2SR,5SR)-2-(4-chlorobenzyl)-5-isopropyl-1-(1H-1,2,4-triazol-1-ylmethyl)cyclopentanol'
      ],
      reportable: true
    },
    'RF-0255-001-PPP': {
      reference: 'RF-0255-001-PPP',
      name: 'Iprodione',
      casNumber: '36734-19-7',
      otherNames: [],
      reportable: true
    },
    'RF-0256-001-PPP': {
      reference: 'RF-0256-001-PPP',
      name: 'Iprovalicarb',
      casNumber: '140923-17-7',
      otherNames: [
        'isopropyl [(2S)-3-methyl-1-{[1-(4-methylphenyl)ethyl]amino}-1-oxobutan-2-yl]carbamate'
      ],
      reportable: true
    },
    'RF-0257-001-PPP': {
      reference: 'RF-0257-001-PPP',
      name: 'Isoproturon',
      casNumber: '34123-59-6',
      otherNames: [],
      reportable: true
    },
    'RF-0258-001-PPP': {
      reference: 'RF-0258-001-PPP',
      name: 'Isoxaben',
      casNumber: '82558-50-7',
      otherNames: [],
      reportable: true
    },
    'RF-0259-001-PPP': {
      reference: 'RF-0259-001-PPP',
      name: 'Isoxaflutole (sum of isoxaflutole and its diketonitrile-metabolite, expressed as isoxaflutole)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0259-002-PPP': {
      reference: 'RF-0259-002-PPP',
      name: 'Isoxaflutole',
      casNumber: '141112-29-0',
      otherNames: [
        '(5-cyclopropyl-4-isoxazolyl)[2-(methylsulfonyl)-4-(trifluoromethyl)phenyl]methanone'
      ],
      reportable: true
    },
    'RF-0260-001-PPP': {
      reference: 'RF-0260-001-PPP',
      name: 'Kresoxim-methyl',
      casNumber: '143390-89-0',
      otherNames: [],
      reportable: true
    },
    'RF-0260-002-PPP': {
      reference: 'RF-0260-002-PPP',
      name: 'Kresoxim methyl (BF-490-9 (2-[2-(4-hydroxy-2-methylphenoxymethyl)phenyl]-2-methoxy-iminoacetic acid), expressed as parent)',
      casNumber: null,
      otherNames: [
        '490M9 (2-[2-(4-hydroxy-2-methylphenoxymethyl)phenyl]-2-methoxy-iminoacetic acid), expressed as kresoxim-methyl)'
      ],
      reportable: true
    },
    'RF-0262-001-PPP': {
      reference: 'RF-0262-001-PPP',
      name: 'Lenacil',
      casNumber: '2164-08-1',
      otherNames: [
        '3-cyclohexyl-1,5,6,7-tetrahydrocyclopentapyrimidine-2,4(3H)-dione',
        '3-cyclohexyl-6,7-dihydro-1H-cyclopentapyrimidine-2,4(3H,5H)-dione'
      ],
      reportable: true
    },
    'RF-0263-001-PPP': {
      reference: 'RF-0263-001-PPP',
      name: 'Lindane (Gamma-isomer of hexachlorocyclohexane (HCH))',
      casNumber: '58-89-9',
      otherNames: ['Lindane (Gamma-isomer of hexachlorociclohexane (HCH))'],
      reportable: true
    },
    'RF-0264-001-PPP': {
      reference: 'RF-0264-001-PPP',
      name: 'Linuron',
      casNumber: '330-55-2',
      otherNames: [],
      reportable: true
    },
    'RF-0265-001-PPP': {
      reference: 'RF-0265-001-PPP',
      name: 'Lufenuron (any ratio of constituent isomers)',
      casNumber: null,
      otherNames: ['Lufenuron'],
      reportable: true
    },
    'RF-0266-001-PPP': {
      reference: 'RF-0266-001-PPP',
      name: 'Malathion (sum of malathion and malaoxon expressed as malathion)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0266-002-PPP': {
      reference: 'RF-0266-002-PPP',
      name: 'Malaoxon',
      casNumber: '1634-78-2',
      otherNames: [],
      reportable: true
    },
    'RF-0266-003-PPP': {
      reference: 'RF-0266-003-PPP',
      name: 'Malathion',
      casNumber: '121-75-5',
      otherNames: [],
      reportable: true
    },
    'RF-0267-001-PPP': {
      reference: 'RF-0267-001-PPP',
      name: 'Maleic hydrazide',
      casNumber: '123-33-1',
      otherNames: [],
      reportable: true
    },
    'RF-0271-001-PPP': {
      reference: 'RF-0271-001-PPP',
      name: 'MCPA, Butotyl-',
      casNumber: '19480-43-4',
      otherNames: [],
      reportable: true
    },
    'RF-0271-002-PPP': {
      reference: 'RF-0271-002-PPP',
      name: 'MCPB',
      casNumber: '94-81-5',
      otherNames: [],
      reportable: true
    },
    'RF-0271-003-PPP': {
      reference: 'RF-0271-003-PPP',
      name: 'MCPA, 2-Ethylhexyl-',
      casNumber: '29450-45-1',
      otherNames: [],
      reportable: true
    },
    'RF-0271-004-PPP': {
      reference: 'RF-0271-004-PPP',
      name: 'MCPA and MCPB (MCPA, MCPB including their salts, esters and conjugates expressed as MCPA)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0271-005-PPP': {
      reference: 'RF-0271-005-PPP',
      name: 'MCPA',
      casNumber: '94-74-6',
      otherNames: [],
      reportable: true
    },
    'RF-0271-006-PPP': {
      reference: 'RF-0271-006-PPP',
      name: 'MCPA, MCPB and MCPA thioethyl expressed as MCPA',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0271-007-PPP': {
      reference: 'RF-0271-007-PPP',
      name: 'MCPA-methyl',
      casNumber: '2436-73-9',
      otherNames: [],
      reportable: true
    },
    'RF-0272-001-PPP': {
      reference: 'RF-0272-001-PPP',
      name: 'Mecarbam',
      casNumber: '2595-54-2',
      otherNames: [],
      reportable: true
    },
    'RF-0273-001-PPP': {
      reference: 'RF-0273-001-PPP',
      name: 'Mecoprop (sum of mecoprop-p and mecoprop expressed as mecoprop)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0274-002-PPP': {
      reference: 'RF-0274-002-PPP',
      name: 'Mepanipyrim',
      casNumber: '110235-47-7',
      otherNames: [],
      reportable: true
    },
    'RF-0274-003-PPP': {
      reference: 'RF-0274-003-PPP',
      name: '2-anilino-4-(2-hydroxypropyl)- 6-methylpyrimidin',
      casNumber: '204571-52-8',
      otherNames: [],
      reportable: true
    },
    'RF-0276-001-PPP': {
      reference: 'RF-0276-001-PPP',
      name: 'Meptyldinocap (sum of 2,4 DNOPC and 2,4 DNOP expressed as meptyldinocap)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0277-001-PPP': {
      reference: 'RF-0277-001-PPP',
      name: 'Mercury compounds (sum of mercury compounds expressed as mercury)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0278-003-PPP': {
      reference: 'RF-0278-003-PPP',
      name: 'Mesosulfuron-methyl',
      casNumber: '208465-21-8',
      otherNames: [],
      reportable: true
    },
    'RF-0280-001-PPP': {
      reference: 'RF-0280-001-PPP',
      name: 'Metaflumizone (sum of E- and Z- isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0281-001-PPP': {
      reference: 'RF-0281-001-PPP',
      name: 'Metalaxyl and metalaxyl-M (metalaxyl including other mixtures of constituent isomers including metalaxyl-M (sum of isomers)',
      casNumber: null,
      otherNames: [
        'Metalaxyl including other mixtures of constituent isomers including metalaxyl-M (sum of isomers)'
      ],
      reportable: true
    },
    'RF-0282-001-PPP': {
      reference: 'RF-0282-001-PPP',
      name: 'Metaldehyde',
      casNumber: '108-62-3',
      otherNames: [],
      reportable: true
    },
    'RF-0284-001-PPP': {
      reference: 'RF-0284-001-PPP',
      name: 'Metamitron',
      casNumber: '41394-05-2',
      otherNames: [],
      reportable: true
    },
    'RF-0285-001-PPP': {
      reference: 'RF-0285-001-PPP',
      name: 'Metazachlor',
      casNumber: '67129-08-2',
      otherNames: [],
      reportable: true
    },
    'RF-0286-001-PPP': {
      reference: 'RF-0286-001-PPP',
      name: 'Metconazole (sum of isomers)',
      casNumber: null,
      otherNames: [
        'Metconazole',
        '(1,5)-5-[(4-chlorophenyl)methyl]-2,2-dimethyl-1-(1H-1,2,4-triazol-1-ylmethyl)cyclopentan-1-ol',
        '5-[(4-chlorophenyl)methyl]-2,2-dimethyl-1-(1H-1,2,4-triazol-1-ylmethyl)cyclopentanol'
      ],
      reportable: true
    },
    'RF-0287-001-PPP': {
      reference: 'RF-0287-001-PPP',
      name: 'Methabenzthiazuron',
      casNumber: '18691-97-9',
      otherNames: [],
      reportable: true
    },
    'RF-0288-001-PPP': {
      reference: 'RF-0288-001-PPP',
      name: 'Methacrifos',
      casNumber: '62610-77-9',
      otherNames: [],
      reportable: true
    },
    'RF-0289-001-PPP': {
      reference: 'RF-0289-001-PPP',
      name: 'Methamidophos',
      casNumber: '10265-92-6',
      otherNames: [],
      reportable: true
    },
    'RF-0290-001-PPP': {
      reference: 'RF-0290-001-PPP',
      name: 'Methidathion',
      casNumber: '950-37-8',
      otherNames: [],
      reportable: true
    },
    'RF-0291-001-PPP': {
      reference: 'RF-0291-001-PPP',
      name: 'Methiocarb (sum of methiocarb and methiocarb sulfoxide and sulfone, expressed as methiocarb)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0291-002-PPP': {
      reference: 'RF-0291-002-PPP',
      name: 'Methiocarb',
      casNumber: '2032-65-7',
      otherNames: [],
      reportable: true
    },
    'RF-0291-003-PPP': {
      reference: 'RF-0291-003-PPP',
      name: 'Methiocarb-Sulfoxid',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0291-004-PPP': {
      reference: 'RF-0291-004-PPP',
      name: 'Methiocarb-Sulfon',
      casNumber: '2179-25-1',
      otherNames: [],
      reportable: true
    },
    'RF-0293-002-PPP': {
      reference: 'RF-0293-002-PPP',
      name: 'Thiodicarb',
      casNumber: '59669-26-0',
      otherNames: [],
      reportable: true
    },
    'RF-0293-003-PPP': {
      reference: 'RF-0293-003-PPP',
      name: 'Methomyl',
      casNumber: '16752-77-5',
      otherNames: [],
      reportable: true
    },
    'RF-0294-001-PPP': {
      reference: 'RF-0294-001-PPP',
      name: 'Methoprene',
      casNumber: '40596-69-8',
      otherNames: [],
      reportable: true
    },
    'RF-0295-001-PPP': {
      reference: 'RF-0295-001-PPP',
      name: 'Methoxychlor',
      casNumber: '72-43-5',
      otherNames: [],
      reportable: true
    },
    'RF-0296-001-PPP': {
      reference: 'RF-0296-001-PPP',
      name: 'Methoxyfenozide',
      casNumber: '161050-58-4',
      otherNames: [],
      reportable: true
    },
    'RF-0298-001-PPP': {
      reference: 'RF-0298-001-PPP',
      name: 'Metosulam',
      casNumber: '139528-85-1',
      otherNames: [],
      reportable: true
    },
    'RF-0299-001-PPP': {
      reference: 'RF-0299-001-PPP',
      name: 'Metrafenone',
      casNumber: '220899-03-6',
      otherNames: [
        '(3-Bromo-6-methoxy-2-methylphenyl)-(2,3,4-trimethoxy-6-methylphenyl)methanone'
      ],
      reportable: true
    },
    'RF-0300-001-PPP': {
      reference: 'RF-0300-001-PPP',
      name: 'Metribuzin',
      casNumber: '21087-64-9',
      otherNames: [
        '4-amino-6-tert-butyl-3-methylthio-1,2,4-triazin-5(4H)-one',
        '4-amino-6-tert-butyl-3-(methylsulfanyl)-1,2,4-triazin-5(4H)-one',
        '4-amino-6-(1,1-dimethylethyl)-3-(methylthio)-1,2,4-triazin-5(4H)-one'
      ],
      reportable: true
    },
    'RF-0301-001-PPP': {
      reference: 'RF-0301-001-PPP',
      name: 'Metsulfuron-methyl',
      casNumber: '74223-64-6',
      otherNames: [],
      reportable: true
    },
    'RF-0302-001-PPP': {
      reference: 'RF-0302-001-PPP',
      name: 'Mevinphos (sum of E- and Z-isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0303-002-PPP': {
      reference: 'RF-0303-002-PPP',
      name: 'Milbemectin A3',
      casNumber: '51596-10-2',
      otherNames: [],
      reportable: true
    },
    'RF-0303-003-PPP': {
      reference: 'RF-0303-003-PPP',
      name: 'Milbemectin A4',
      casNumber: '51596-11-3',
      otherNames: [],
      reportable: true
    },
    'RF-0304-001-PPP': {
      reference: 'RF-0304-001-PPP',
      name: 'Molinate',
      casNumber: '2212-67-1',
      otherNames: [],
      reportable: true
    },
    'RF-0305-001-PPP': {
      reference: 'RF-0305-001-PPP',
      name: 'Monocrotophos',
      casNumber: '6923-22-4',
      otherNames: [],
      reportable: true
    },
    'RF-0306-001-PPP': {
      reference: 'RF-0306-001-PPP',
      name: 'Monolinuron',
      casNumber: '1746-81-2',
      otherNames: [],
      reportable: true
    },
    'RF-0307-001-PPP': {
      reference: 'RF-0307-001-PPP',
      name: 'Monuron',
      casNumber: '150-68-5',
      otherNames: [],
      reportable: true
    },
    'RF-0310-001-PPP': {
      reference: 'RF-0310-001-PPP',
      name: 'Nicosulfuron',
      casNumber: '111991-09-4',
      otherNames: [],
      reportable: true
    },
    'RF-0311-001-PPP': {
      reference: 'RF-0311-001-PPP',
      name: 'Nitrofen',
      casNumber: '1836-75-5',
      otherNames: [],
      reportable: true
    },
    'RF-0312-001-PPP': {
      reference: 'RF-0312-001-PPP',
      name: 'Norflurazon',
      casNumber: '27314-13-2',
      otherNames: [],
      reportable: true
    },
    'RF-0313-001-PPP': {
      reference: 'RF-0313-001-PPP',
      name: 'Novaluron',
      casNumber: '116714-46-6',
      otherNames: [
        '(RS)-1-[3-chloro-4-(1,1,2-trifluoro-2-trifluoromethoxyethoxy)phenyl]-3-(2,6-difluorobenzoyl)urea'
      ],
      reportable: false
    },
    'RF-0315-001-PPP': {
      reference: 'RF-0315-001-PPP',
      name: 'Orthosulfamuron',
      casNumber: '213464-77-8',
      otherNames: [],
      reportable: true
    },
    'RF-0316-001-PPP': {
      reference: 'RF-0316-001-PPP',
      name: 'Oryzalin',
      casNumber: '19044-88-3',
      otherNames: [],
      reportable: true
    },
    'RF-0317-001-PPP': {
      reference: 'RF-0317-001-PPP',
      name: 'Oxadiargyl',
      casNumber: '39807-15-3',
      otherNames: [],
      reportable: true
    },
    'RF-0318-001-PPP': {
      reference: 'RF-0318-001-PPP',
      name: 'Oxadiazon',
      casNumber: '19666-30-9',
      otherNames: [],
      reportable: true
    },
    'RF-0319-001-PPP': {
      reference: 'RF-0319-001-PPP',
      name: 'Oxadixyl',
      casNumber: '77732-09-3',
      otherNames: [],
      reportable: true
    },
    'RF-0320-001-PPP': {
      reference: 'RF-0320-001-PPP',
      name: 'Oxamyl',
      casNumber: '23135-22-0',
      otherNames: [
        'methyl (1Ξ)-2-(dimethylamino)-N-[(methylcarbamoyl)oxy]-2-oxoethanimidothioate',
        'methyl 2-(dimethylamino)-N-[[(methylamino)carbonyl]oxy]-2-oxoethanimidothioate'
      ],
      reportable: true
    },
    'RF-0321-001-PPP': {
      reference: 'RF-0321-001-PPP',
      name: 'Oxasulfuron',
      casNumber: '144651-06-9',
      otherNames: [
        '3-oxetanyl 2-[[[[(4,6-dimethyl-2-pyrimidinyl)amino]carbonyl]amino]sulfonyl]benzoate'
      ],
      reportable: true
    },
    'RF-0322-001-PPP': {
      reference: 'RF-0322-001-PPP',
      name: 'Oxycarboxin',
      casNumber: '5259-88-1',
      otherNames: [],
      reportable: true
    },
    'RF-0323-001-PPP': {
      reference: 'RF-0323-001-PPP',
      name: 'Oxydemeton-methyl (sum of oxydemeton-methyl and demeton-S-methylsulfone expressed as oxydemeton-methyl)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0323-003-PPP': {
      reference: 'RF-0323-003-PPP',
      name: 'Demeton-S-Methylsulfone',
      casNumber: '17040-19-6',
      otherNames: [],
      reportable: true
    },
    'RF-0323-004-PPP': {
      reference: 'RF-0323-004-PPP',
      name: 'Oxydemeton-methyl',
      casNumber: '301-12-2',
      otherNames: [],
      reportable: true
    },
    'RF-0324-001-PPP': {
      reference: 'RF-0324-001-PPP',
      name: 'Oxyfluorfen',
      casNumber: '42874-03-3',
      otherNames: [],
      reportable: true
    },
    'RF-0326-001-PPP': {
      reference: 'RF-0326-001-PPP',
      name: 'Paraquat',
      casNumber: '4685-14-7',
      otherNames: [],
      reportable: true
    },
    'RF-0327-001-PPP': {
      reference: 'RF-0327-001-PPP',
      name: 'Parathion',
      casNumber: '56-38-2',
      otherNames: [],
      reportable: true
    },
    'RF-0328-001-PPP': {
      reference: 'RF-0328-001-PPP',
      name: 'Parathion-methyl (sum of Parathion-methyl and paraoxon-methyl expressed as Parathion-methyl)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0328-002-PPP': {
      reference: 'RF-0328-002-PPP',
      name: 'Paraoxon-Methyl',
      casNumber: '950-35-6',
      otherNames: [],
      reportable: true
    },
    'RF-0328-003-PPP': {
      reference: 'RF-0328-003-PPP',
      name: 'Parathion-methyl',
      casNumber: '298-00-0',
      otherNames: [],
      reportable: true
    },
    'RF-0329-001-PPP': {
      reference: 'RF-0329-001-PPP',
      name: 'Penconazole (sum of constituent isomers)',
      casNumber: null,
      otherNames: ['Penconazole'],
      reportable: true
    },
    'RF-0330-001-PPP': {
      reference: 'RF-0330-001-PPP',
      name: 'Pencycuron',
      casNumber: '66063-05-6',
      otherNames: [],
      reportable: true
    },
    'RF-0331-001-PPP': {
      reference: 'RF-0331-001-PPP',
      name: 'Pendimethalin',
      casNumber: '40487-42-1',
      otherNames: [],
      reportable: true
    },
    'RF-0332-001-PPP': {
      reference: 'RF-0332-001-PPP',
      name: 'Penoxsulam',
      casNumber: '219714-96-2',
      otherNames: [],
      reportable: true
    },
    'RF-0333-001-PPP': {
      reference: 'RF-0333-001-PPP',
      name: 'Pethoxamid',
      casNumber: '106700-29-2',
      otherNames: [],
      reportable: true
    },
    'RF-0334-001-PPP': {
      reference: 'RF-0334-001-PPP',
      name: 'Phenmedipham',
      casNumber: '13684-63-4',
      otherNames: [],
      reportable: true
    },
    'RF-0335-001-PPP': {
      reference: 'RF-0335-001-PPP',
      name: 'Phenothrin (phenothrin including other mixtures of constituent isomers (sum of isomers))',
      casNumber: '26002-80-2',
      otherNames: ['Phenothrin'],
      reportable: true
    },
    'RF-0336-001-PPP': {
      reference: 'RF-0336-001-PPP',
      name: 'Phorate (sum of phorate, its oxygen analogue and their sulfones expressed as phorate)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0336-002-PPP': {
      reference: 'RF-0336-002-PPP',
      name: 'Phorate-Sulfon',
      casNumber: '2588-04-7',
      otherNames: [],
      reportable: true
    },
    'RF-0336-003-PPP': {
      reference: 'RF-0336-003-PPP',
      name: 'Phorate',
      casNumber: '298-02-2',
      otherNames: [],
      reportable: true
    },
    'RF-0336-004-PPP': {
      reference: 'RF-0336-004-PPP',
      name: 'Phorate-Sulfoxid',
      casNumber: '2588-03-6',
      otherNames: [],
      reportable: true
    },
    'RF-0336-005-PPP': {
      reference: 'RF-0336-005-PPP',
      name: 'Phorate-O-analogue',
      casNumber: '2600-69-3',
      otherNames: [],
      reportable: true
    },
    'RF-0336-006-PPP': {
      reference: 'RF-0336-006-PPP',
      name: 'Phorate-oxonsulfone',
      casNumber: '2588-06-9',
      otherNames: [],
      reportable: true
    },
    'RF-0336-007-PPP': {
      reference: 'RF-0336-007-PPP',
      name: 'Phorate-oxonsulfoxid',
      casNumber: '2588-05-8',
      otherNames: [],
      reportable: true
    },
    'RF-0337-001-PPP': {
      reference: 'RF-0337-001-PPP',
      name: 'Phosalone',
      casNumber: '2310-17-0',
      otherNames: [],
      reportable: true
    },
    'RF-0338-001-PPP': {
      reference: 'RF-0338-001-PPP',
      name: 'Phosmet (phosmet and phosmet oxon expressed as phosmet)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0338-002-PPP': {
      reference: 'RF-0338-002-PPP',
      name: 'Phosmet',
      casNumber: '732-11-6',
      otherNames: [
        'O,O-dimethyl S-phthalimidomethyl phosphorodithioate',
        'N-(dimethoxyphosphinothioylthiomethyl)phthalimide',
        'S-[(1,3-dihydro-1,3-dioxo-2H-isoindol-2-yl)methyl] O,O-dimethyl phosphorodithioate'
      ],
      reportable: true
    },
    'RF-0338-003-PPP': {
      reference: 'RF-0338-003-PPP',
      name: 'Phosmet oxon',
      casNumber: '3735-33-9',
      otherNames: [],
      reportable: true
    },
    'RF-0339-001-PPP': {
      reference: 'RF-0339-001-PPP',
      name: 'Phosphamidon',
      casNumber: '13171-21-6',
      otherNames: [],
      reportable: true
    },
    'RF-0342-001-PPP': {
      reference: 'RF-0342-001-PPP',
      name: 'Phoxim',
      casNumber: '14816-18-3',
      otherNames: [],
      reportable: true
    },
    'RF-0343-001-PPP': {
      reference: 'RF-0343-001-PPP',
      name: 'Picloram',
      casNumber: '1918-02-1',
      otherNames: [],
      reportable: true
    },
    'RF-0344-001-PPP': {
      reference: 'RF-0344-001-PPP',
      name: 'Picolinafen',
      casNumber: '137641-05-5',
      otherNames: [],
      reportable: true
    },
    'RF-0345-001-PPP': {
      reference: 'RF-0345-001-PPP',
      name: 'Picoxystrobin',
      casNumber: '117428-22-5',
      otherNames: [],
      reportable: true
    },
    'RF-0346-001-PPP': {
      reference: 'RF-0346-001-PPP',
      name: 'Pinoxaden',
      casNumber: '243973-20-8',
      otherNames: [],
      reportable: false
    },
    'RF-0347-001-PPP': {
      reference: 'RF-0347-001-PPP',
      name: 'Pirimicarb (sum of Pirimicarb and Desmethyl pirimicarb expressed as Pirimicarb)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0347-002-PPP': {
      reference: 'RF-0347-002-PPP',
      name: 'Pirimicarb',
      casNumber: '23103-98-2',
      otherNames: [
        '2-dimethylamino-5,6-dimethylpyrimidin-4-yl dimethylcarbamate',
        '2-(dimethylamino)-5,6-dimethyl-4-pyrimidinyl N,N-dimethylcarbamate'
      ],
      reportable: true
    },
    'RF-0347-003-PPP': {
      reference: 'RF-0347-003-PPP',
      name: 'Desmethyl Pirimicarb',
      casNumber: '30614-22-3',
      otherNames: [],
      reportable: true
    },
    'RF-0348-001-PPP': {
      reference: 'RF-0348-001-PPP',
      name: 'Pirimiphos-methyl',
      casNumber: '29232-93-7',
      otherNames: [
        'O-2-diethylamino-6-methylpyrimidin-4-yl O,O-dimethyl phosphorothioate',
        'O-[2-(diethylamino)-6-methyl-4-pyrimidinyl] O,O-dimethyl phosphorothioate'
      ],
      reportable: true
    },
    'RF-0349-002-PPP': {
      reference: 'RF-0349-002-PPP',
      name: 'Prochloraz',
      casNumber: '67747-09-5',
      otherNames: [
        'N-propyl-N-[2-(2,4,6-trichlorophenoxy)ethyl]imidazole-1-carboxamide'
      ],
      reportable: true
    },
    'RF-0350-001-PPP': {
      reference: 'RF-0350-001-PPP',
      name: 'Procymidone',
      casNumber: '32809-16-8',
      otherNames: [],
      reportable: true
    },
    'RF-0351-001-PPP': {
      reference: 'RF-0351-001-PPP',
      name: 'Profenofos',
      casNumber: '41198-08-7',
      otherNames: [],
      reportable: true
    },
    'RF-0352-001-PPP': {
      reference: 'RF-0352-001-PPP',
      name: 'Prohexadione (prohexadione (acid) and its salts expressed as prohexadione-calcium)',
      casNumber: null,
      otherNames: [
        "'Prohexadione (prohexadione (acid) and its salts expressed as prohexadione-calcium)"
      ],
      reportable: true
    },
    'RF-0353-001-PPP': {
      reference: 'RF-0353-001-PPP',
      name: 'Propachlor: oxalinic derivate of propachlor, expressed as propachlor',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0354-001-PPP': {
      reference: 'RF-0354-001-PPP',
      name: 'Propamocarb (Sum of propamocarb and its salts, expressed as propamocarb)',
      casNumber: null,
      otherNames: [
        'Propamocarb (Sum of propamocarb and its salt expressed as propamocarb)'
      ],
      reportable: true
    },
    'RF-0354-003-PPP': {
      reference: 'RF-0354-003-PPP',
      name: 'N-desmethyl propamocarb',
      casNumber: '1392231-41-2',
      otherNames: [],
      reportable: true
    },
    'RF-0355-001-PPP': {
      reference: 'RF-0355-001-PPP',
      name: 'Propanil',
      casNumber: '709-98-8',
      otherNames: ['3′,4′-dichloropropionanilide'],
      reportable: true
    },
    'RF-0356-001-PPP': {
      reference: 'RF-0356-001-PPP',
      name: 'Propaquizafop',
      casNumber: '111479-05-1',
      otherNames: [],
      reportable: true
    },
    'RF-0357-001-PPP': {
      reference: 'RF-0357-001-PPP',
      name: 'Propargite',
      casNumber: '2312-35-8',
      otherNames: [],
      reportable: true
    },
    'RF-0358-001-PPP': {
      reference: 'RF-0358-001-PPP',
      name: 'Propiconazole (sum of isomers)',
      casNumber: null,
      otherNames: ['Propiconazole'],
      reportable: true
    },
    'RF-0359-001-PPP': {
      reference: 'RF-0359-001-PPP',
      name: 'Propineb (expressed as propilendiamine)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0360-001-PPP': {
      reference: 'RF-0360-001-PPP',
      name: 'Propisochlor',
      casNumber: '86763-47-5',
      otherNames: [],
      reportable: true
    },
    'RF-0361-001-PPP': {
      reference: 'RF-0361-001-PPP',
      name: 'Propoxur',
      casNumber: '114-26-1',
      otherNames: [],
      reportable: true
    },
    'RF-0362-001-PPP': {
      reference: 'RF-0362-001-PPP',
      name: 'Propoxycarbazone (propoxycarbazone, its salts and 2-hydroxy-propoxy-propoxycarbazone, calculated as propoxycarbazone)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0362-002-PPP': {
      reference: 'RF-0362-002-PPP',
      name: 'Propoxycarbazone',
      casNumber: '145026-81-9',
      otherNames: [],
      reportable: true
    },
    'RF-0363-001-PPP': {
      reference: 'RF-0363-001-PPP',
      name: 'Propyl-3-t-butylphenoxyacetate',
      casNumber: '66227-09-6',
      otherNames: [],
      reportable: true
    },
    'RF-0364-001-PPP': {
      reference: 'RF-0364-001-PPP',
      name: 'Propyzamide',
      casNumber: '23950-58-5',
      otherNames: [],
      reportable: true
    },
    'RF-0364-002-PPP': {
      reference: 'RF-0364-002-PPP',
      name: 'Propyzamide (sum of propyzamide and all metabolites containing the 3,5-dichlorobenzoic acid fraction expressed as propyzamide)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0365-001-PPP': {
      reference: 'RF-0365-001-PPP',
      name: 'Proquinazid',
      casNumber: '189278-12-4',
      otherNames: [],
      reportable: true
    },
    'RF-0366-001-PPP': {
      reference: 'RF-0366-001-PPP',
      name: 'Prosulfocarb',
      casNumber: '52888-80-9',
      otherNames: [],
      reportable: true
    },
    'RF-0367-001-PPP': {
      reference: 'RF-0367-001-PPP',
      name: 'Prosulfuron',
      casNumber: '94125-34-5',
      otherNames: [
        'N-[(4-methoxy-6-methyl-1,3,5-triazin-2-yl)carbamoyl]-2-(3,3,3-trifluoropropyl)benzene-1-sulfonamide'
      ],
      reportable: true
    },
    'RF-0369-001-PPP': {
      reference: 'RF-0369-001-PPP',
      name: 'Pymetrozine',
      casNumber: '123312-89-0',
      otherNames: [],
      reportable: true
    },
    'RF-0370-001-PPP': {
      reference: 'RF-0370-001-PPP',
      name: 'Pyraclostrobin',
      casNumber: '175013-18-0',
      otherNames: [
        'methyl 2-[1-(4-chlorophenyl)-1H-pyrazol-3-yloxymethyl]-N-methoxycarbanilate',
        'methyl N-[2-[[[1-(4-chlorophenyl)-1H-pyrazol-3-yl]oxy]methyl]phenyl]-N-methoxycarbamate'
      ],
      reportable: true
    },
    'RF-0371-001-PPP': {
      reference: 'RF-0371-001-PPP',
      name: 'Pyraflufen-ethyl',
      casNumber: '129630-19-9',
      otherNames: [],
      reportable: true
    },
    'RF-0372-001-PPP': {
      reference: 'RF-0372-001-PPP',
      name: 'Pyrasulfotole',
      casNumber: '365400-11-9',
      otherNames: [],
      reportable: true
    },
    'RF-0373-001-PPP': {
      reference: 'RF-0373-001-PPP',
      name: 'Pyrazophos',
      casNumber: '13457-18-6',
      otherNames: [],
      reportable: true
    },
    'RF-0374-001-PPP': {
      reference: 'RF-0374-001-PPP',
      name: 'Pyrethrins',
      casNumber: '8003-34-7',
      otherNames: [],
      reportable: true
    },
    'RF-0374-002-PPP': {
      reference: 'RF-0374-002-PPP',
      name: 'Pyrethrin I',
      casNumber: '121-21-1',
      otherNames: [],
      reportable: true
    },
    'RF-0374-003-PPP': {
      reference: 'RF-0374-003-PPP',
      name: 'Pyrethrin II',
      casNumber: '121-29-9',
      otherNames: [],
      reportable: true
    },
    'RF-0374-004-PPP': {
      reference: 'RF-0374-004-PPP',
      name: 'Jasmolin I',
      casNumber: '4466-14-2',
      otherNames: [],
      reportable: true
    },
    'RF-0374-005-PPP': {
      reference: 'RF-0374-005-PPP',
      name: 'Jasmolin II',
      casNumber: '1172-63-0',
      otherNames: [],
      reportable: true
    },
    'RF-0375-001-PPP': {
      reference: 'RF-0375-001-PPP',
      name: 'Pyridaben',
      casNumber: '96489-71-3',
      otherNames: [],
      reportable: true
    },
    'RF-0376-001-PPP': {
      reference: 'RF-0376-001-PPP',
      name: 'Pyridate (sum of pyridate, its hydrolysis product CL 9673 (6-chloro-4-hydroxy-3-phenylpyridazin) and hydrolysable conjugates of CL 9673 expressed as pyridate)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0376-002-PPP': {
      reference: 'RF-0376-002-PPP',
      name: 'Pyridate',
      casNumber: '55512-33-9',
      otherNames: [],
      reportable: true
    },
    'RF-0377-001-PPP': {
      reference: 'RF-0377-001-PPP',
      name: 'Pyrimethanil',
      casNumber: '53112-28-0',
      otherNames: [
        'N-(4,6-dimethylpyrimidin-2-yl)aniline',
        '4,6-dimethyl-N-phenyl-2-pyrimidinamine'
      ],
      reportable: true
    },
    'RF-0378-001-PPP': {
      reference: 'RF-0378-001-PPP',
      name: 'Pyriproxyfen',
      casNumber: '95737-68-1',
      otherNames: [
        '2-[1-methyl-2-(4-phenoxyphenoxy)ethoxy]pyridine',
        '4-phenoxyphenyl (RS)-2-(2-pyridyloxy)propyl ether'
      ],
      reportable: true
    },
    'RF-0379-001-PPP': {
      reference: 'RF-0379-001-PPP',
      name: 'Pyroquilon',
      casNumber: '57369-32-1',
      otherNames: [],
      reportable: true
    },
    'RF-0380-001-PPP': {
      reference: 'RF-0380-001-PPP',
      name: 'Quinalphos',
      casNumber: '13593-03-8',
      otherNames: [],
      reportable: true
    },
    'RF-0381-001-PPP': {
      reference: 'RF-0381-001-PPP',
      name: 'Quinmerac',
      casNumber: '90717-03-6',
      otherNames: [],
      reportable: true
    },
    'RF-0382-001-PPP': {
      reference: 'RF-0382-001-PPP',
      name: 'Quinoxyfen',
      casNumber: '124495-18-7',
      otherNames: [],
      reportable: true
    },
    'RF-0383-001-PPP': {
      reference: 'RF-0383-001-PPP',
      name: 'Quintozene (sum of quintozene and pentachloro-aniline expressed as quintozene)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0383-002-PPP': {
      reference: 'RF-0383-002-PPP',
      name: 'Quintozene',
      casNumber: '82-68-8',
      otherNames: [],
      reportable: true
    },
    'RF-0383-003-PPP': {
      reference: 'RF-0383-003-PPP',
      name: 'Pentachloroaniline',
      casNumber: '527-20-8',
      otherNames: [],
      reportable: true
    },
    'RF-0384-002-PPP': {
      reference: 'RF-0384-002-PPP',
      name: 'Quizalofop-P',
      casNumber: '94051-08-8',
      otherNames: [],
      reportable: true
    },
    'RF-0384-004-PPP': {
      reference: 'RF-0384-004-PPP',
      name: 'Quizalofop',
      casNumber: '76578-12-6',
      otherNames: [],
      reportable: true
    },
    'RF-0385-001-PPP': {
      reference: 'RF-0385-001-PPP',
      name: 'Resmethrin (resmethrin including other mixtures of consituent isomers (sum of isomers))',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0386-001-PPP': {
      reference: 'RF-0386-001-PPP',
      name: 'Rimsulfuron',
      casNumber: '122931-48-0',
      otherNames: [],
      reportable: true
    },
    'RF-0387-001-PPP': {
      reference: 'RF-0387-001-PPP',
      name: 'Rotenone',
      casNumber: '83-79-4',
      otherNames: [],
      reportable: true
    },
    'RF-0389-001-PPP': {
      reference: 'RF-0389-001-PPP',
      name: 'Silthiofam',
      casNumber: '175217-20-6',
      otherNames: [],
      reportable: true
    },
    'RF-0390-001-PPP': {
      reference: 'RF-0390-001-PPP',
      name: 'Simazine',
      casNumber: '122-34-9',
      otherNames: [],
      reportable: true
    },
    'RF-0391-001-PPP': {
      reference: 'RF-0391-001-PPP',
      name: 'Sodium tetrathiocarbonate',
      casNumber: '7345-69-9',
      otherNames: [],
      reportable: true
    },
    'RF-0393-001-PPP': {
      reference: 'RF-0393-001-PPP',
      name: 'Spinosad (spinosad, sum of spinosyn A and spinosyn D)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0393-002-PPP': {
      reference: 'RF-0393-002-PPP',
      name: 'Spinosyn A',
      casNumber: '131929-60-7',
      otherNames: [],
      reportable: true
    },
    'RF-0393-003-PPP': {
      reference: 'RF-0393-003-PPP',
      name: 'Spinosyn D',
      casNumber: '131929-63-0',
      otherNames: [],
      reportable: true
    },
    'RF-0394-001-PPP': {
      reference: 'RF-0394-001-PPP',
      name: 'Spirodiclofen',
      casNumber: '148477-71-8',
      otherNames: [],
      reportable: true
    },
    'RF-0395-001-PPP': {
      reference: 'RF-0395-001-PPP',
      name: 'Spiromesifen',
      casNumber: '283594-90-1',
      otherNames: [],
      reportable: true
    },
    'RF-0396-001-PPP': {
      reference: 'RF-0396-001-PPP',
      name: 'Spirotetramat and its 4 metabolites BYI08330-enol, BYI08330-ketohydroxy, BYI08330-monohydroxy, and BYI08330 enol-glucoside, expressed as spirotetramat',
      casNumber: null,
      otherNames: [],
      reportable: false
    },
    'RF-0397-001-PPP': {
      reference: 'RF-0397-001-PPP',
      name: 'Spiroxamine (sum of isomers)',
      casNumber: null,
      otherNames: ['Spiroxamine'],
      reportable: true
    },
    'RF-0398-001-PPP': {
      reference: 'RF-0398-001-PPP',
      name: 'Sulcotrione',
      casNumber: '99105-77-8',
      otherNames: [],
      reportable: true
    },
    'RF-0399-001-PPP': {
      reference: 'RF-0399-001-PPP',
      name: 'Sulfosulfuron',
      casNumber: '141776-32-1',
      otherNames: [],
      reportable: true
    },
    'RF-0400-001-PPP': {
      reference: 'RF-0400-001-PPP',
      name: 'Sulfuryl fluoride',
      casNumber: '2699-79-8',
      otherNames: [],
      reportable: true
    },
    'RF-0401-001-PPP': {
      reference: 'RF-0401-001-PPP',
      name: 'Sulphur',
      casNumber: '7704-34-9',
      otherNames: [],
      reportable: true
    },
    'RF-0402-001-PPP': {
      reference: 'RF-0402-001-PPP',
      name: 'tau-fluvalinate',
      casNumber: '102851-06-9',
      otherNames: [
        'Fluvalinate, tau-',
        'cyano-(3-phenoxyphenyl)methyl N-[2-chloro-4-(trifluoromethyl)phenyl]-D-valinate'
      ],
      reportable: false
    },
    'RF-0403-001-PPP': {
      reference: 'RF-0403-001-PPP',
      name: 'Tebuconazole',
      casNumber: '107534-96-3',
      otherNames: [
        'rac-(3R)-1-(4-chlorophenyl)-4,4-dimethyl-3-(1H-1,2,4-triazol-1-ylmethyl)pentan-3-ol',
        'α-[2-(4-chlorophenyl)ethyl]-α-(1,1-dimethylethyl)-1H-1,2,4-triazole-1-ethanol'
      ],
      reportable: true
    },
    'RF-0404-001-PPP': {
      reference: 'RF-0404-001-PPP',
      name: 'Tebufenozide',
      casNumber: '112410-23-8',
      otherNames: [
        '3,5-dimethylbenzoic acid 1-(1,1-dimethylethyl)-2-(4-ethylbenzoyl)hydrazide'
      ],
      reportable: true
    },
    'RF-0405-001-PPP': {
      reference: 'RF-0405-001-PPP',
      name: 'Tebufenpyrad',
      casNumber: '119168-77-3',
      otherNames: [],
      reportable: true
    },
    'RF-0406-001-PPP': {
      reference: 'RF-0406-001-PPP',
      name: 'Tecnazene',
      casNumber: '117-18-0',
      otherNames: [],
      reportable: true
    },
    'RF-0407-001-PPP': {
      reference: 'RF-0407-001-PPP',
      name: 'Teflubenzuron',
      casNumber: '83121-18-0',
      otherNames: [],
      reportable: true
    },
    'RF-0409-001-PPP': {
      reference: 'RF-0409-001-PPP',
      name: 'Tembotrione',
      casNumber: '335104-84-2',
      otherNames: [],
      reportable: true
    },
    'RF-0410-001-PPP': {
      reference: 'RF-0410-001-PPP',
      name: 'TEPP',
      casNumber: '107-49-3',
      otherNames: [],
      reportable: true
    },
    'RF-0411-001-PPP': {
      reference: 'RF-0411-001-PPP',
      name: 'Tepraloxydim',
      casNumber: '149979-41-9',
      otherNames: [],
      reportable: true
    },
    'RF-0412-002-PPP': {
      reference: 'RF-0412-002-PPP',
      name: 'Terbufos',
      casNumber: '13071-79-9',
      otherNames: [],
      reportable: true
    },
    'RF-0412-003-PPP': {
      reference: 'RF-0412-003-PPP',
      name: 'Terbufos Sulfone',
      casNumber: '56070-16-7',
      otherNames: [],
      reportable: true
    },
    'RF-0412-004-PPP': {
      reference: 'RF-0412-004-PPP',
      name: 'Terbufos Sulfoxide',
      casNumber: '10548-10-4',
      otherNames: [],
      reportable: true
    },
    'RF-0412-005-PPP': {
      reference: 'RF-0412-005-PPP',
      name: 'Terbufos-oxon-sulfone',
      casNumber: '56070-15-6',
      otherNames: [],
      reportable: true
    },
    'RF-0412-006-PPP': {
      reference: 'RF-0412-006-PPP',
      name: 'Terbufos-oxon',
      casNumber: '56070-14-5',
      otherNames: [],
      reportable: true
    },
    'RF-0412-007-PPP': {
      reference: 'RF-0412-007-PPP',
      name: 'Terbufos-oxon-sulfoxide',
      casNumber: '56165-57-2',
      otherNames: [],
      reportable: true
    },
    'RF-0413-001-PPP': {
      reference: 'RF-0413-001-PPP',
      name: 'Terbuthylazine',
      casNumber: '5915-41-3',
      otherNames: [],
      reportable: true
    },
    'RF-0414-001-PPP': {
      reference: 'RF-0414-001-PPP',
      name: 'Tetraconazole',
      casNumber: '112281-77-3',
      otherNames: [],
      reportable: false
    },
    'RF-0415-001-PPP': {
      reference: 'RF-0415-001-PPP',
      name: 'Tetradifon',
      casNumber: '116-29-0',
      otherNames: [],
      reportable: true
    },
    'RF-0416-001-PPP': {
      reference: 'RF-0416-001-PPP',
      name: 'Thiabendazole',
      casNumber: '148-79-8',
      otherNames: [],
      reportable: true
    },
    'RF-0417-001-PPP': {
      reference: 'RF-0417-001-PPP',
      name: 'Thiacloprid',
      casNumber: '111988-49-9',
      otherNames: [],
      reportable: true
    },
    'RF-0418-001-PPP': {
      reference: 'RF-0418-001-PPP',
      name: 'Thiamethoxam',
      casNumber: '153719-23-4',
      otherNames: ['Thiametoxam'],
      reportable: true
    },
    'RF-0419-001-PPP': {
      reference: 'RF-0419-001-PPP',
      name: 'Thifensulfuron-methyl',
      casNumber: '79277-27-3',
      otherNames: [],
      reportable: true
    },
    'RF-0420-001-PPP': {
      reference: 'RF-0420-001-PPP',
      name: 'Thiobencarb',
      casNumber: '28249-77-6',
      otherNames: [],
      reportable: true
    },
    'RF-0422-001-PPP': {
      reference: 'RF-0422-001-PPP',
      name: 'Thiophanate-methyl',
      casNumber: '23564-05-8',
      otherNames: [],
      reportable: true
    },
    'RF-0423-001-PPP': {
      reference: 'RF-0423-001-PPP',
      name: 'Thiram (expressed as thiram)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0424-001-PPP': {
      reference: 'RF-0424-001-PPP',
      name: 'Tolclofos-methyl',
      casNumber: '57018-04-9',
      otherNames: [],
      reportable: true
    },
    'RF-0425-001-PPP': {
      reference: 'RF-0425-001-PPP',
      name: 'Tolylfluanid (Sum of tolylfluanid and dimethylaminosulfotoluidide expressed as tolylfluanid)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0425-002-PPP': {
      reference: 'RF-0425-002-PPP',
      name: 'Tolylfluanid',
      casNumber: '731-27-1',
      otherNames: [],
      reportable: true
    },
    'RF-0426-001-PPP': {
      reference: 'RF-0426-001-PPP',
      name: 'Topramezone',
      casNumber: '210631-68-8',
      otherNames: ['Topramezone (BAS 670H)'],
      reportable: true
    },
    'RF-0428-003-PPP': {
      reference: 'RF-0428-003-PPP',
      name: 'Triadimefon',
      casNumber: '43121-43-3',
      otherNames: [],
      reportable: true
    },
    'RF-0430-001-PPP': {
      reference: 'RF-0430-001-PPP',
      name: 'Tri-allate',
      casNumber: '2303-17-5',
      otherNames: [],
      reportable: true
    },
    'RF-0431-001-PPP': {
      reference: 'RF-0431-001-PPP',
      name: 'Triasulfuron',
      casNumber: '82097-50-5',
      otherNames: [],
      reportable: true
    },
    'RF-0432-001-PPP': {
      reference: 'RF-0432-001-PPP',
      name: 'Triazophos',
      casNumber: '24017-47-8',
      otherNames: [],
      reportable: true
    },
    'RF-0433-001-PPP': {
      reference: 'RF-0433-001-PPP',
      name: 'Triazoxide',
      casNumber: '72459-58-6',
      otherNames: [],
      reportable: true
    },
    'RF-0434-001-PPP': {
      reference: 'RF-0434-001-PPP',
      name: 'Tribenuron-methyl',
      casNumber: '101200-48-0',
      otherNames: [],
      reportable: true
    },
    'RF-0435-001-PPP': {
      reference: 'RF-0435-001-PPP',
      name: 'Trichlorfon',
      casNumber: '52-68-6',
      otherNames: [],
      reportable: true
    },
    'RF-0436-001-PPP': {
      reference: 'RF-0436-001-PPP',
      name: 'Triclopyr',
      casNumber: '55335-06-3',
      otherNames: [
        '[(3,5,6-trichloropyridin-2-yl)oxy]acetic acid',
        '2-[(3,5,6-trichloro-2-pyridinyl)oxy]acetic acid'
      ],
      reportable: true
    },
    'RF-0437-001-PPP': {
      reference: 'RF-0437-001-PPP',
      name: 'Tricyclazole',
      casNumber: '41814-78-2',
      otherNames: [],
      reportable: true
    },
    'RF-0438-001-PPP': {
      reference: 'RF-0438-001-PPP',
      name: 'Tridemorph',
      casNumber: '24602-86-6',
      otherNames: [],
      reportable: true
    },
    'RF-0439-001-PPP': {
      reference: 'RF-0439-001-PPP',
      name: 'Trifloxystrobin',
      casNumber: '141517-21-7',
      otherNames: [],
      reportable: true
    },
    'RF-0440-001-PPP': {
      reference: 'RF-0440-001-PPP',
      name: 'Triflumizole Triflumizole and metabolite FM-6-1(N-(4-chloro-2-trifluoromethylphenyl)-n-propoxyacetamidine), expressed as Triflumizole',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0440-002-PPP': {
      reference: 'RF-0440-002-PPP',
      name: 'Triflumizole',
      casNumber: '68694-11-1',
      otherNames: [],
      reportable: true
    },
    'RF-0441-001-PPP': {
      reference: 'RF-0441-001-PPP',
      name: 'Triflumuron',
      casNumber: '64628-44-0',
      otherNames: [],
      reportable: true
    },
    'RF-0442-001-PPP': {
      reference: 'RF-0442-001-PPP',
      name: 'Trifluralin',
      casNumber: '1582-09-8',
      otherNames: [],
      reportable: true
    },
    'RF-0444-001-PPP': {
      reference: 'RF-0444-001-PPP',
      name: 'Triforine',
      casNumber: '26644-46-2',
      otherNames: [],
      reportable: true
    },
    'RF-0445-001-PPP': {
      reference: 'RF-0445-001-PPP',
      name: 'Trimethyl-sulfonium cation, resulting from the use of glyphosate',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0446-001-PPP': {
      reference: 'RF-0446-001-PPP',
      name: 'Trinexapac (sum of trinexapac (acid) and its salts, expressed as trinexapac)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0447-001-PPP': {
      reference: 'RF-0447-001-PPP',
      name: 'Triticonazole',
      casNumber: '138182-18-0',
      otherNames: [
        '(RS)-(E)-5-(4-chlorobenzylidene)-2,2-dimethyl-1-(1H-1,2,4-triazol-1-ylmethyl)cyclopentanol',
        '(5E)-5-[(4-chlorophenyl)methylene]-2,2-dimethyl-1-(1H-1,2,4-triazol-1-ylmethyl)cyclopentanol'
      ],
      reportable: true
    },
    'RF-0448-001-PPP': {
      reference: 'RF-0448-001-PPP',
      name: 'Tritosulfuron',
      casNumber: '142469-14-5',
      otherNames: [
        'N-{[4-methoxy-6-(trifluoromethyl)-1,3,5-triazin-2-yl]carbamoyl}-2-(trifluoromethyl)benzene-1-sulfonamide'
      ],
      reportable: true
    },
    'RF-0450-002-PPP': {
      reference: 'RF-0450-002-PPP',
      name: 'Dichloroaniline, 3,5-',
      casNumber: '626-43-7',
      otherNames: [],
      reportable: true
    },
    'RF-0450-003-PPP': {
      reference: 'RF-0450-003-PPP',
      name: 'Vinclozolin',
      casNumber: '50471-44-8',
      otherNames: [],
      reportable: true
    },
    'RF-0451-001-PPP': {
      reference: 'RF-0451-001-PPP',
      name: 'Ziram',
      casNumber: '137-30-4',
      otherNames: [
        'zinc bis(dimethylcarbamodithioate)',
        '(T-4)-bis(dimethylcarbamodithioato-κS,κS′)zinc'
      ],
      reportable: true
    },
    'RF-0452-001-PPP': {
      reference: 'RF-0452-001-PPP',
      name: 'Zoxamide',
      casNumber: '156052-68-5',
      otherNames: [],
      reportable: true
    },
    'RF-0453-001-PPP': {
      reference: 'RF-0453-001-PPP',
      name: 'Dichlofluanid',
      casNumber: '1085-98-9',
      otherNames: [],
      reportable: true
    },
    'RF-0457-001-PPP': {
      reference: 'RF-0457-001-PPP',
      name: '2,4,5-T-Methylester',
      casNumber: '1928-37-6',
      otherNames: [],
      reportable: true
    },
    'RF-0458-001-PPP': {
      reference: 'RF-0458-001-PPP',
      name: '2,4,5-TP',
      casNumber: '93-72-1',
      otherNames: [],
      reportable: true
    },
    'RF-0460-001-PPP': {
      reference: 'RF-0460-001-PPP',
      name: '4-CPA',
      casNumber: '122-88-3',
      otherNames: [],
      reportable: true
    },
    'RF-0461-001-PPP': {
      reference: 'RF-0461-001-PPP',
      name: 'Acifluorfen',
      casNumber: '50594-66-6',
      otherNames: [],
      reportable: true
    },
    'RF-0462-001-PPP': {
      reference: 'RF-0462-001-PPP',
      name: 'Alanycarb',
      casNumber: '83130-01-2',
      otherNames: [],
      reportable: true
    },
    'RF-0463-001-PPP': {
      reference: 'RF-0463-001-PPP',
      name: 'Aldimorph',
      casNumber: '91315-15-0',
      otherNames: [],
      reportable: true
    },
    'RF-0464-001-PPP': {
      reference: 'RF-0464-001-PPP',
      name: 'Allethrin',
      casNumber: '584-79-2',
      otherNames: [],
      reportable: true
    },
    'RF-0465-001-PPP': {
      reference: 'RF-0465-001-PPP',
      name: 'Alloxydim',
      casNumber: '55634-91-8',
      otherNames: [],
      reportable: true
    },
    'RF-0467-001-PPP': {
      reference: 'RF-0467-001-PPP',
      name: 'Ametryn',
      casNumber: '834-12-8',
      otherNames: [],
      reportable: true
    },
    'RF-0468-001-PPP': {
      reference: 'RF-0468-001-PPP',
      name: 'Amidithion',
      casNumber: '919-76-6',
      otherNames: [],
      reportable: true
    },
    'RF-0469-001-PPP': {
      reference: 'RF-0469-001-PPP',
      name: 'Aminocarb',
      casNumber: '2032-59-9',
      otherNames: [],
      reportable: true
    },
    'RF-0470-001-PPP': {
      reference: 'RF-0470-001-PPP',
      name: 'Amisulbrom',
      casNumber: '348635-87-0',
      otherNames: [],
      reportable: true
    },
    'RF-0471-001-PPP': {
      reference: 'RF-0471-001-PPP',
      name: 'AMPA',
      casNumber: '1066-51-9',
      otherNames: [],
      reportable: true
    },
    'RF-0472-001-PPP': {
      reference: 'RF-0472-001-PPP',
      name: 'Ampropylfos',
      casNumber: '16606-64-7',
      otherNames: [],
      reportable: true
    },
    'RF-0473-001-PPP': {
      reference: 'RF-0473-001-PPP',
      name: 'Ancymidol',
      casNumber: '12771-68-5',
      otherNames: [],
      reportable: true
    },
    'RF-0474-001-PPP': {
      reference: 'RF-0474-001-PPP',
      name: 'Anilofos',
      casNumber: '64249-01-0',
      otherNames: [],
      reportable: true
    },
    'RF-0475-001-PPP': {
      reference: 'RF-0475-001-PPP',
      name: 'Anthraquinone',
      casNumber: '84-65-1',
      otherNames: [],
      reportable: true
    },
    'RF-0476-001-PPP': {
      reference: 'RF-0476-001-PPP',
      name: 'Aspon',
      casNumber: '3244-90-4',
      otherNames: [],
      reportable: true
    },
    'RF-0477-001-PPP': {
      reference: 'RF-0477-001-PPP',
      name: 'Atrazine, 2-Hydroxy-',
      casNumber: '2163-68-0',
      otherNames: [],
      reportable: true
    },
    'RF-0478-001-PPP': {
      reference: 'RF-0478-001-PPP',
      name: 'Desethyl-Atrazine',
      casNumber: '6190-65-4',
      otherNames: [],
      reportable: true
    },
    'RF-0479-001-PPP': {
      reference: 'RF-0479-001-PPP',
      name: 'Atrazine, Desethyl-2-Hydroxy-',
      casNumber: '19988-24-0',
      otherNames: [],
      reportable: true
    },
    'RF-0480-001-PPP': {
      reference: 'RF-0480-001-PPP',
      name: 'Atrazine, Desethyl-Desisopropyl-',
      casNumber: '3397-62-4',
      otherNames: [],
      reportable: true
    },
    'RF-0481-001-PPP': {
      reference: 'RF-0481-001-PPP',
      name: 'Atrazine, Desisopropyl-',
      casNumber: '1007-28-9',
      otherNames: [],
      reportable: true
    },
    'RF-0482-001-PPP': {
      reference: 'RF-0482-001-PPP',
      name: 'Azaconazole',
      casNumber: '60207-31-0',
      otherNames: [],
      reportable: true
    },
    'RF-0483-001-PPP': {
      reference: 'RF-0483-001-PPP',
      name: 'Azafenidin',
      casNumber: '68049-83-2',
      otherNames: [],
      reportable: true
    },
    'RF-0484-001-PPP': {
      reference: 'RF-0484-001-PPP',
      name: 'Azamethiphos',
      casNumber: '35575-96-3',
      otherNames: [],
      reportable: true
    },
    'RF-0485-001-PPP': {
      reference: 'RF-0485-001-PPP',
      name: 'Aziprotryne',
      casNumber: '4658-28-0',
      otherNames: [],
      reportable: true
    },
    'RF-0487-001-PPP': {
      reference: 'RF-0487-001-PPP',
      name: 'Benazolin',
      casNumber: '3813-05-6',
      otherNames: [],
      reportable: true
    },
    'RF-0488-001-PPP': {
      reference: 'RF-0488-001-PPP',
      name: 'Benazolin-Ethyl',
      casNumber: '25059-80-7',
      otherNames: [],
      reportable: true
    },
    'RF-0489-001-PPP': {
      reference: 'RF-0489-001-PPP',
      name: 'Bendiocarb',
      casNumber: '22781-23-3',
      otherNames: [],
      reportable: true
    },
    'RF-0490-001-PPP': {
      reference: 'RF-0490-001-PPP',
      name: 'Benfuresate',
      casNumber: '68505-69-1',
      otherNames: [],
      reportable: true
    },
    'RF-0491-001-PPP': {
      reference: 'RF-0491-001-PPP',
      name: 'Benodanil',
      casNumber: '15310-01-7',
      otherNames: [],
      reportable: true
    },
    'RF-0492-001-PPP': {
      reference: 'RF-0492-001-PPP',
      name: 'Benoxacor',
      casNumber: '98730-04-2',
      otherNames: [],
      reportable: true
    },
    'RF-0493-001-PPP': {
      reference: 'RF-0493-001-PPP',
      name: 'Bensulfuron',
      casNumber: '99283-01-9',
      otherNames: [],
      reportable: true
    },
    'RF-0494-001-PPP': {
      reference: 'RF-0494-001-PPP',
      name: 'Bensulfuron-Methyl',
      casNumber: '83055-99-6',
      otherNames: [],
      reportable: true
    },
    'RF-0495-001-PPP': {
      reference: 'RF-0495-001-PPP',
      name: 'Bensulide',
      casNumber: '741-58-2',
      otherNames: [],
      reportable: true
    },
    'RF-0496-001-PPP': {
      reference: 'RF-0496-001-PPP',
      name: 'Bensultap',
      casNumber: '17606-31-4',
      otherNames: [],
      reportable: true
    },
    'RF-0497-001-PPP': {
      reference: 'RF-0497-001-PPP',
      name: 'Bentaluron',
      casNumber: '28956-64-1',
      otherNames: [],
      reportable: true
    },
    'RF-0498-001-PPP': {
      reference: 'RF-0498-001-PPP',
      name: 'Benzimidazole',
      casNumber: '51-17-2',
      otherNames: [],
      reportable: true
    },
    'RF-0499-001-PPP': {
      reference: 'RF-0499-001-PPP',
      name: 'Benzobicyclon',
      casNumber: '156963-66-5',
      otherNames: [],
      reportable: true
    },
    'RF-0500-001-PPP': {
      reference: 'RF-0500-001-PPP',
      name: 'Benzoximate',
      casNumber: '29104-30-1',
      otherNames: [],
      reportable: true
    },
    'RF-0501-001-PPP': {
      reference: 'RF-0501-001-PPP',
      name: 'Benzoylprop',
      casNumber: '22212-56-2',
      otherNames: [],
      reportable: true
    },
    'RF-0502-001-PPP': {
      reference: 'RF-0502-001-PPP',
      name: 'Benzoylprop-Ethyl',
      casNumber: '22212-55-1',
      otherNames: [],
      reportable: true
    },
    'RF-0503-001-PPP': {
      reference: 'RF-0503-001-PPP',
      name: 'Benzthiazuron',
      casNumber: '1929-88-0',
      otherNames: [],
      reportable: true
    },
    'RF-0504-001-PPP': {
      reference: 'RF-0504-001-PPP',
      name: 'Bioallethrin',
      casNumber: '260359-57-7',
      otherNames: [],
      reportable: true
    },
    'RF-0505-001-PPP': {
      reference: 'RF-0505-001-PPP',
      name: 'Bioresmethrin',
      casNumber: '28434-01-7',
      otherNames: [],
      reportable: true
    },
    'RF-0506-001-PPP': {
      reference: 'RF-0506-001-PPP',
      name: 'Biphenyl',
      casNumber: '92-52-4',
      otherNames: [],
      reportable: true
    },
    'RF-0507-001-PPP': {
      reference: 'RF-0507-001-PPP',
      name: 'Bispyribac (sum of bispyribac, its salts and its esters, expressed as bispyribac)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0508-001-PPP': {
      reference: 'RF-0508-001-PPP',
      name: 'Blasticidin-S',
      casNumber: '51775-28-1',
      otherNames: [],
      reportable: true
    },
    'RF-0509-001-PPP': {
      reference: 'RF-0509-001-PPP',
      name: 'Bomyl',
      casNumber: '122-10-1',
      otherNames: [],
      reportable: true
    },
    'RF-0510-001-PPP': {
      reference: 'RF-0510-001-PPP',
      name: 'Brodifacoum',
      casNumber: '56073-10-0',
      otherNames: [],
      reportable: true
    },
    'RF-0511-001-PPP': {
      reference: 'RF-0511-001-PPP',
      name: 'Bromacil',
      casNumber: '314-40-9',
      otherNames: [],
      reportable: true
    },
    'RF-0512-001-PPP': {
      reference: 'RF-0512-001-PPP',
      name: 'Bromethalin',
      casNumber: '63333-35-7',
      otherNames: [],
      reportable: true
    },
    'RF-0513-001-PPP': {
      reference: 'RF-0513-001-PPP',
      name: 'Bromfenvinfos',
      casNumber: '33399-00-7',
      otherNames: [],
      reportable: true
    },
    'RF-0514-001-PPP': {
      reference: 'RF-0514-001-PPP',
      name: 'Bromobutide',
      casNumber: '74712-19-9',
      otherNames: [],
      reportable: true
    },
    'RF-0515-001-PPP': {
      reference: 'RF-0515-001-PPP',
      name: 'Bromocyclen',
      casNumber: '1715-40-8',
      otherNames: [],
      reportable: true
    },
    'RF-0516-001-PPP': {
      reference: 'RF-0516-001-PPP',
      name: 'Bromofenoxim',
      casNumber: '13181-17-4',
      otherNames: [],
      reportable: true
    },
    'RF-0517-001-PPP': {
      reference: 'RF-0517-001-PPP',
      name: 'Bromophos',
      casNumber: '2104-96-3',
      otherNames: [],
      reportable: true
    },
    'RF-0518-001-PPP': {
      reference: 'RF-0518-001-PPP',
      name: 'Bronopol',
      casNumber: '52-51-7',
      otherNames: [],
      reportable: true
    },
    'RF-0519-001-PPP': {
      reference: 'RF-0519-001-PPP',
      name: 'Butachlor',
      casNumber: '23184-66-9',
      otherNames: [],
      reportable: true
    },
    'RF-0520-001-PPP': {
      reference: 'RF-0520-001-PPP',
      name: 'Butafenacil',
      casNumber: '134605-64-4',
      otherNames: [],
      reportable: true
    },
    'RF-0521-001-PPP': {
      reference: 'RF-0521-001-PPP',
      name: 'Butamifos',
      casNumber: '36335-67-8',
      otherNames: [],
      reportable: true
    },
    'RF-0522-001-PPP': {
      reference: 'RF-0522-001-PPP',
      name: 'Butocarboxim',
      casNumber: '34681-10-2',
      otherNames: [],
      reportable: true
    },
    'RF-0524-001-PPP': {
      reference: 'RF-0524-001-PPP',
      name: 'Butocarboxim-Sulfoxid',
      casNumber: '34681-24-8',
      otherNames: [],
      reportable: true
    },
    'RF-0525-001-PPP': {
      reference: 'RF-0525-001-PPP',
      name: 'Butoxycarboxim',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0526-001-PPP': {
      reference: 'RF-0526-001-PPP',
      name: 'Butroxydim',
      casNumber: '138164-12-2',
      otherNames: [],
      reportable: true
    },
    'RF-0527-001-PPP': {
      reference: 'RF-0527-001-PPP',
      name: 'Buturon',
      casNumber: '3766-60-7',
      otherNames: [],
      reportable: true
    },
    'RF-0528-001-PPP': {
      reference: 'RF-0528-001-PPP',
      name: 'Cadusafos',
      casNumber: '95465-99-9',
      otherNames: [],
      reportable: true
    },
    'RF-0529-001-PPP': {
      reference: 'RF-0529-001-PPP',
      name: 'Cafenstrole',
      casNumber: '125306-83-4',
      otherNames: [],
      reportable: true
    },
    'RF-0534-001-PPP': {
      reference: 'RF-0534-001-PPP',
      name: 'Carbofuran, 3-keto',
      casNumber: '16709-30-1',
      otherNames: [],
      reportable: true
    },
    'RF-0535-001-PPP': {
      reference: 'RF-0535-001-PPP',
      name: 'Carbophenothion',
      casNumber: '786-19-6',
      otherNames: [],
      reportable: true
    },
    'RF-0536-001-PPP': {
      reference: 'RF-0536-001-PPP',
      name: 'Carbophenothion-Methyl',
      casNumber: '953-17-3',
      otherNames: [],
      reportable: true
    },
    'RF-0537-001-PPP': {
      reference: 'RF-0537-001-PPP',
      name: 'Carpropamid',
      casNumber: '104030-54-8',
      otherNames: [],
      reportable: true
    },
    'RF-0538-001-PPP': {
      reference: 'RF-0538-001-PPP',
      name: 'Carvone',
      casNumber: '99-49-0',
      otherNames: [],
      reportable: true
    },
    'RF-0539-001-PPP': {
      reference: 'RF-0539-001-PPP',
      name: 'Chinomethionat',
      casNumber: '2439-01-2',
      otherNames: [],
      reportable: true
    },
    'RF-0540-001-PPP': {
      reference: 'RF-0540-001-PPP',
      name: 'Chlomethoxyfen',
      casNumber: '32861-85-1',
      otherNames: [],
      reportable: true
    },
    'RF-0541-001-PPP': {
      reference: 'RF-0541-001-PPP',
      name: 'Chloramben',
      casNumber: '133-90-4',
      otherNames: [],
      reportable: true
    },
    'RF-0542-001-PPP': {
      reference: 'RF-0542-001-PPP',
      name: 'Chloramben-Methyl',
      casNumber: '7286-84-2',
      otherNames: [],
      reportable: true
    },
    'RF-0543-001-PPP': {
      reference: 'RF-0543-001-PPP',
      name: 'Chloraniformethan',
      casNumber: '20856-57-9',
      otherNames: [],
      reportable: true
    },
    'RF-0544-001-PPP': {
      reference: 'RF-0544-001-PPP',
      name: 'Chlorbromuron',
      casNumber: '13360-45-7',
      otherNames: [],
      reportable: true
    },
    'RF-0545-001-PPP': {
      reference: 'RF-0545-001-PPP',
      name: 'Chlordimeform',
      casNumber: '6164-98-3',
      otherNames: [],
      reportable: true
    },
    'RF-0546-001-PPP': {
      reference: 'RF-0546-001-PPP',
      name: 'Chlorethoxyfos',
      casNumber: '54593-83-8',
      otherNames: [],
      reportable: true
    },
    'RF-0547-001-PPP': {
      reference: 'RF-0547-001-PPP',
      name: 'Chlorfenprop',
      casNumber: '59604-11-4',
      otherNames: [],
      reportable: true
    },
    'RF-0548-001-PPP': {
      reference: 'RF-0548-001-PPP',
      name: 'Chlorfenprop-Methyl',
      casNumber: '14437-17-3',
      otherNames: [],
      reportable: true
    },
    'RF-0549-001-PPP': {
      reference: 'RF-0549-001-PPP',
      name: 'Chlorfluazuron',
      casNumber: '71422-67-8',
      otherNames: [],
      reportable: true
    },
    'RF-0550-001-PPP': {
      reference: 'RF-0550-001-PPP',
      name: 'Chlorflurenol',
      casNumber: '2464-37-1',
      otherNames: [],
      reportable: true
    },
    'RF-0551-001-PPP': {
      reference: 'RF-0551-001-PPP',
      name: 'Chlorflurenol-Methyl',
      casNumber: '2536-31-4',
      otherNames: [],
      reportable: true
    },
    'RF-0552-001-PPP': {
      reference: 'RF-0552-001-PPP',
      name: 'Chloridazon, Methyl-Desphenyl-',
      casNumber: '17254-80-7',
      otherNames: ['Metabolite B-1'],
      reportable: true
    },
    'RF-0553-001-PPP': {
      reference: 'RF-0553-001-PPP',
      name: 'Chlorimuron-Ethyl',
      casNumber: '90982-32-4',
      otherNames: [],
      reportable: true
    },
    'RF-0554-001-PPP': {
      reference: 'RF-0554-001-PPP',
      name: 'Chlormephos',
      casNumber: '24934-91-6',
      otherNames: [],
      reportable: true
    },
    'RF-0555-001-PPP': {
      reference: 'RF-0555-001-PPP',
      name: 'Chlornitrofen',
      casNumber: '1836-77-7',
      otherNames: [],
      reportable: true
    },
    'RF-0556-001-PPP': {
      reference: 'RF-0556-001-PPP',
      name: 'Chloroneb',
      casNumber: '2675-77-6',
      otherNames: [],
      reportable: true
    },
    'RF-0557-001-PPP': {
      reference: 'RF-0557-001-PPP',
      name: 'Chloropropylate',
      casNumber: '5836-10-2',
      otherNames: [],
      reportable: true
    },
    'RF-0558-001-PPP': {
      reference: 'RF-0558-001-PPP',
      name: 'Chlorphonium',
      casNumber: '115-78-6',
      otherNames: [],
      reportable: true
    },
    'RF-0559-001-PPP': {
      reference: 'RF-0559-001-PPP',
      name: 'Chlorthal',
      casNumber: '2136-79-0',
      otherNames: [],
      reportable: true
    },
    'RF-0560-001-PPP': {
      reference: 'RF-0560-001-PPP',
      name: 'Chlorthion',
      casNumber: '500-28-7',
      otherNames: [],
      reportable: true
    },
    'RF-0561-001-PPP': {
      reference: 'RF-0561-001-PPP',
      name: 'Chlorthiophos',
      casNumber: '60238-56-4',
      otherNames: [],
      reportable: true
    },
    'RF-0563-001-PPP': {
      reference: 'RF-0563-001-PPP',
      name: 'Cinmethylin',
      casNumber: '87818-31-3',
      otherNames: [
        'Exo-(+/-)-1-methyl-4-(1-methylethyl)-2-[(2-methylphenyl)methoxy]-7-oxabicyclo[2.2.1]heptane',
        'rac-(1R,2S,4S)-1-methyl-4-(1-methylethyl)-2-[(2-methylphenyl)methoxy]-7-oxabicyclo[2.2.1]heptane'
      ],
      reportable: true
    },
    'RF-0564-001-PPP': {
      reference: 'RF-0564-001-PPP',
      name: 'Cinosulfuron',
      casNumber: '94593-91-6',
      otherNames: [],
      reportable: true
    },
    'RF-0565-001-PPP': {
      reference: 'RF-0565-001-PPP',
      name: 'Clodinafop-Propargyl',
      casNumber: '105512-06-9',
      otherNames: [],
      reportable: true
    },
    'RF-0566-001-PPP': {
      reference: 'RF-0566-001-PPP',
      name: 'Clofencet',
      casNumber: '129025-54-3',
      otherNames: [],
      reportable: true
    },
    'RF-0568-001-PPP': {
      reference: 'RF-0568-001-PPP',
      name: 'Cloquintocet-Mexyl',
      casNumber: '99607-70-2',
      otherNames: [],
      reportable: true
    },
    'RF-0569-001-PPP': {
      reference: 'RF-0569-001-PPP',
      name: 'Cloransulam-Methyl',
      casNumber: '147150-35-4',
      otherNames: [],
      reportable: true
    },
    'RF-0570-001-PPP': {
      reference: 'RF-0570-001-PPP',
      name: 'Coumachlor',
      casNumber: '81-82-3',
      otherNames: [],
      reportable: true
    },
    'RF-0571-001-PPP': {
      reference: 'RF-0571-001-PPP',
      name: 'Coumaphos',
      casNumber: '56-72-4',
      otherNames: [],
      reportable: true
    },
    'RF-0572-001-PPP': {
      reference: 'RF-0572-001-PPP',
      name: 'Coumatetralyl',
      casNumber: '5836-29-3',
      otherNames: [],
      reportable: true
    },
    'RF-0573-001-PPP': {
      reference: 'RF-0573-001-PPP',
      name: 'Crimidine',
      casNumber: '535-89-7',
      otherNames: [],
      reportable: true
    },
    'RF-0574-001-PPP': {
      reference: 'RF-0574-001-PPP',
      name: 'Crotoxyphos',
      casNumber: '7700-17-6',
      otherNames: [],
      reportable: true
    },
    'RF-0575-001-PPP': {
      reference: 'RF-0575-001-PPP',
      name: 'Crufomate',
      casNumber: '299-86-5',
      otherNames: [],
      reportable: true
    },
    'RF-0576-001-PPP': {
      reference: 'RF-0576-001-PPP',
      name: 'Cyanazine',
      casNumber: '21725-46-2',
      otherNames: [],
      reportable: true
    },
    'RF-0577-001-PPP': {
      reference: 'RF-0577-001-PPP',
      name: 'Cyanofenphos',
      casNumber: '13067-93-1',
      otherNames: [],
      reportable: true
    },
    'RF-0578-001-PPP': {
      reference: 'RF-0578-001-PPP',
      name: 'Cyanophos',
      casNumber: '2636-26-2',
      otherNames: [],
      reportable: true
    },
    'RF-0579-001-PPP': {
      reference: 'RF-0579-001-PPP',
      name: 'Cybutryne',
      casNumber: '28159-98-0',
      otherNames: [],
      reportable: true
    },
    'RF-0580-001-PPP': {
      reference: 'RF-0580-001-PPP',
      name: 'Cycloate',
      casNumber: '1134-23-2',
      otherNames: [],
      reportable: true
    },
    'RF-0581-001-PPP': {
      reference: 'RF-0581-001-PPP',
      name: 'Cycloprothrin',
      casNumber: '63935-38-6',
      otherNames: [],
      reportable: true
    },
    'RF-0582-001-PPP': {
      reference: 'RF-0582-001-PPP',
      name: 'Cyclosulfamuron',
      casNumber: '136849-15-5',
      otherNames: [],
      reportable: true
    },
    'RF-0583-001-PPP': {
      reference: 'RF-0583-001-PPP',
      name: 'Cycluron',
      casNumber: '2163-69-1',
      otherNames: [],
      reportable: true
    },
    'RF-0584-001-PPP': {
      reference: 'RF-0584-001-PPP',
      name: 'Cyhalothrin',
      casNumber: '68085-85-8',
      otherNames: [],
      reportable: true
    },
    'RF-0586-001-PPP': {
      reference: 'RF-0586-001-PPP',
      name: 'Cymiazole',
      casNumber: '61676-87-7',
      otherNames: [],
      reportable: true
    },
    'RF-0587-001-PPP': {
      reference: 'RF-0587-001-PPP',
      name: 'Cyphenothrin',
      casNumber: '39515-40-7',
      otherNames: [],
      reportable: true
    },
    'RF-0588-001-PPP': {
      reference: 'RF-0588-001-PPP',
      name: 'Cyprazin',
      casNumber: '22936-86-3',
      otherNames: [],
      reportable: true
    },
    'RF-0589-001-PPP': {
      reference: 'RF-0589-001-PPP',
      name: 'Cyprofuram',
      casNumber: '69581-33-5',
      otherNames: [],
      reportable: true
    },
    'RF-0590-001-PPP': {
      reference: 'RF-0590-001-PPP',
      name: 'Cythioate',
      casNumber: '115-93-5',
      otherNames: [],
      reportable: true
    },
    'RF-0591-001-PPP': {
      reference: 'RF-0591-001-PPP',
      name: 'Daimuron',
      casNumber: '42609-52-9',
      otherNames: [],
      reportable: true
    },
    'RF-0592-001-PPP': {
      reference: 'RF-0592-001-PPP',
      name: 'Demephion-O',
      casNumber: '682-80-4',
      otherNames: [],
      reportable: true
    },
    'RF-0593-001-PPP': {
      reference: 'RF-0593-001-PPP',
      name: 'Demephion-S',
      casNumber: '2587-90-8',
      otherNames: [],
      reportable: true
    },
    'RF-0594-002-PPP': {
      reference: 'RF-0594-002-PPP',
      name: 'Demeton-S-Methyl',
      casNumber: '919-86-8',
      otherNames: [],
      reportable: true
    },
    'RF-0595-001-PPP': {
      reference: 'RF-0595-001-PPP',
      name: 'Desmetryn',
      casNumber: '1014-69-3',
      otherNames: [],
      reportable: true
    },
    'RF-0596-001-PPP': {
      reference: 'RF-0596-001-PPP',
      name: 'Diafenthiuron',
      casNumber: '80060-09-9',
      otherNames: [],
      reportable: true
    },
    'RF-0597-001-PPP': {
      reference: 'RF-0597-001-PPP',
      name: 'Dialifos',
      casNumber: '10311-84-9',
      otherNames: [],
      reportable: true
    },
    'RF-0598-001-PPP': {
      reference: 'RF-0598-001-PPP',
      name: 'Dibromobenzophenone, 4,4`-',
      casNumber: '3988-03-2',
      otherNames: [],
      reportable: true
    },
    'RF-0599-001-PPP': {
      reference: 'RF-0599-001-PPP',
      name: 'Dichlofenthion',
      casNumber: '97-17-6',
      otherNames: [],
      reportable: true
    },
    'RF-0600-001-PPP': {
      reference: 'RF-0600-001-PPP',
      name: 'Dichlone',
      casNumber: '117-80-6',
      otherNames: [],
      reportable: true
    },
    'RF-0601-001-PPP': {
      reference: 'RF-0601-001-PPP',
      name: 'Dichlormid',
      casNumber: '37764-25-3',
      otherNames: [],
      reportable: true
    },
    'RF-0602-001-PPP': {
      reference: 'RF-0602-001-PPP',
      name: 'Dichlorobenzamide, 2,6-',
      casNumber: '2008-58-4',
      otherNames: [],
      reportable: true,
      // produit de dégradation du diclobénil et du chlorothalonil
      lmrCanBeOptional: true
    },
    'RF-0603-001-PPP': {
      reference: 'RF-0603-001-PPP',
      name: 'Dichlorobenzene, 1,4-',
      casNumber: '106-46-7',
      otherNames: [],
      reportable: true
    },
    'RF-0604-001-PPP': {
      reference: 'RF-0604-001-PPP',
      name: 'Dichlorobenzoic acid, 2,4-',
      casNumber: '50-84-0',
      otherNames: [],
      reportable: true
    },
    'RF-0604-002-PPP': {
      reference: 'RF-0604-002-PPP',
      name: 'Dichlorobenzoic acid, 2,6-',
      casNumber: '50-30-6',
      otherNames: [],
      reportable: true
    },
    'RF-0605-001-PPP': {
      reference: 'RF-0605-001-PPP',
      name: 'Dichlorobenzophenone, 4,4`-',
      casNumber: '90-98-2',
      otherNames: [],
      reportable: true
    },
    'RF-0606-001-PPP': {
      reference: 'RF-0606-001-PPP',
      name: 'Dichloro-p-Cresol, 2,6-',
      casNumber: '2432-12-4',
      otherNames: [],
      reportable: true
    },
    'RF-0607-001-PPP': {
      reference: 'RF-0607-001-PPP',
      name: 'Dichlorophen',
      casNumber: '97-23-4',
      otherNames: [],
      reportable: true
    },
    'RF-0608-001-PPP': {
      reference: 'RF-0608-001-PPP',
      name: 'Dichloropropane, 1,2-',
      casNumber: '78-87-5',
      otherNames: [],
      reportable: true
    },
    'RF-0609-001-PPP': {
      reference: 'RF-0609-001-PPP',
      name: 'Dichlozoline',
      casNumber: '24201-58-9',
      otherNames: [],
      reportable: true
    },
    'RF-0610-001-PPP': {
      reference: 'RF-0610-001-PPP',
      name: 'Diclobutrazol',
      casNumber: '75736-33-3',
      otherNames: [],
      reportable: true
    },
    'RF-0611-001-PPP': {
      reference: 'RF-0611-001-PPP',
      name: 'Diclosulam',
      casNumber: '145701-21-9',
      otherNames: [],
      reportable: true
    },
    'RF-0612-001-PPP': {
      reference: 'RF-0612-001-PPP',
      name: 'Dicrotophos',
      casNumber: '141-66-2',
      otherNames: [],
      reportable: true
    },
    'RF-0613-001-PPP': {
      reference: 'RF-0613-001-PPP',
      name: 'Dicyclanil',
      casNumber: '112636-83-6',
      otherNames: [],
      reportable: true
    },
    'RF-0614-001-PPP': {
      reference: 'RF-0614-001-PPP',
      name: 'Dienochlor',
      casNumber: '2227-17-0',
      otherNames: [],
      reportable: true
    },
    'RF-0615-001-PPP': {
      reference: 'RF-0615-001-PPP',
      name: 'Diethatyl',
      casNumber: '38725-95-0',
      otherNames: [],
      reportable: true
    },
    'RF-0616-001-PPP': {
      reference: 'RF-0616-001-PPP',
      name: 'Diethyl-m-toluamid, N,N-',
      casNumber: '134-62-3',
      otherNames: [],
      reportable: true,
      lmrCanBeOptional: true
    },
    'RF-0617-001-PPP': {
      reference: 'RF-0617-001-PPP',
      name: 'Difenacoum',
      casNumber: '56073-07-5',
      otherNames: [],
      reportable: true
    },
    'RF-0618-001-PPP': {
      reference: 'RF-0618-001-PPP',
      name: 'Difenoxuron',
      casNumber: '14214-32-5',
      otherNames: [],
      reportable: true
    },
    'RF-0619-001-PPP': {
      reference: 'RF-0619-001-PPP',
      name: 'Difenzoquat',
      casNumber: '49866-87-7',
      otherNames: [],
      reportable: true
    },
    'RF-0620-001-PPP': {
      reference: 'RF-0620-001-PPP',
      name: 'Diflufenzopyr',
      casNumber: '109293-97-2',
      otherNames: [],
      reportable: true
    },
    'RF-0621-001-PPP': {
      reference: 'RF-0621-001-PPP',
      name: 'Dikegulac',
      casNumber: '18467-77-1',
      otherNames: [],
      reportable: true
    },
    'RF-0622-001-PPP': {
      reference: 'RF-0622-001-PPP',
      name: 'Dimefox',
      casNumber: '115-26-4',
      otherNames: [],
      reportable: true
    },
    'RF-0623-001-PPP': {
      reference: 'RF-0623-001-PPP',
      name: 'Dimefuron',
      casNumber: '34205-21-5',
      otherNames: [],
      reportable: true
    },
    'RF-0624-001-PPP': {
      reference: 'RF-0624-001-PPP',
      name: 'Dimepiperate',
      casNumber: '61432-55-1',
      otherNames: [],
      reportable: true
    },
    'RF-0625-001-PPP': {
      reference: 'RF-0625-001-PPP',
      name: 'Dimethametryn',
      casNumber: '22936-75-0',
      otherNames: [],
      reportable: true
    },
    'RF-0626-001-PPP': {
      reference: 'RF-0626-001-PPP',
      name: 'Dimethirimol',
      casNumber: '5221-53-4',
      otherNames: [],
      reportable: true
    },
    'RF-0627-001-PPP': {
      reference: 'RF-0627-001-PPP',
      name: 'Dimethylvinphos',
      casNumber: '2274-67-1',
      otherNames: [],
      reportable: true
    },
    'RF-0628-001-PPP': {
      reference: 'RF-0628-001-PPP',
      name: 'Dimetilan',
      casNumber: '644-64-4',
      otherNames: [],
      reportable: true
    },
    'RF-0629-001-PPP': {
      reference: 'RF-0629-001-PPP',
      name: 'Dimexano',
      casNumber: '1468-37-7',
      otherNames: [],
      reportable: true
    },
    'RF-0630-001-PPP': {
      reference: 'RF-0630-001-PPP',
      name: 'Dinitramine',
      casNumber: '29091-05-2',
      otherNames: [],
      reportable: true
    },
    'RF-0631-001-PPP': {
      reference: 'RF-0631-001-PPP',
      name: 'Dinobuton',
      casNumber: '973-21-7',
      otherNames: [],
      reportable: true
    },
    'RF-0632-001-PPP': {
      reference: 'RF-0632-001-PPP',
      name: 'Dinoseb Acetate',
      casNumber: '2813-95-8',
      otherNames: [],
      reportable: true
    },
    'RF-0633-001-PPP': {
      reference: 'RF-0633-001-PPP',
      name: 'Dinotefuran',
      casNumber: '165252-70-0',
      otherNames: [],
      reportable: true
    },
    'RF-0634-001-PPP': {
      reference: 'RF-0634-001-PPP',
      name: 'Diofenolan',
      casNumber: '63837-33-2',
      otherNames: [],
      reportable: true
    },
    'RF-0635-001-PPP': {
      reference: 'RF-0635-001-PPP',
      name: 'Dioxabenzofos',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0636-001-PPP': {
      reference: 'RF-0636-001-PPP',
      name: 'Dioxacarb',
      casNumber: '6988-21-2',
      otherNames: [],
      reportable: true
    },
    'RF-0637-001-PPP': {
      reference: 'RF-0637-001-PPP',
      name: 'Diphacinone',
      casNumber: '82-66-6',
      otherNames: [],
      reportable: true
    },
    'RF-0638-001-PPP': {
      reference: 'RF-0638-001-PPP',
      name: 'Diphenamid',
      casNumber: '957-51-7',
      otherNames: [],
      reportable: true
    },
    'RF-0639-001-PPP': {
      reference: 'RF-0639-001-PPP',
      name: 'Disulfiram',
      casNumber: '97-77-8',
      otherNames: [],
      reportable: true
    },
    'RF-0640-001-PPP': {
      reference: 'RF-0640-001-PPP',
      name: 'Ditalimfos',
      casNumber: '5131-24-8',
      otherNames: [],
      reportable: true
    },
    'RF-0641-001-PPP': {
      reference: 'RF-0641-001-PPP',
      name: 'Dithiopyr',
      casNumber: '97886-45-8',
      otherNames: [],
      reportable: true
    },
    'RF-0642-001-PPP': {
      reference: 'RF-0642-001-PPP',
      name: 'DMS',
      casNumber: '3984-14-3',
      otherNames: [],
      reportable: true
    },
    'RF-0643-001-PPP': {
      reference: 'RF-0643-001-PPP',
      name: 'DMSA',
      casNumber: '4710-17-2',
      otherNames: [],
      reportable: true
    },
    'RF-0644-001-PPP': {
      reference: 'RF-0644-001-PPP',
      name: 'Dimethylaminosulfotoluidide (DMST)',
      casNumber: '66840-71-9',
      otherNames: [],
      reportable: true
    },
    'RF-0645-001-PPP': {
      reference: 'RF-0645-001-PPP',
      name: 'Dodemorph',
      casNumber: '1593-77-7',
      otherNames: [],
      reportable: true
    },
    'RF-0646-001-PPP': {
      reference: 'RF-0646-001-PPP',
      name: 'Drazoxolon',
      casNumber: '5707-69-7',
      otherNames: [],
      reportable: true
    },
    'RF-0647-001-PPP': {
      reference: 'RF-0647-001-PPP',
      name: 'Edifenphos',
      casNumber: '17109-49-8',
      otherNames: [],
      reportable: true
    },
    'RF-0648-001-PPP': {
      reference: 'RF-0648-001-PPP',
      name: 'Emamectin benzoate B1a, expressed as emamectin',
      casNumber: null,
      otherNames: [],
      reportable: false
    },
    'RF-0649-001-PPP': {
      reference: 'RF-0649-001-PPP',
      name: 'Emamectin B1a',
      casNumber: '121124-29-6',
      otherNames: [],
      reportable: true
    },
    'RF-0651-001-PPP': {
      reference: 'RF-0651-001-PPP',
      name: 'Empenthrin',
      casNumber: '54406-48-3',
      otherNames: [],
      reportable: true
    },
    'RF-0652-001-PPP': {
      reference: 'RF-0652-001-PPP',
      name: 'Endothal',
      casNumber: '145-73-3',
      otherNames: [],
      reportable: true
    },
    'RF-0653-001-PPP': {
      reference: 'RF-0653-001-PPP',
      name: 'Endrin ketone',
      casNumber: '53494-70-5',
      otherNames: [],
      reportable: true
    },
    'RF-0654-001-PPP': {
      reference: 'RF-0654-001-PPP',
      name: 'EPN',
      casNumber: '2104-64-5',
      otherNames: [],
      reportable: true
    },
    'RF-0656-001-PPP': {
      reference: 'RF-0656-001-PPP',
      name: 'Esprocarb',
      casNumber: '85785-20-2',
      otherNames: [],
      reportable: true
    },
    'RF-0657-001-PPP': {
      reference: 'RF-0657-001-PPP',
      name: 'Etaconazole',
      casNumber: '60207-93-4',
      otherNames: [],
      reportable: true
    },
    'RF-0658-001-PPP': {
      reference: 'RF-0658-001-PPP',
      name: 'Ethametsulfuron-Methyl',
      casNumber: '97780-06-8',
      otherNames: [],
      reportable: true
    },
    'RF-0659-001-PPP': {
      reference: 'RF-0659-001-PPP',
      name: 'Ethidimuron',
      casNumber: '30043-49-3',
      otherNames: [],
      reportable: true
    },
    'RF-0660-001-PPP': {
      reference: 'RF-0660-001-PPP',
      name: 'Ethiofencarb',
      casNumber: '29973-13-5',
      otherNames: [],
      reportable: true
    },
    'RF-0661-001-PPP': {
      reference: 'RF-0661-001-PPP',
      name: 'Ethiofencarb (sum)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0662-001-PPP': {
      reference: 'RF-0662-001-PPP',
      name: 'Ethiofencarb-Sulfon',
      casNumber: '53380-23-7',
      otherNames: [],
      reportable: true
    },
    'RF-0663-001-PPP': {
      reference: 'RF-0663-001-PPP',
      name: 'Ethiofencarb-Sulfoxid',
      casNumber: '53380-22-6',
      otherNames: [],
      reportable: true
    },
    'RF-0664-001-PPP': {
      reference: 'RF-0664-001-PPP',
      name: 'Ethiprole',
      casNumber: '181587-01-9',
      otherNames: [],
      reportable: true
    },
    'RF-0665-001-PPP': {
      reference: 'RF-0665-001-PPP',
      name: 'Ethoate-Methyl',
      casNumber: '116-01-8',
      otherNames: [],
      reportable: true
    },
    'RF-0667-001-PPP': {
      reference: 'RF-0667-001-PPP',
      name: 'Etobenzanid',
      casNumber: '79540-50-4',
      otherNames: [],
      reportable: true
    },
    'RF-0668-001-PPP': {
      reference: 'RF-0668-001-PPP',
      name: 'Etrimfos',
      casNumber: '38260-54-7',
      otherNames: [],
      reportable: true
    },
    'RF-0669-001-PPP': {
      reference: 'RF-0669-001-PPP',
      name: 'Ethylenethiourea',
      casNumber: '96-45-7',
      otherNames: [],
      reportable: true
    },
    'RF-0670-001-PPP': {
      reference: 'RF-0670-001-PPP',
      name: 'Famphur',
      casNumber: '52-85-7',
      otherNames: [],
      reportable: true
    },
    'RF-0671-001-PPP': {
      reference: 'RF-0671-001-PPP',
      name: 'Fenaminosulf',
      casNumber: '140-56-7',
      otherNames: [],
      reportable: true
    },
    'RF-0672-001-PPP': {
      reference: 'RF-0672-001-PPP',
      name: 'Fenazaflor',
      casNumber: '14255-88-0',
      otherNames: [],
      reportable: true
    },
    'RF-0673-001-PPP': {
      reference: 'RF-0673-001-PPP',
      name: 'Fenchlorazol-Ethyl',
      casNumber: '103112-35-2',
      otherNames: [],
      reportable: true
    },
    'RF-0674-001-PPP': {
      reference: 'RF-0674-001-PPP',
      name: 'Fenclorim',
      casNumber: '3740-92-9',
      otherNames: [],
      reportable: true
    },
    'RF-0675-001-PPP': {
      reference: 'RF-0675-001-PPP',
      name: 'Fenfluthrin',
      casNumber: '75867-00-4',
      otherNames: [],
      reportable: true
    },
    'RF-0676-001-PPP': {
      reference: 'RF-0676-001-PPP',
      name: 'Fenfuram',
      casNumber: '24691-80-3',
      otherNames: [],
      reportable: true
    },
    'RF-0677-001-PPP': {
      reference: 'RF-0677-001-PPP',
      name: 'Fenobucarb',
      casNumber: '3766-81-2',
      otherNames: [],
      reportable: true
    },
    'RF-0678-001-PPP': {
      reference: 'RF-0678-001-PPP',
      name: 'Fenothiocarb',
      casNumber: '62850-32-2',
      otherNames: [],
      reportable: true
    },
    'RF-0679-001-PPP': {
      reference: 'RF-0679-001-PPP',
      name: 'Fenoxanil',
      casNumber: '115852-48-7',
      otherNames: [],
      reportable: true
    },
    'RF-0680-001-PPP': {
      reference: 'RF-0680-001-PPP',
      name: 'Fenoxaprop',
      casNumber: '95617-09-7',
      otherNames: [],
      reportable: true
    },
    'RF-0681-001-PPP': {
      reference: 'RF-0681-001-PPP',
      name: 'Fenoxaprop-P-Ethyl',
      casNumber: '71283-80-2',
      otherNames: [
        'ethyl (R)-2-[4-(6-chlorobenzoxazol-2-yloxy)phenoxy]propionate',
        'ethyl (2R)-2-[4-[(6-chloro-2-benzoxazolyl)oxy]phenoxy]propanoate'
      ],
      reportable: true
    },
    'RF-0681-002-PPP': {
      reference: 'RF-0681-002-PPP',
      name: 'Fenoxaprop-ethyl',
      casNumber: '66441-23-4',
      otherNames: [],
      reportable: true
    },
    'RF-0682-001-PPP': {
      reference: 'RF-0682-001-PPP',
      name: 'Fenpiclonil',
      casNumber: '74738-17-3',
      otherNames: [],
      reportable: true
    },
    'RF-0683-001-PPP': {
      reference: 'RF-0683-001-PPP',
      name: 'Fenridazon',
      casNumber: '68254-10-4',
      otherNames: [],
      reportable: true
    },
    'RF-0684-001-PPP': {
      reference: 'RF-0684-001-PPP',
      name: 'Fenson',
      casNumber: '80-38-6',
      otherNames: [],
      reportable: true
    },
    'RF-0685-002-PPP': {
      reference: 'RF-0685-002-PPP',
      name: 'Fensulfothion',
      casNumber: '115-90-2',
      otherNames: [],
      reportable: true
    },
    'RF-0685-003-PPP': {
      reference: 'RF-0685-003-PPP',
      name: 'Fensulfothion-sulfon',
      casNumber: '14255-72-2',
      otherNames: [],
      reportable: true
    },
    'RF-0685-004-PPP': {
      reference: 'RF-0685-004-PPP',
      name: 'Fensulfothion oxon',
      casNumber: '6552-21-2',
      otherNames: [],
      reportable: true
    },
    'RF-0685-005-PPP': {
      reference: 'RF-0685-005-PPP',
      name: 'Fensulfothion-oxon-sulphone',
      casNumber: '6132-17-8',
      otherNames: [],
      reportable: true
    },
    'RF-0687-001-PPP': {
      reference: 'RF-0687-001-PPP',
      name: 'Fentin (fentin including its salts, expressed as triphenyltin cation)',
      casNumber: '668-34-8',
      otherNames: [],
      reportable: true
    },
    'RF-0688-001-PPP': {
      reference: 'RF-0688-001-PPP',
      name: 'Fentrazamide',
      casNumber: '158237-07-1',
      otherNames: [],
      reportable: true
    },
    'RF-0689-001-PPP': {
      reference: 'RF-0689-001-PPP',
      name: 'Fenuron',
      casNumber: '101-42-8',
      otherNames: [],
      reportable: true
    },
    'RF-0690-004-PPP': {
      reference: 'RF-0690-004-PPP',
      name: 'Fenvalerate and Esfenvalerate (Sum of RR and SS isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0690-005-PPP': {
      reference: 'RF-0690-005-PPP',
      name: 'Fenvalerate and Esfenvalerate (Sum of RS and SR isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0690-006-PPP': {
      reference: 'RF-0690-006-PPP',
      name: 'Fenvalerate (any ratio of constituent isomers (RR, SS, RS and SR) including esfenvalerate)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0691-001-PPP': {
      reference: 'RF-0691-001-PPP',
      name: 'Ferbam',
      casNumber: '14484-64-1',
      otherNames: [],
      reportable: true
    },
    'RF-0692-002-PPP': {
      reference: 'RF-0692-002-PPP',
      name: 'Fipronil-Desulfinyl',
      casNumber: '205650-65-3',
      otherNames: [],
      reportable: true
    },
    'RF-0693-001-PPP': {
      reference: 'RF-0693-001-PPP',
      name: 'Fipronil-Sulfide',
      casNumber: '120067-83-6',
      otherNames: [],
      reportable: true
    },
    'RF-0694-001-PPP': {
      reference: 'RF-0694-001-PPP',
      name: 'Flamprop-M-Isopropyl',
      casNumber: '63782-90-1',
      otherNames: [],
      reportable: true
    },
    'RF-0695-001-PPP': {
      reference: 'RF-0695-001-PPP',
      name: 'Flamprop-M-Methyl',
      casNumber: '63729-98-6',
      otherNames: [],
      reportable: true
    },
    'RF-0696-001-PPP': {
      reference: 'RF-0696-001-PPP',
      name: 'Flocoumafen',
      casNumber: '90035-08-8',
      otherNames: [],
      reportable: true
    },
    'RF-0697-001-PPP': {
      reference: 'RF-0697-001-PPP',
      name: 'Fluacrypyrim',
      casNumber: '229977-93-9',
      otherNames: [],
      reportable: true
    },
    'RF-0698-001-PPP': {
      reference: 'RF-0698-001-PPP',
      name: 'Fluazifop',
      casNumber: '69335-91-7',
      otherNames: ['Fluazifop (free acid)'],
      reportable: true
    },
    'RF-0699-001-PPP': {
      reference: 'RF-0699-001-PPP',
      name: 'Fluazifop-Butyl',
      casNumber: '69806-50-4',
      otherNames: [],
      reportable: true
    },
    'RF-0699-002-PPP': {
      reference: 'RF-0699-002-PPP',
      name: 'Fluazifop-methyl',
      casNumber: '69335-90-6',
      otherNames: [],
      reportable: true
    },
    'RF-0700-001-PPP': {
      reference: 'RF-0700-001-PPP',
      name: 'Fluazolate',
      casNumber: '174514-07-9',
      otherNames: [],
      reportable: true
    },
    'RF-0701-001-PPP': {
      reference: 'RF-0701-001-PPP',
      name: 'Fluazuron',
      casNumber: '86811-58-7',
      otherNames: [],
      reportable: true
    },
    'RF-0702-001-PPP': {
      reference: 'RF-0702-001-PPP',
      name: 'Flubenzimine',
      casNumber: '37893-02-0',
      otherNames: [],
      reportable: true
    },
    'RF-0703-001-PPP': {
      reference: 'RF-0703-001-PPP',
      name: 'Fluchloralin',
      casNumber: '33245-39-5',
      otherNames: [],
      reportable: true
    },
    'RF-0704-001-PPP': {
      reference: 'RF-0704-001-PPP',
      name: 'Flufenprox',
      casNumber: '107713-58-6',
      otherNames: [],
      reportable: true
    },
    'RF-0705-001-PPP': {
      reference: 'RF-0705-001-PPP',
      name: 'Flumethrin',
      casNumber: '69770-45-2',
      otherNames: [],
      reportable: true
    },
    'RF-0706-001-PPP': {
      reference: 'RF-0706-001-PPP',
      name: 'Flumetralin',
      casNumber: '62924-70-3',
      otherNames: [],
      reportable: true
    },
    'RF-0707-001-PPP': {
      reference: 'RF-0707-001-PPP',
      name: 'Flumetsulam',
      casNumber: '98967-40-9',
      otherNames: [],
      reportable: true
    },
    'RF-0708-001-PPP': {
      reference: 'RF-0708-001-PPP',
      name: 'Flumiclorac',
      casNumber: '87547-04-4',
      otherNames: [],
      reportable: true
    },
    'RF-0709-001-PPP': {
      reference: 'RF-0709-001-PPP',
      name: 'Flumiclorac-Pentyl',
      casNumber: '87546-18-7',
      otherNames: [],
      reportable: true
    },
    'RF-0710-001-PPP': {
      reference: 'RF-0710-001-PPP',
      name: 'Fluorodifen',
      casNumber: '15457-05-3',
      otherNames: [],
      reportable: true
    },
    'RF-0711-001-PPP': {
      reference: 'RF-0711-001-PPP',
      name: 'Fluoroglycofen-Ethyl',
      casNumber: '77501-90-7',
      otherNames: [],
      reportable: true
    },
    'RF-0712-001-PPP': {
      reference: 'RF-0712-001-PPP',
      name: 'Fluoroimide',
      casNumber: '41205-21-4',
      otherNames: [],
      reportable: true
    },
    'RF-0713-001-PPP': {
      reference: 'RF-0713-001-PPP',
      name: 'Fluotrimazole',
      casNumber: '31251-03-3',
      otherNames: [],
      reportable: true
    },
    'RF-0714-001-PPP': {
      reference: 'RF-0714-001-PPP',
      name: 'Flupoxam',
      casNumber: '119126-15-7',
      otherNames: [],
      reportable: true
    },
    'RF-0715-001-PPP': {
      reference: 'RF-0715-001-PPP',
      name: 'Flupyrsulfuron',
      casNumber: '150315-10-9',
      otherNames: [],
      reportable: true
    },
    'RF-0716-001-PPP': {
      reference: 'RF-0716-001-PPP',
      name: 'Flurazole',
      casNumber: '72850-64-7',
      otherNames: [],
      reportable: true
    },
    'RF-0717-001-PPP': {
      reference: 'RF-0717-001-PPP',
      name: 'Flurenol',
      casNumber: '467-69-6',
      otherNames: [],
      reportable: true
    },
    'RF-0718-001-PPP': {
      reference: 'RF-0718-001-PPP',
      name: 'Fluridone',
      casNumber: '59756-60-4',
      otherNames: [],
      reportable: true
    },
    'RF-0719-001-PPP': {
      reference: 'RF-0719-001-PPP',
      name: 'Flusulfamide',
      casNumber: '106917-52-6',
      otherNames: [],
      reportable: true
    },
    'RF-0720-001-PPP': {
      reference: 'RF-0720-001-PPP',
      name: 'Fluthiacet-Methyl',
      casNumber: '117337-19-6',
      otherNames: [],
      reportable: true
    },
    'RF-0722-001-PPP': {
      reference: 'RF-0722-001-PPP',
      name: 'Fluxofenim',
      casNumber: '88485-37-4',
      otherNames: [],
      reportable: true
    },
    'RF-0723-001-PPP': {
      reference: 'RF-0723-001-PPP',
      name: 'Fomesafen',
      casNumber: '72178-02-0',
      otherNames: [],
      reportable: true
    },
    'RF-0724-001-PPP': {
      reference: 'RF-0724-001-PPP',
      name: 'Fonofos',
      casNumber: '944-22-9',
      otherNames: [],
      reportable: true
    },
    'RF-0725-001-PPP': {
      reference: 'RF-0725-001-PPP',
      name: 'Fosamine',
      casNumber: '59682-52-9',
      otherNames: [],
      reportable: true
    },
    'RF-0726-001-PPP': {
      reference: 'RF-0726-001-PPP',
      name: 'Fosthietan',
      casNumber: '21548-32-3',
      otherNames: [],
      reportable: true
    },
    'RF-0727-001-PPP': {
      reference: 'RF-0727-001-PPP',
      name: 'Furalaxyl',
      casNumber: '57646-30-7',
      otherNames: [],
      reportable: true
    },
    'RF-0728-001-PPP': {
      reference: 'RF-0728-001-PPP',
      name: 'Furilazole',
      casNumber: '121776-33-8',
      otherNames: [],
      reportable: true
    },
    'RF-0729-001-PPP': {
      reference: 'RF-0729-001-PPP',
      name: 'Furmecyclox',
      casNumber: '60568-05-0',
      otherNames: [],
      reportable: true
    },
    'RF-0730-001-PPP': {
      reference: 'RF-0730-001-PPP',
      name: 'Genite',
      casNumber: '97-16-5',
      otherNames: [],
      reportable: true
    },
    'RF-0731-001-PPP': {
      reference: 'RF-0731-001-PPP',
      name: 'Glyphosate-Trimesium',
      casNumber: '81591-81-3',
      otherNames: [],
      reportable: true
    },
    'RF-0732-001-PPP': {
      reference: 'RF-0732-001-PPP',
      name: 'Halfenprox',
      casNumber: '111872-58-3',
      otherNames: [],
      reportable: true
    },
    'RF-0733-001-PPP': {
      reference: 'RF-0733-001-PPP',
      name: 'Halofenozide',
      casNumber: '112226-61-6',
      otherNames: [],
      reportable: true
    },
    'RF-0734-001-PPP': {
      reference: 'RF-0734-001-PPP',
      name: 'Halosulfuron',
      casNumber: '135397-30-7',
      otherNames: [],
      reportable: true
    },
    'RF-0736-001-PPP': {
      reference: 'RF-0736-001-PPP',
      name: 'HCH, delta-',
      casNumber: '319-86-8',
      otherNames: [],
      reportable: true
    },
    'RF-0737-001-PPP': {
      reference: 'RF-0737-001-PPP',
      name: 'Heptenophos',
      casNumber: '23560-59-0',
      otherNames: [],
      reportable: true
    },
    'RF-0738-001-PPP': {
      reference: 'RF-0738-001-PPP',
      name: 'Hexaflumuron',
      casNumber: '86479-06-3',
      otherNames: [],
      reportable: true
    },
    'RF-0739-001-PPP': {
      reference: 'RF-0739-001-PPP',
      name: 'Hexazinone',
      casNumber: '51235-04-2',
      otherNames: [],
      reportable: true
    },
    'RF-0740-001-PPP': {
      reference: 'RF-0740-001-PPP',
      name: 'Hydramethylnon',
      casNumber: '67485-29-4',
      otherNames: [],
      reportable: true
    },
    'RF-0741-001-PPP': {
      reference: 'RF-0741-001-PPP',
      name: 'Hydroxyquinoline sulfate, 8-',
      casNumber: '134-31-6',
      otherNames: [],
      reportable: true
    },
    'RF-0742-001-PPP': {
      reference: 'RF-0742-001-PPP',
      name: 'Imazamethabenz-Methyl',
      casNumber: '81405-85-8',
      otherNames: [],
      reportable: true
    },
    'RF-0743-001-PPP': {
      reference: 'RF-0743-001-PPP',
      name: 'Imazapic',
      casNumber: '104098-48-8',
      otherNames: [
        '2-[4,5-dihydro-4-methyl-4-(1-methylethyl)-5-oxo-1H-imidazol-2-yl]-5-methyl-3-pyridinecarboxylic acid'
      ],
      reportable: true
    },
    'RF-0744-001-PPP': {
      reference: 'RF-0744-001-PPP',
      name: 'Imazapyr',
      casNumber: '81334-34-1',
      otherNames: [
        '2-[(RS)-4-isopropyl-4-methyl-5-oxo-2-imidazolin-2-yl]nicotinic acid'
      ],
      reportable: true
    },
    'RF-0745-001-PPP': {
      reference: 'RF-0745-001-PPP',
      name: 'Imazethapyr',
      casNumber: '81335-77-5',
      otherNames: [],
      reportable: true
    },
    'RF-0746-001-PPP': {
      reference: 'RF-0746-001-PPP',
      name: 'Imibenconazole',
      casNumber: '86598-92-7',
      otherNames: [],
      reportable: true
    },
    'RF-0747-001-PPP': {
      reference: 'RF-0747-001-PPP',
      name: 'Imidacloprid, 5-Hydroxy-',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0748-001-PPP': {
      reference: 'RF-0748-001-PPP',
      name: 'Imidacloprid, Olefin-',
      casNumber: '115086-54-9',
      otherNames: [],
      reportable: true
    },
    'RF-0749-001-PPP': {
      reference: 'RF-0749-001-PPP',
      name: 'Iminoctadine',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0750-001-PPP': {
      reference: 'RF-0750-001-PPP',
      name: 'Inabenfide',
      casNumber: '82211-24-3',
      otherNames: [],
      reportable: true
    },
    'RF-0751-001-PPP': {
      reference: 'RF-0751-001-PPP',
      name: 'Iprobenfos',
      casNumber: '26087-47-8',
      otherNames: [],
      reportable: true
    },
    'RF-0752-001-PPP': {
      reference: 'RF-0752-001-PPP',
      name: 'Isazofos',
      casNumber: '42509-80-8',
      otherNames: [],
      reportable: true
    },
    'RF-0753-001-PPP': {
      reference: 'RF-0753-001-PPP',
      name: 'Isocarbamid',
      casNumber: '30979-48-7',
      otherNames: [],
      reportable: true
    },
    'RF-0754-001-PPP': {
      reference: 'RF-0754-001-PPP',
      name: 'Isocarbophos',
      casNumber: '24353-61-5',
      otherNames: [],
      reportable: true
    },
    'RF-0755-001-PPP': {
      reference: 'RF-0755-001-PPP',
      name: 'Isodrin',
      casNumber: '465-73-6',
      otherNames: [],
      reportable: true
    },
    'RF-0756-001-PPP': {
      reference: 'RF-0756-001-PPP',
      name: 'Isofenphos',
      casNumber: '25311-71-1',
      otherNames: [],
      reportable: true
    },
    'RF-0757-001-PPP': {
      reference: 'RF-0757-001-PPP',
      name: 'Isofenphos (sum)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0758-001-PPP': {
      reference: 'RF-0758-001-PPP',
      name: 'Isofenphos-methyl',
      casNumber: '99675-03-3',
      otherNames: [],
      reportable: true
    },
    'RF-0759-001-PPP': {
      reference: 'RF-0759-001-PPP',
      name: 'Isofenphos-oxon',
      casNumber: '31120-85-1',
      otherNames: [],
      reportable: true
    },
    'RF-0760-001-PPP': {
      reference: 'RF-0760-001-PPP',
      name: 'Isolane',
      casNumber: '119-38-0',
      otherNames: [],
      reportable: true
    },
    'RF-0761-001-PPP': {
      reference: 'RF-0761-001-PPP',
      name: 'Isomethiozin',
      casNumber: '57052-04-7',
      otherNames: [],
      reportable: true
    },
    'RF-0762-001-PPP': {
      reference: 'RF-0762-001-PPP',
      name: 'Isoprocarb',
      casNumber: '2631-40-5',
      otherNames: [],
      reportable: true
    },
    'RF-0763-001-PPP': {
      reference: 'RF-0763-001-PPP',
      name: 'Isopropalin',
      casNumber: '33820-53-0',
      otherNames: [],
      reportable: true
    },
    'RF-0764-001-PPP': {
      reference: 'RF-0764-001-PPP',
      name: 'Isoprothiolane',
      casNumber: '50512-35-1',
      otherNames: [],
      reportable: true
    },
    'RF-0765-001-PPP': {
      reference: 'RF-0765-001-PPP',
      name: 'Isoxadifen-ethyl',
      casNumber: '163520-33-0',
      otherNames: [],
      reportable: true
    },
    'RF-0766-001-PPP': {
      reference: 'RF-0766-001-PPP',
      name: 'Isoxathion',
      casNumber: '18854-01-8',
      otherNames: [],
      reportable: true
    },
    'RF-0767-001-PPP': {
      reference: 'RF-0767-001-PPP',
      name: 'Ivermectin',
      casNumber: '70288-86-7',
      otherNames: [],
      reportable: true
    },
    'RF-0768-001-PPP': {
      reference: 'RF-0768-001-PPP',
      name: 'Iodofenphos',
      casNumber: '18181-70-9',
      otherNames: ['Jodfenphos'],
      reportable: true
    },
    'RF-0769-001-PPP': {
      reference: 'RF-0769-001-PPP',
      name: 'Kadethrin',
      casNumber: '58769-20-3',
      otherNames: [],
      reportable: true
    },
    'RF-0770-001-PPP': {
      reference: 'RF-0770-001-PPP',
      name: 'Karbutilate',
      casNumber: '4849-32-5',
      otherNames: [],
      reportable: true
    },
    'RF-0771-001-PPP': {
      reference: 'RF-0771-001-PPP',
      name: 'Karetazan',
      casNumber: '81051-65-2',
      otherNames: [],
      reportable: true
    },
    'RF-0772-001-PPP': {
      reference: 'RF-0772-001-PPP',
      name: 'Kasugamycin',
      casNumber: '6980-18-3',
      otherNames: [],
      reportable: true
    },
    'RF-0773-001-PPP': {
      reference: 'RF-0773-001-PPP',
      name: 'Kelevan',
      casNumber: '4234-79-1',
      otherNames: [],
      reportable: true
    },
    'RF-0774-001-PPP': {
      reference: 'RF-0774-001-PPP',
      name: 'Lactofen',
      casNumber: '77501-63-4',
      otherNames: [],
      reportable: true
    },
    'RF-0775-001-PPP': {
      reference: 'RF-0775-001-PPP',
      name: 'Leptophos',
      casNumber: '21609-90-5',
      otherNames: [],
      reportable: true
    },
    'RF-0776-001-PPP': {
      reference: 'RF-0776-001-PPP',
      name: 'Mefenacet',
      casNumber: '73250-68-7',
      otherNames: [],
      reportable: true
    },
    'RF-0777-001-PPP': {
      reference: 'RF-0777-001-PPP',
      name: 'Mefenpyr',
      casNumber: '135591-00-3',
      otherNames: [],
      reportable: true
    },
    'RF-0778-001-PPP': {
      reference: 'RF-0778-001-PPP',
      name: 'Mefluidide',
      casNumber: '53780-34-0',
      otherNames: [],
      reportable: true
    },
    'RF-0779-001-PPP': {
      reference: 'RF-0779-001-PPP',
      name: 'Mephosfolan',
      casNumber: '950-10-7',
      otherNames: [],
      reportable: true
    },
    'RF-0780-001-PPP': {
      reference: 'RF-0780-001-PPP',
      name: 'Mepronil',
      casNumber: '55814-41-0',
      otherNames: [],
      reportable: true
    },
    'RF-0781-001-PPP': {
      reference: 'RF-0781-001-PPP',
      name: 'Merphos',
      casNumber: '150-50-5',
      otherNames: [],
      reportable: true
    },
    'RF-0782-001-PPP': {
      reference: 'RF-0782-001-PPP',
      name: 'Methazole',
      casNumber: '20354-26-1',
      otherNames: [],
      reportable: true
    },
    'RF-0783-001-PPP': {
      reference: 'RF-0783-001-PPP',
      name: 'Methfuroxam',
      casNumber: '28730-17-8',
      otherNames: [],
      reportable: true
    },
    'RF-0784-001-PPP': {
      reference: 'RF-0784-001-PPP',
      name: 'Methomyl-Oxime',
      casNumber: '13749-94-5',
      otherNames: [],
      reportable: true
    },
    'RF-0785-001-PPP': {
      reference: 'RF-0785-001-PPP',
      name: 'Methomyl-Sulfone',
      casNumber: '55620-24-1',
      otherNames: [],
      reportable: true
    },
    'RF-0786-001-PPP': {
      reference: 'RF-0786-001-PPP',
      name: 'Methoprotryne',
      casNumber: '841-06-5',
      otherNames: [],
      reportable: true
    },
    'RF-0787-001-PPP': {
      reference: 'RF-0787-001-PPP',
      name: 'Methothrin',
      casNumber: '34388-29-9',
      otherNames: [],
      reportable: true
    },
    'RF-0788-001-PPP': {
      reference: 'RF-0788-001-PPP',
      name: 'Methyl bromide',
      casNumber: '74-83-9',
      otherNames: [],
      reportable: true
    },
    'RF-0789-001-PPP': {
      reference: 'RF-0789-001-PPP',
      name: 'Methyldymron',
      casNumber: '42609-73-4',
      otherNames: [],
      reportable: true
    },
    'RF-0790-001-PPP': {
      reference: 'RF-0790-001-PPP',
      name: 'Methyl-Isothiocyanate',
      casNumber: '556-61-6',
      otherNames: [],
      reportable: true
    },
    'RF-0791-001-PPP': {
      reference: 'RF-0791-001-PPP',
      name: 'Metobromuron',
      casNumber: '3060-89-7',
      otherNames: [],
      reportable: true
    },
    'RF-0792-001-PPP': {
      reference: 'RF-0792-001-PPP',
      name: 'Metolcarb',
      casNumber: '1129-41-5',
      otherNames: [],
      reportable: true
    },
    'RF-0793-001-PPP': {
      reference: 'RF-0793-001-PPP',
      name: 'Metominostrobin',
      casNumber: '133408-50-1',
      otherNames: [],
      reportable: true
    },
    'RF-0794-001-PPP': {
      reference: 'RF-0794-001-PPP',
      name: 'Metoxuron',
      casNumber: '19937-59-8',
      otherNames: [],
      reportable: true
    },
    'RF-0795-001-PPP': {
      reference: 'RF-0795-001-PPP',
      name: 'Metsulfovax',
      casNumber: '21452-18-6',
      otherNames: [],
      reportable: true
    },
    'RF-0796-001-PPP': {
      reference: 'RF-0796-001-PPP',
      name: 'Metsulfuron',
      casNumber: '79510-48-8',
      otherNames: [],
      reportable: true
    },
    'RF-0797-001-PPP': {
      reference: 'RF-0797-001-PPP',
      name: 'Mirex',
      casNumber: '2385-85-5',
      otherNames: [],
      reportable: true
    },
    'RF-0798-001-PPP': {
      reference: 'RF-0798-001-PPP',
      name: 'Monalide',
      casNumber: '7287-36-7',
      otherNames: [],
      reportable: true
    },
    'RF-0799-001-PPP': {
      reference: 'RF-0799-001-PPP',
      name: 'Nabam',
      casNumber: '142-59-6',
      otherNames: [],
      reportable: true
    },
    'RF-0800-001-PPP': {
      reference: 'RF-0800-001-PPP',
      name: 'Naled',
      casNumber: '300-76-5',
      otherNames: [],
      reportable: true
    },
    'RF-0801-001-PPP': {
      reference: 'RF-0801-001-PPP',
      name: 'Naphthalene',
      casNumber: '91-20-3',
      otherNames: [],
      reportable: true
    },
    'RF-0802-001-PPP': {
      reference: 'RF-0802-001-PPP',
      name: 'Naphthol, 1-',
      casNumber: '90-15-3',
      otherNames: [],
      reportable: true
    },
    'RF-0803-001-PPP': {
      reference: 'RF-0803-001-PPP',
      name: '2-Naphthyloxyacetic acid',
      casNumber: '120-23-0',
      otherNames: ['Naphthoxyacetic acid, 2-'],
      reportable: true
    },
    'RF-0804-001-PPP': {
      reference: 'RF-0804-001-PPP',
      name: 'Naptalam',
      casNumber: '132-66-1',
      otherNames: [],
      reportable: true
    },
    'RF-0805-001-PPP': {
      reference: 'RF-0805-001-PPP',
      name: 'Neburon',
      casNumber: '555-37-3',
      otherNames: [],
      reportable: true
    },
    'RF-0806-001-PPP': {
      reference: 'RF-0806-001-PPP',
      name: 'Nereistoxin',
      casNumber: '1631-58-9',
      otherNames: [],
      reportable: true
    },
    'RF-0808-001-PPP': {
      reference: 'RF-0808-001-PPP',
      name: 'Niclosamide',
      casNumber: '50-65-7',
      otherNames: [],
      reportable: true
    },
    'RF-0809-001-PPP': {
      reference: 'RF-0809-001-PPP',
      name: 'Nicotine',
      casNumber: '54-11-5',
      otherNames: [],
      reportable: true
    },
    'RF-0810-001-PPP': {
      reference: 'RF-0810-001-PPP',
      name: 'Nitenpyram',
      casNumber: '150824-47-8',
      otherNames: [],
      reportable: true
    },
    'RF-0811-001-PPP': {
      reference: 'RF-0811-001-PPP',
      name: 'Nithiazine',
      casNumber: '58842-20-9',
      otherNames: [],
      reportable: true
    },
    'RF-0812-001-PPP': {
      reference: 'RF-0812-001-PPP',
      name: 'Nitralin',
      casNumber: '4726-14-1',
      otherNames: [],
      reportable: true
    },
    'RF-0813-001-PPP': {
      reference: 'RF-0813-001-PPP',
      name: 'Nitrapyrin',
      casNumber: '1929-82-4',
      otherNames: [],
      reportable: true
    },
    'RF-0814-001-PPP': {
      reference: 'RF-0814-001-PPP',
      name: 'Nitrobenzene',
      casNumber: '98-95-3',
      otherNames: [],
      reportable: true
    },
    'RF-0815-001-PPP': {
      reference: 'RF-0815-001-PPP',
      name: 'Nitrothal-Isopropyl',
      casNumber: '10552-74-6',
      otherNames: [],
      reportable: true
    },
    'RF-0816-001-PPP': {
      reference: 'RF-0816-001-PPP',
      name: 'Norflurazon-Desmethyl',
      casNumber: '23576-24-1',
      otherNames: [],
      reportable: true
    },
    'RF-0817-001-PPP': {
      reference: 'RF-0817-001-PPP',
      name: 'Noruron',
      casNumber: '18530-56-8',
      otherNames: [],
      reportable: true
    },
    'RF-0818-001-PPP': {
      reference: 'RF-0818-001-PPP',
      name: 'Noviflumuron',
      casNumber: '121451-02-3',
      otherNames: [],
      reportable: true
    },
    'RF-0819-001-PPP': {
      reference: 'RF-0819-001-PPP',
      name: 'Nuarimol',
      casNumber: '63284-71-9',
      otherNames: [],
      reportable: true
    },
    'RF-0820-001-PPP': {
      reference: 'RF-0820-001-PPP',
      name: 'Octhilinone',
      casNumber: '26530-20-1',
      otherNames: [],
      reportable: true
    },
    'RF-0821-001-PPP': {
      reference: 'RF-0821-001-PPP',
      name: 'Ofurace',
      casNumber: '58810-48-3',
      otherNames: [],
      reportable: true
    },
    'RF-0822-001-PPP': {
      reference: 'RF-0822-001-PPP',
      name: 'Orbencarb',
      casNumber: '34622-58-7',
      otherNames: [],
      reportable: true
    },
    'RF-0823-001-PPP': {
      reference: 'RF-0823-001-PPP',
      name: '2-phenylphenol',
      casNumber: '90-43-7',
      otherNames: [],
      reportable: true
    },
    'RF-0823-002-PPP': {
      reference: 'RF-0823-002-PPP',
      name: '4-Phenylphenol',
      casNumber: '92-69-3',
      otherNames: [],
      reportable: true
    },
    'RF-0824-001-PPP': {
      reference: 'RF-0824-001-PPP',
      name: 'Oxamyl-Oxime',
      casNumber: '30558-43-1',
      otherNames: [],
      reportable: true
    },
    'RF-0825-001-PPP': {
      reference: 'RF-0825-001-PPP',
      name: 'Oxaziclomefone',
      casNumber: '153197-14-9',
      otherNames: [],
      reportable: true
    },
    'RF-0827-001-PPP': {
      reference: 'RF-0827-001-PPP',
      name: 'Oxychlordane',
      casNumber: '27304-13-8',
      otherNames: [],
      reportable: true
    },
    'RF-0828-001-PPP': {
      reference: 'RF-0828-001-PPP',
      name: 'Paraoxon',
      casNumber: '311-45-5',
      otherNames: [],
      reportable: true
    },
    'RF-0835-001-PPP': {
      reference: 'RF-0835-001-PPP',
      name: 'Pebulate',
      casNumber: '1114-71-2',
      otherNames: [],
      reportable: true
    },
    'RF-0836-001-PPP': {
      reference: 'RF-0836-001-PPP',
      name: 'Penfluron',
      casNumber: '35367-31-8',
      otherNames: [],
      reportable: true
    },
    'RF-0837-001-PPP': {
      reference: 'RF-0837-001-PPP',
      name: 'Pentachloroanisole',
      casNumber: '1825-21-4',
      otherNames: [],
      reportable: true
    },
    'RF-0838-001-PPP': {
      reference: 'RF-0838-001-PPP',
      name: 'Pentachlorobenzene',
      casNumber: '608-93-5',
      otherNames: [],
      reportable: true
    },
    'RF-0839-001-PPP': {
      reference: 'RF-0839-001-PPP',
      name: 'Pentachlorophenol',
      casNumber: '87-86-5',
      otherNames: [],
      reportable: true
    },
    'RF-0840-001-PPP': {
      reference: 'RF-0840-001-PPP',
      name: 'Pentanochlor',
      casNumber: '2307-68-8',
      otherNames: [],
      reportable: true
    },
    'RF-0841-001-PPP': {
      reference: 'RF-0841-001-PPP',
      name: 'Perfluidone',
      casNumber: '37924-13-3',
      otherNames: [],
      reportable: true
    },
    'RF-0842-001-PPP': {
      reference: 'RF-0842-001-PPP',
      name: 'Permethrin (sum of isomers)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0842-002-PPP': {
      reference: 'RF-0842-002-PPP',
      name: 'cis-Permethrin',
      casNumber: '61949-76-6',
      otherNames: [],
      reportable: true
    },
    'RF-0844-001-PPP': {
      reference: 'RF-0844-001-PPP',
      name: 'Phenkapton',
      casNumber: '2275-14-1',
      otherNames: [],
      reportable: true
    },
    'RF-0845-001-PPP': {
      reference: 'RF-0845-001-PPP',
      name: 'Phenol',
      casNumber: '108-95-2',
      otherNames: ['Carbolic Acid', 'Hydroxybenzene'],
      reportable: true
    },
    'RF-0846-001-PPP': {
      reference: 'RF-0846-001-PPP',
      name: 'Phenthoate',
      casNumber: '2597-03-7',
      otherNames: [],
      reportable: true
    },
    'RF-0847-001-PPP': {
      reference: 'RF-0847-001-PPP',
      name: 'Piperalin',
      casNumber: '3478-94-2',
      otherNames: [],
      reportable: true
    },
    'RF-0848-001-PPP': {
      reference: 'RF-0848-001-PPP',
      name: 'Piperonyl Butoxide',
      casNumber: '51-03-6',
      otherNames: [],
      reportable: true,
      lmrCanBeOptional: true
    },
    'RF-0849-001-PPP': {
      reference: 'RF-0849-001-PPP',
      name: 'Piperophos',
      casNumber: '24151-93-7',
      otherNames: [],
      reportable: true
    },
    'RF-0850-001-PPP': {
      reference: 'RF-0850-001-PPP',
      name: 'Pirimicarb, Desmethylformamido-',
      casNumber: '27218-04-8',
      otherNames: [],
      reportable: true
    },
    'RF-0851-001-PPP': {
      reference: 'RF-0851-001-PPP',
      name: 'Pirimiphos-Ethyl',
      casNumber: '23505-41-1',
      otherNames: [],
      reportable: true
    },
    'RF-0852-001-PPP': {
      reference: 'RF-0852-001-PPP',
      name: 'Polyoxin B',
      casNumber: '19396-06-6',
      otherNames: [],
      reportable: true
    },
    'RF-0853-001-PPP': {
      reference: 'RF-0853-001-PPP',
      name: 'Prallethrin',
      casNumber: '23031-36-9',
      otherNames: [],
      reportable: true
    },
    'RF-0854-001-PPP': {
      reference: 'RF-0854-001-PPP',
      name: 'Pretilachlor',
      casNumber: '51218-49-6',
      otherNames: [],
      reportable: true
    },
    'RF-0855-001-PPP': {
      reference: 'RF-0855-001-PPP',
      name: 'Primisulfuron',
      casNumber: '113036-87-6',
      otherNames: [],
      reportable: true
    },
    'RF-0856-001-PPP': {
      reference: 'RF-0856-001-PPP',
      name: 'Primisulfuron-Methyl',
      casNumber: '86209-51-0',
      otherNames: [],
      reportable: true
    },
    'RF-0857-001-PPP': {
      reference: 'RF-0857-001-PPP',
      name: 'Probenazole',
      casNumber: '27605-76-1',
      otherNames: [],
      reportable: true
    },
    'RF-0858-001-PPP': {
      reference: 'RF-0858-001-PPP',
      name: 'Profluralin',
      casNumber: '26399-36-0',
      otherNames: [],
      reportable: true
    },
    'RF-0859-001-PPP': {
      reference: 'RF-0859-001-PPP',
      name: 'Profoxydim',
      casNumber: '139001-49-3',
      otherNames: [],
      reportable: true
    },
    'RF-0860-001-PPP': {
      reference: 'RF-0860-001-PPP',
      name: 'Promecarb',
      casNumber: '2631-37-0',
      otherNames: [],
      reportable: true
    },
    'RF-0861-001-PPP': {
      reference: 'RF-0861-001-PPP',
      name: 'Prometon',
      casNumber: '1610-18-0',
      otherNames: [],
      reportable: true
    },
    'RF-0862-001-PPP': {
      reference: 'RF-0862-001-PPP',
      name: 'Prometryn',
      casNumber: '7287-19-6',
      otherNames: [],
      reportable: true
    },
    'RF-0863-001-PPP': {
      reference: 'RF-0863-001-PPP',
      name: 'Propaphos',
      casNumber: '7292-16-2',
      otherNames: [],
      reportable: true
    },
    'RF-0864-001-PPP': {
      reference: 'RF-0864-001-PPP',
      name: 'Propazine',
      casNumber: '139-40-2',
      otherNames: [],
      reportable: true
    },
    'RF-0866-001-PPP': {
      reference: 'RF-0866-001-PPP',
      name: 'Propetamphos',
      casNumber: '31218-83-4',
      otherNames: [],
      reportable: true
    },
    'RF-0867-001-PPP': {
      reference: 'RF-0867-001-PPP',
      name: 'Propham',
      casNumber: '122-42-9',
      otherNames: [],
      reportable: true
    },
    'RF-0868-001-PPP': {
      reference: 'RF-0868-001-PPP',
      name: 'Prothioconazole: prothioconazole-desthio (sum of isomers)',
      casNumber: null,
      otherNames: ['Prothioconazole (prothioconazole-Desthio)'],
      reportable: true
    },
    'RF-0869-001-PPP': {
      reference: 'RF-0869-001-PPP',
      name: 'Prothiofos',
      casNumber: '34643-46-4',
      otherNames: [],
      reportable: true
    },
    'RF-0870-001-PPP': {
      reference: 'RF-0870-001-PPP',
      name: 'Prothoate',
      casNumber: '2275-18-5',
      otherNames: [],
      reportable: true
    },
    'RF-0872-001-PPP': {
      reference: 'RF-0872-001-PPP',
      name: 'Pyraclofos',
      casNumber: '89784-60-1',
      otherNames: [],
      reportable: true
    },
    'RF-0873-001-PPP': {
      reference: 'RF-0873-001-PPP',
      name: 'Pyrazoxyfen',
      casNumber: '71561-11-0',
      otherNames: [],
      reportable: true
    },
    'RF-0874-001-PPP': {
      reference: 'RF-0874-001-PPP',
      name: 'Pyributicarb',
      casNumber: '88678-67-5',
      otherNames: [],
      reportable: true
    },
    'RF-0875-001-PPP': {
      reference: 'RF-0875-001-PPP',
      name: 'CL 9673 (6-chloro-4-hydroxy-3-phenylpyridazin)',
      casNumber: '40020-01-7',
      otherNames: [
        'CL 9673 (6-chloro-4-hydroxy-3-phenylpyridazin 6-chloro-3-phenylpyridazin-4-ol)'
      ],
      reportable: true
    },
    'RF-0876-001-PPP': {
      reference: 'RF-0876-001-PPP',
      name: 'Pyridalyl',
      casNumber: '179101-81-6',
      otherNames: [],
      reportable: true
    },
    'RF-0877-001-PPP': {
      reference: 'RF-0877-001-PPP',
      name: 'Pyridaphenthion',
      casNumber: '119-12-0',
      otherNames: [],
      reportable: true
    },
    'RF-0878-001-PPP': {
      reference: 'RF-0878-001-PPP',
      name: 'Pyrifenox',
      casNumber: '88283-41-4',
      otherNames: [],
      reportable: true
    },
    'RF-0879-001-PPP': {
      reference: 'RF-0879-001-PPP',
      name: 'Pyriftalid',
      casNumber: '135186-78-6',
      otherNames: [],
      reportable: true
    },
    'RF-0880-001-PPP': {
      reference: 'RF-0880-001-PPP',
      name: 'Pyrimidifen',
      casNumber: '105779-78-0',
      otherNames: [],
      reportable: true
    },
    'RF-0881-001-PPP': {
      reference: 'RF-0881-001-PPP',
      name: 'Pyriminobac-Methyl',
      casNumber: '136191-64-5',
      otherNames: [],
      reportable: true
    },
    'RF-0882-001-PPP': {
      reference: 'RF-0882-001-PPP',
      name: 'Pyrithiobac',
      casNumber: '123342-93-8',
      otherNames: [],
      reportable: true
    },
    'RF-0883-001-PPP': {
      reference: 'RF-0883-001-PPP',
      name: 'Pyroxsulam',
      casNumber: '422556-08-9',
      otherNames: [],
      reportable: true
    },
    'RF-0885-001-PPP': {
      reference: 'RF-0885-001-PPP',
      name: 'Quinclorac',
      casNumber: '84087-01-4',
      otherNames: [],
      reportable: true
    },
    'RF-0886-001-PPP': {
      reference: 'RF-0886-001-PPP',
      name: 'Quinoclamine',
      casNumber: '2797-51-5',
      otherNames: [],
      reportable: true
    },
    'RF-0887-001-PPP': {
      reference: 'RF-0887-001-PPP',
      name: 'Quizalofop-Ethyl',
      casNumber: '76578-14-8',
      otherNames: [],
      reportable: true
    },
    'RF-0887-002-PPP': {
      reference: 'RF-0887-002-PPP',
      name: 'Quizalofop-P-ethyl',
      casNumber: '100646-51-3',
      otherNames: [],
      reportable: true
    },
    'RF-0888-001-PPP': {
      reference: 'RF-0888-001-PPP',
      name: 'Rabenzazole',
      casNumber: '40341-04-6',
      otherNames: [],
      reportable: true
    },
    'RF-0889-001-PPP': {
      reference: 'RF-0889-001-PPP',
      name: 'S421',
      casNumber: '127-90-2',
      otherNames: [],
      reportable: true
    },
    'RF-0890-001-PPP': {
      reference: 'RF-0890-001-PPP',
      name: 'Schradan',
      casNumber: '152-16-9',
      otherNames: [],
      reportable: true
    },
    'RF-0891-001-PPP': {
      reference: 'RF-0891-001-PPP',
      name: 'Sebuthylazine',
      casNumber: '7286-69-3',
      otherNames: [],
      reportable: true
    },
    'RF-0892-001-PPP': {
      reference: 'RF-0892-001-PPP',
      name: 'Sebuthylazine, Desethyl-',
      casNumber: '37019-18-4',
      otherNames: [],
      reportable: true
    },
    'RF-0893-001-PPP': {
      reference: 'RF-0893-001-PPP',
      name: 'Secbumeton',
      casNumber: '26259-45-0',
      otherNames: [],
      reportable: true
    },
    'RF-0894-001-PPP': {
      reference: 'RF-0894-001-PPP',
      name: 'Siduron',
      casNumber: '1982-49-6',
      otherNames: [],
      reportable: true
    },
    'RF-0895-001-PPP': {
      reference: 'RF-0895-001-PPP',
      name: 'Silafluofen',
      casNumber: '105024-66-6',
      otherNames: [],
      reportable: true
    },
    'RF-0896-001-PPP': {
      reference: 'RF-0896-001-PPP',
      name: 'Simazine, 2-Hydroxy-',
      casNumber: '2599-11-3',
      otherNames: [],
      reportable: true
    },
    'RF-0897-001-PPP': {
      reference: 'RF-0897-001-PPP',
      name: 'Simeconazole',
      casNumber: '149508-90-7',
      otherNames: [],
      reportable: true
    },
    'RF-0898-001-PPP': {
      reference: 'RF-0898-001-PPP',
      name: 'Simetryn',
      casNumber: '1014-70-6',
      otherNames: [],
      reportable: true
    },
    'RF-0899-001-PPP': {
      reference: 'RF-0899-001-PPP',
      name: 'Streptomycin',
      casNumber: '57-92-1',
      otherNames: [],
      reportable: true
    },
    'RF-0901-001-PPP': {
      reference: 'RF-0901-001-PPP',
      name: 'Sulfentrazone',
      casNumber: '122836-35-5',
      otherNames: [],
      reportable: true
    },
    'RF-0902-001-PPP': {
      reference: 'RF-0902-001-PPP',
      name: 'Sulfometuron-Methyl',
      casNumber: '74222-97-2',
      otherNames: [],
      reportable: true
    },
    'RF-0903-001-PPP': {
      reference: 'RF-0903-001-PPP',
      name: 'Sulfotep',
      casNumber: '3689-24-5',
      otherNames: [],
      reportable: true
    },
    'RF-0905-001-PPP': {
      reference: 'RF-0905-001-PPP',
      name: 'Sulprofos',
      casNumber: '35400-43-2',
      otherNames: [],
      reportable: true
    },
    'RF-0906-001-PPP': {
      reference: 'RF-0906-001-PPP',
      name: 'TCMTB',
      casNumber: '21564-17-0',
      otherNames: [],
      reportable: true
    },
    'RF-0907-001-PPP': {
      reference: 'RF-0907-001-PPP',
      name: 'Tebupirimphos',
      casNumber: '96182-53-5',
      otherNames: [],
      reportable: true
    },
    'RF-0908-001-PPP': {
      reference: 'RF-0908-001-PPP',
      name: 'Tebutam',
      casNumber: '35256-85-0',
      otherNames: [],
      reportable: true
    },
    'RF-0909-001-PPP': {
      reference: 'RF-0909-001-PPP',
      name: 'Tebuthiuron',
      casNumber: '34014-18-1',
      otherNames: [],
      reportable: true
    },
    'RF-0910-001-PPP': {
      reference: 'RF-0910-001-PPP',
      name: 'Tecloftalam',
      casNumber: '76280-91-6',
      otherNames: [],
      reportable: true
    },
    'RF-0911-001-PPP': {
      reference: 'RF-0911-001-PPP',
      name: 'Temephos',
      casNumber: '3383-96-8',
      otherNames: [],
      reportable: true
    },
    'RF-0912-001-PPP': {
      reference: 'RF-0912-001-PPP',
      name: 'Terbacil',
      casNumber: '5902-51-2',
      otherNames: [],
      reportable: true
    },
    'RF-0913-001-PPP': {
      reference: 'RF-0913-001-PPP',
      name: 'Terbucarb',
      casNumber: '1918-11-2',
      otherNames: [],
      reportable: true
    },
    'RF-0916-001-PPP': {
      reference: 'RF-0916-001-PPP',
      name: 'Terbumeton',
      casNumber: '33693-04-8',
      otherNames: [],
      reportable: true
    },
    'RF-0917-001-PPP': {
      reference: 'RF-0917-001-PPP',
      name: 'Terbuthylazine, 2-Hydroxy-',
      casNumber: '66753-07-9',
      otherNames: [],
      reportable: true
    },
    'RF-0918-001-PPP': {
      reference: 'RF-0918-001-PPP',
      name: 'Terbuthylazine, Desethyl-',
      casNumber: '30125-63-4',
      otherNames: [],
      reportable: true
    },
    'RF-0919-001-PPP': {
      reference: 'RF-0919-001-PPP',
      name: 'Terbutryn',
      casNumber: '886-50-0',
      otherNames: [],
      reportable: true
    },
    'RF-0920-001-PPP': {
      reference: 'RF-0920-001-PPP',
      name: 'Tetrachlorvinphos',
      casNumber: '22248-79-9',
      otherNames: [],
      reportable: true
    },
    'RF-0922-001-PPP': {
      reference: 'RF-0922-001-PPP',
      name: 'Tetramethrin',
      casNumber: '7696-12-0',
      otherNames: [],
      reportable: true
    },
    'RF-0923-001-PPP': {
      reference: 'RF-0923-001-PPP',
      name: 'Tetrasul',
      casNumber: '2227-13-6',
      otherNames: [],
      reportable: true
    },
    'RF-0924-001-PPP': {
      reference: 'RF-0924-001-PPP',
      name: 'Thenylchlor',
      casNumber: '96491-05-3',
      otherNames: [],
      reportable: true
    },
    'RF-0926-001-PPP': {
      reference: 'RF-0926-001-PPP',
      name: 'Thiabendazole, 5-Hydroxy-',
      casNumber: '948-71-0',
      otherNames: [],
      reportable: true
    },
    'RF-0927-001-PPP': {
      reference: 'RF-0927-001-PPP',
      name: 'Thiazafluron',
      casNumber: '25366-23-8',
      otherNames: [],
      reportable: true
    },
    'RF-0928-001-PPP': {
      reference: 'RF-0928-001-PPP',
      name: 'Thiazopyr',
      casNumber: '117718-60-2',
      otherNames: [],
      reportable: true
    },
    'RF-0929-001-PPP': {
      reference: 'RF-0929-001-PPP',
      name: 'Thidiazuron',
      casNumber: '51707-55-2',
      otherNames: [],
      reportable: true
    },
    'RF-0930-001-PPP': {
      reference: 'RF-0930-001-PPP',
      name: 'Thifensulfuron',
      casNumber: '79277-67-1',
      otherNames: [],
      reportable: true
    },
    'RF-0931-001-PPP': {
      reference: 'RF-0931-001-PPP',
      name: 'Thifluzamide',
      casNumber: '130000-40-7',
      otherNames: [],
      reportable: true
    },
    'RF-0932-001-PPP': {
      reference: 'RF-0932-001-PPP',
      name: 'Thiocyclam',
      casNumber: '31895-21-3',
      otherNames: [],
      reportable: true
    },
    'RF-0933-001-PPP': {
      reference: 'RF-0933-001-PPP',
      name: 'Thiofanox',
      casNumber: '39196-18-4',
      otherNames: [],
      reportable: true
    },
    'RF-0934-001-PPP': {
      reference: 'RF-0934-001-PPP',
      name: 'Thiofanox-Sulfon',
      casNumber: '39184-59-3',
      otherNames: [],
      reportable: true
    },
    'RF-0935-001-PPP': {
      reference: 'RF-0935-001-PPP',
      name: 'Thiofanox-Sulfoxid',
      casNumber: '39184-27-5',
      otherNames: [],
      reportable: true
    },
    'RF-0936-001-PPP': {
      reference: 'RF-0936-001-PPP',
      name: 'Thiometon',
      casNumber: '640-15-3',
      otherNames: [],
      reportable: true
    },
    'RF-0937-001-PPP': {
      reference: 'RF-0937-001-PPP',
      name: 'Thionazin',
      casNumber: '297-97-2',
      otherNames: [],
      reportable: true
    },
    'RF-0938-001-PPP': {
      reference: 'RF-0938-001-PPP',
      name: 'Thiophanate-Ethyl',
      casNumber: '23564-06-9',
      otherNames: [],
      reportable: true
    },
    'RF-0939-001-PPP': {
      reference: 'RF-0939-001-PPP',
      name: 'Thioquinox',
      casNumber: '93-75-4',
      otherNames: [],
      reportable: true
    },
    'RF-0940-001-PPP': {
      reference: 'RF-0940-001-PPP',
      name: 'Thiosultap',
      casNumber: '98968-92-4',
      otherNames: [],
      reportable: true
    },
    'RF-0941-001-PPP': {
      reference: 'RF-0941-001-PPP',
      name: 'Thymol',
      casNumber: '89-83-8',
      otherNames: ['2-isopropyl-5-methylphenol'],
      reportable: true
    },
    'RF-0942-001-PPP': {
      reference: 'RF-0942-001-PPP',
      name: 'Tiocarbazil',
      casNumber: '36756-79-3',
      otherNames: [],
      reportable: true
    },
    'RF-0943-001-PPP': {
      reference: 'RF-0943-001-PPP',
      name: 'Tolfenpyrad',
      casNumber: '129558-76-5',
      otherNames: [],
      reportable: true
    },
    'RF-0944-001-PPP': {
      reference: 'RF-0944-001-PPP',
      name: 'Tralomethrin',
      casNumber: '66841-25-6',
      otherNames: [],
      reportable: true
    },
    'RF-0945-001-PPP': {
      reference: 'RF-0945-001-PPP',
      name: 'Transfluthrin',
      casNumber: '118712-89-3',
      otherNames: [],
      reportable: true
    },
    'RF-0946-001-PPP': {
      reference: 'RF-0946-001-PPP',
      name: 'Triamiphos',
      casNumber: '1031-47-6',
      otherNames: [],
      reportable: true
    },
    'RF-0947-001-PPP': {
      reference: 'RF-0947-001-PPP',
      name: 'Triapenthenol',
      casNumber: '76608-88-3',
      otherNames: [],
      reportable: true
    },
    'RF-0948-001-PPP': {
      reference: 'RF-0948-001-PPP',
      name: 'Triazamate',
      casNumber: '112143-82-5',
      otherNames: [],
      reportable: true
    },
    'RF-0949-001-PPP': {
      reference: 'RF-0949-001-PPP',
      name: 'Triazole, 1,2,4-',
      casNumber: '288-88-0',
      otherNames: [],
      reportable: true
    },
    'RF-0949-002-PPP': {
      reference: 'RF-0949-002-PPP',
      name: 'Triazole acetic acid',
      casNumber: '28711-29-7',
      otherNames: [],
      reportable: true
    },
    'RF-0949-003-PPP': {
      reference: 'RF-0949-003-PPP',
      name: 'Triazole alanine',
      casNumber: '10109-05-4',
      otherNames: [],
      reportable: true
    },
    'RF-0949-004-PPP': {
      reference: 'RF-0949-004-PPP',
      name: 'Triazole lactic acid',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0951-001-PPP': {
      reference: 'RF-0951-001-PPP',
      name: 'Tribromoanisole, 2,4,6-',
      casNumber: '607-99-8',
      otherNames: [],
      reportable: true
    },
    'RF-0952-001-PPP': {
      reference: 'RF-0952-001-PPP',
      name: 'Tribromophenol, 2,4,6-',
      casNumber: '118-79-6',
      otherNames: [],
      reportable: true
    },
    'RF-0953-001-PPP': {
      reference: 'RF-0953-001-PPP',
      name: 'Tributylphosphate',
      casNumber: '126-73-8',
      otherNames: [],
      reportable: true
    },
    'RF-0954-001-PPP': {
      reference: 'RF-0954-001-PPP',
      name: 'Tributyltin Oxide',
      casNumber: '56-35-9',
      otherNames: [],
      reportable: true
    },
    'RF-0955-001-PPP': {
      reference: 'RF-0955-001-PPP',
      name: 'Trichlamide',
      casNumber: '70193-21-4',
      otherNames: [],
      reportable: true
    },
    'RF-0956-001-PPP': {
      reference: 'RF-0956-001-PPP',
      name: 'Trichlorobenzoic acid, 2,3,6-',
      casNumber: '50-31-7',
      otherNames: [],
      reportable: true
    },
    'RF-0957-001-PPP': {
      reference: 'RF-0957-001-PPP',
      name: 'Trichloronat',
      casNumber: '327-98-0',
      otherNames: [],
      reportable: true
    },
    'RF-0958-001-PPP': {
      reference: 'RF-0958-001-PPP',
      name: 'Tridiphane',
      casNumber: '58138-08-2',
      otherNames: [],
      reportable: true
    },
    'RF-0959-001-PPP': {
      reference: 'RF-0959-001-PPP',
      name: 'Trietazine',
      casNumber: '1912-26-1',
      otherNames: [],
      reportable: true
    },
    'RF-0960-001-PPP': {
      reference: 'RF-0960-001-PPP',
      name: 'Trifloxysulfuron',
      casNumber: '145099-21-4',
      otherNames: [],
      reportable: true
    },
    'RF-0961-001-PPP': {
      reference: 'RF-0961-001-PPP',
      name: 'Triflusulfuron-Methyl',
      casNumber: '126535-15-7',
      otherNames: [
        'methyl 2-({[4-(dimethylamino)-6-(2,2,2-trifluoroethoxy)-1,3,5-triazin-2-yl]carbamoyl}sulfamoyl)-3-methylbenzoate',
        'methyl 2-[[[[[4-(dimethylamino)-6-(2,2,2-trifluoroethoxy)-1,3,5-triazin-2-yl]amino]carbonyl]amino]sulfonyl]-3-methylbenzoate'
      ],
      reportable: true
    },
    'RF-0962-001-PPP': {
      reference: 'RF-0962-001-PPP',
      name: 'Trimethacarb',
      casNumber: '12407-86-2',
      otherNames: [],
      reportable: true
    },
    'RF-0962-002-PPP': {
      reference: 'RF-0962-002-PPP',
      name: '2,3,5-Trimethacarb',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0962-003-PPP': {
      reference: 'RF-0962-003-PPP',
      name: '3,4,5-Trimethacarb',
      casNumber: '2686-99-9',
      otherNames: [],
      reportable: true
    },
    'RF-0963-001-PPP': {
      reference: 'RF-0963-001-PPP',
      name: 'Trinexapac-Ethyl',
      casNumber: '95266-40-3',
      otherNames: [],
      reportable: false
    },
    'RF-0964-001-PPP': {
      reference: 'RF-0964-001-PPP',
      name: 'Triphenylmethane',
      casNumber: '519-73-3',
      otherNames: [],
      reportable: true
    },
    'RF-0965-001-PPP': {
      reference: 'RF-0965-001-PPP',
      name: 'Triphenylphosphate',
      casNumber: '115-86-6',
      otherNames: [],
      reportable: true
    },
    'RF-0967-001-PPP': {
      reference: 'RF-0967-001-PPP',
      name: 'Uniconazole',
      casNumber: '83657-22-1',
      otherNames: [],
      reportable: true
    },
    'RF-0968-001-PPP': {
      reference: 'RF-0968-001-PPP',
      name: 'Validamycin',
      casNumber: '37248-47-8',
      otherNames: [],
      reportable: true
    },
    'RF-0969-001-PPP': {
      reference: 'RF-0969-001-PPP',
      name: 'Vamidothion',
      casNumber: '2275-23-2',
      otherNames: [],
      reportable: true
    },
    'RF-0969-003-PPP': {
      reference: 'RF-0969-003-PPP',
      name: 'Vamidothion sulfone',
      casNumber: '70898-34-9',
      otherNames: [],
      reportable: true
    },
    'RF-0969-004-PPP': {
      reference: 'RF-0969-004-PPP',
      name: 'Vamidothion sulfoxide',
      casNumber: '20300-00-9',
      otherNames: [],
      reportable: true
    },
    'RF-0970-001-PPP': {
      reference: 'RF-0970-001-PPP',
      name: 'Vernolate',
      casNumber: '1929-77-7',
      otherNames: [],
      reportable: true
    },
    'RF-0971-001-PPP': {
      reference: 'RF-0971-001-PPP',
      name: 'XMC',
      casNumber: '2655-14-3',
      otherNames: [],
      reportable: true
    },
    'RF-0972-001-PPP': {
      reference: 'RF-0972-001-PPP',
      name: 'Zineb',
      casNumber: '12122-67-7',
      otherNames: [],
      reportable: true
    },
    'RF-0974-001-PPP': {
      reference: 'RF-0974-001-PPP',
      name: 'Tribufos (s,s,s-tributyl-phosphorotrithioate)',
      casNumber: '78-48-8',
      otherNames: [],
      reportable: true
    },
    'RF-0975-001-PPP': {
      reference: 'RF-0975-001-PPP',
      name: 'Trans-permethrin',
      casNumber: '61949-77-7',
      otherNames: [],
      reportable: true
    },
    'RF-0976-001-PPP': {
      reference: 'RF-0976-001-PPP',
      name: 'Thiomethon sulphone',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0977-001-PPP': {
      reference: 'RF-0977-001-PPP',
      name: 'Polychloroterpenes',
      casNumber: '8001-50-1',
      otherNames: [],
      reportable: true
    },
    'RF-0978-001-PPP': {
      reference: 'RF-0978-001-PPP',
      name: 'Phosphorothioic acid O-(3-bromo-4-methyl-2-oxo-2H-1-benzopyran-7-yl)-O,O-diethyl ester',
      casNumber: '121227-99-4',
      otherNames: ['Cekafix'],
      reportable: true
    },
    'RF-0979-001-PPP': {
      reference: 'RF-0979-001-PPP',
      name: 'Nonachlor',
      casNumber: '3734-49-4',
      otherNames: [],
      reportable: true
    },
    'RF-0981-001-PPP': {
      reference: 'RF-0981-001-PPP',
      name: 'Lime sulphur',
      casNumber: '1344-81-6',
      otherNames: [],
      reportable: true
    },
    'RF-0982-001-PPP': {
      reference: 'RF-0982-001-PPP',
      name: 'Dipropyl isocinchomeronate',
      casNumber: '136-45-8',
      otherNames: [],
      reportable: true
    },
    'RF-0985-001-PPP': {
      reference: 'RF-0985-001-PPP',
      name: 'Chlorthiophos sulfone',
      casNumber: '25900-20-3',
      otherNames: [],
      reportable: true
    },
    'RF-0986-001-PPP': {
      reference: 'RF-0986-001-PPP',
      name: 'Butocarboxim sulfone',
      casNumber: '34681-23-7',
      otherNames: [],
      reportable: true
    },
    'RF-0987-001-PPP': {
      reference: 'RF-0987-001-PPP',
      name: 'Brompyrazon',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-0989-001-PPP': {
      reference: 'RF-0989-001-PPP',
      name: 'Bromfenvinfos-methyl',
      casNumber: '13104-21-7',
      otherNames: [],
      reportable: true
    },
    'RF-0990-001-PPP': {
      reference: 'RF-0990-001-PPP',
      name: '2,2,2-Trichloro-1-(3,4-dichlorophenyl)ethyl acetate',
      casNumber: '21757-82-4',
      otherNames: [],
      reportable: true
    },
    'RF-0991-001-PPP': {
      reference: 'RF-0991-001-PPP',
      name: 'Phthalimide',
      casNumber: '85-41-6',
      otherNames: [],
      reportable: true
    },
    'RF-0992-001-PPP': {
      reference: 'RF-0992-001-PPP',
      name: '2,4-Dimethylanilin',
      casNumber: '95-68-1',
      otherNames: [],
      reportable: true
    },
    'RF-0993-001-PPP': {
      reference: 'RF-0993-001-PPP',
      name: 'Trichlorophenol, 2,4,6-',
      casNumber: '88-06-2',
      otherNames: [],
      reportable: true
    },
    'RF-0994-001-PPP': {
      reference: 'RF-0994-001-PPP',
      name: 'Chlorfenethol',
      casNumber: '80-06-8',
      otherNames: [],
      reportable: true
    },
    'RF-0995-001-PPP': {
      reference: 'RF-0995-001-PPP',
      name: 'Chloroaniline-para',
      casNumber: '106-47-8',
      otherNames: [],
      reportable: true
    },
    'RF-0996-001-PPP': {
      reference: 'RF-0996-001-PPP',
      name: 'DDMU',
      casNumber: '1022-22-6',
      otherNames: [],
      reportable: true
    },
    'RF-0997-001-PPP': {
      reference: 'RF-0997-001-PPP',
      name: 'Endrin aldehyde',
      casNumber: '7421-93-4',
      otherNames: [],
      reportable: true
    },
    'RF-0998-001-PPP': {
      reference: 'RF-0998-001-PPP',
      name: 'Isobenzan',
      casNumber: '297-78-9',
      otherNames: [],
      reportable: true
    },
    'RF-0999-001-PPP': {
      reference: 'RF-0999-001-PPP',
      name: 'Nonachlor-Trans',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-1002-001-PPP': {
      reference: 'RF-1002-001-PPP',
      name: 'Carbendazim and thiophanate-methyl, expressed as carbendazim',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-1003-001-PPP': {
      reference: 'RF-1003-001-PPP',
      name: 'Vinclozolin, iprodione, procymidone, sum of compounds and all metabolites containing the 3,5-dichloroaniline moiety expressed as 3,5 dichloroaniline',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-1004-001-PPP': {
      reference: 'RF-1004-001-PPP',
      name: 'Lambda-cyhalothrin (includes gamma-cyhalothrin) (sum of R,S and S,R isomers)',
      casNumber: null,
      otherNames: [
        'Lambda-cyhalothrin, including other mixed isomeric consituents (sum of isomers)'
      ],
      reportable: true
    },
    'RF-1006-001-PPP': {
      reference: 'RF-1006-001-PPP',
      name: 'Spiroxamine carboxylic acid metabolite M06, expressed as spiroxamine (sum of isomers)',
      casNumber: null,
      otherNames: ['Spiroxamine carboxylic acid expressed as spiroxamine'],
      reportable: true
    },
    'RF-1008-001-PPP': {
      reference: 'RF-1008-001-PPP',
      name: 'Nonachlor-Cis',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-1009-001-PPP': {
      reference: 'RF-1009-001-PPP',
      name: 'Furfural',
      casNumber: '98-01-1',
      otherNames: [
        'Furan-2-carbaldehyde',
        ' 2-Formylfuran',
        'Fural',
        'Furfuraldehyde',
        '2-Furylcarboxaldehyde',
        'pyromucic aldehyde'
      ],
      reportable: true
    },
    'RF-1015-001-PPP': {
      reference: 'RF-1015-001-PPP',
      name: 'Cloethocarb',
      casNumber: '51487-69-5',
      otherNames: [],
      reportable: true
    },
    'RF-1016-001-PPP': {
      reference: 'RF-1016-001-PPP',
      name: 'Flurenol-butyl',
      casNumber: '2314-09-2',
      otherNames: [],
      reportable: true
    },
    'RF-1017-001-PPP': {
      reference: 'RF-1017-001-PPP',
      name: 'Phosfolan',
      casNumber: '947-02-4',
      otherNames: [],
      reportable: true
    },
    'RF-1019-001-PPP': {
      reference: 'RF-1019-001-PPP',
      name: 'Pyracarbolid',
      casNumber: '24691-76-7',
      otherNames: [],
      reportable: true
    },
    'RF-1020-001-PPP': {
      reference: 'RF-1020-001-PPP',
      name: 'Glyphosate',
      casNumber: '1071-83-6',
      otherNames: ['N-(Phosphonomethyl)glycine'],
      reportable: true
    },
    'RF-1022-001-PPP': {
      reference: 'RF-1022-001-PPP',
      name: 'Demeton-S',
      casNumber: '126-75-0',
      otherNames: [],
      reportable: true
    },
    'RF-1023-001-PPP': {
      reference: 'RF-1023-001-PPP',
      name: 'Allidochlor',
      casNumber: '93-71-0',
      otherNames: [],
      reportable: true
    },
    'RF-1024-001-PPP': {
      reference: 'RF-1024-001-PPP',
      name: 'Atraton',
      casNumber: '1610-17-9',
      otherNames: [],
      reportable: true
    },
    'RF-1025-001-PPP': {
      reference: 'RF-1025-001-PPP',
      name: 'Bufencarb',
      casNumber: '8065-36-9',
      otherNames: [],
      reportable: true
    },
    'RF-1026-001-PPP': {
      reference: 'RF-1026-001-PPP',
      name: 'Carbanolate',
      casNumber: '671-04-5',
      otherNames: [],
      reportable: true
    },
    'RF-1027-001-PPP': {
      reference: 'RF-1027-001-PPP',
      name: 'Chloranil',
      casNumber: '118-75-2',
      otherNames: [],
      reportable: true
    },
    'RF-1030-001-PPP': {
      reference: 'RF-1030-001-PPP',
      name: 'Dipropetryn',
      casNumber: '4147-51-7',
      otherNames: [],
      reportable: true
    },
    'RF-1031-001-PPP': {
      reference: 'RF-1031-001-PPP',
      name: 'Azoxybenzene',
      casNumber: '495-48-7',
      otherNames: [],
      reportable: true
    },
    'RF-1032-001-PPP': {
      reference: 'RF-1032-001-PPP',
      name: 'Griseofulvin',
      casNumber: '126-07-8',
      otherNames: [],
      reportable: true
    },
    'RF-1033-001-PPP': {
      reference: 'RF-1033-001-PPP',
      name: 'Hexachlorobutadiene',
      casNumber: '87-68-3',
      otherNames: [],
      reportable: true
    },
    'RF-1034-001-PPP': {
      reference: 'RF-1034-001-PPP',
      name: 'Isomalathion',
      casNumber: '3344-12-5',
      otherNames: [],
      reportable: true
    },
    'RF-1035-001-PPP': {
      reference: 'RF-1035-001-PPP',
      name: 'Isonoruron',
      casNumber: '28805-78-9',
      otherNames: [],
      reportable: true
    },
    'RF-1036-001-PPP': {
      reference: 'RF-1036-001-PPP',
      name: 'Medinoterb',
      casNumber: '3996-59-6',
      otherNames: [],
      reportable: true
    },
    'RF-1037-001-PPP': {
      reference: 'RF-1037-001-PPP',
      name: 'Oxabetrinil',
      casNumber: '74782-23-3',
      otherNames: [],
      reportable: true
    },
    'RF-1038-001-PPP': {
      reference: 'RF-1038-001-PPP',
      name: 'Pentachloromethylthiobenzene',
      casNumber: '1825-19-0',
      otherNames: [],
      reportable: true
    },
    'RF-1039-001-PPP': {
      reference: 'RF-1039-001-PPP',
      name: 'Pyridinitril',
      casNumber: '1086-02-8',
      otherNames: [],
      reportable: true
    },
    'RF-1040-001-PPP': {
      reference: 'RF-1040-001-PPP',
      name: 'Sulfallate',
      casNumber: '95-06-7',
      otherNames: [],
      reportable: true
    },
    'RF-1041-001-PPP': {
      reference: 'RF-1041-001-PPP',
      name: 'Trichlophenidine',
      casNumber: '53720-80-2',
      otherNames: [],
      reportable: true
    },
    'RF-1042-001-PPP': {
      reference: 'RF-1042-001-PPP',
      name: 'Trifenmorph',
      casNumber: '1420-06-0',
      otherNames: [],
      reportable: true
    },
    'RF-1043-001-PPP': {
      reference: 'RF-1043-001-PPP',
      name: 'Warfarin',
      casNumber: '81-81-2',
      otherNames: [],
      reportable: true
    },
    'RF-1044-001-PPP': {
      reference: 'RF-1044-001-PPP',
      name: 'Danifos',
      casNumber: '7173-84-4',
      otherNames: [],
      reportable: true
    },
    'RF-1045-001-PPP': {
      reference: 'RF-1045-001-PPP',
      name: 'Demeton',
      casNumber: '8065-48-3',
      otherNames: [],
      reportable: true
    },
    'RF-1046-001-PPP': {
      reference: 'RF-1046-001-PPP',
      name: 'Flamprop',
      casNumber: '58667-63-3',
      otherNames: [],
      reportable: true
    },
    'RF-1047-001-PPP': {
      reference: 'RF-1047-001-PPP',
      name: 'Flamprop-isopropyl',
      casNumber: '52756-22-6',
      otherNames: [],
      reportable: true
    },
    'RF-1048-001-PPP': {
      reference: 'RF-1048-001-PPP',
      name: 'Flamprop-methyl',
      casNumber: '52756-25-9',
      otherNames: [],
      reportable: true
    },
    'RF-1049-001-PPP': {
      reference: 'RF-1049-001-PPP',
      name: 'Isoxadifen',
      casNumber: '209866-92-2',
      otherNames: [],
      reportable: true
    },
    'RF-1050-001-PPP': {
      reference: 'RF-1050-001-PPP',
      name: 'Benzoic acid, 2,3,5,6-tetrachloro-4-((methoxymethylamino)carbonyl)-, methyl ester (9CI)',
      casNumber: '14419-01-3',
      otherNames: [],
      reportable: true
    },
    'RF-1051-001-PPP': {
      reference: 'RF-1051-001-PPP',
      name: 'Chloropyrifos oxon',
      casNumber: '5598-15-2',
      otherNames: [],
      reportable: true
    },
    'RF-1052-001-PPP': {
      reference: 'RF-1052-001-PPP',
      name: '1,2-Dibromo-3-chloropropane',
      casNumber: '96-12-8',
      otherNames: [],
      reportable: true
    },
    'RF-1053-001-PPP': {
      reference: 'RF-1053-001-PPP',
      name: 'Metamitron-desamino',
      casNumber: '36993-94-9',
      otherNames: [],
      reportable: true
    },
    'RF-1054-001-PPP': {
      reference: 'RF-1054-001-PPP',
      name: 'Propylenethiourea',
      casNumber: '2122-19-2',
      otherNames: ['Propylethiourea'],
      reportable: true
    },
    'RF-1055-001-PPP': {
      reference: 'RF-1055-001-PPP',
      name: 'Ametoctradin',
      casNumber: '865318-97-4',
      otherNames: [],
      reportable: true
    },
    'RF-1056-001-PPP': {
      reference: 'RF-1056-001-PPP',
      name: 'Bixafen',
      casNumber: '581809-46-3',
      otherNames: [],
      reportable: true
    },
    'RF-1057-001-PPP': {
      reference: 'RF-1057-001-PPP',
      name: 'Valifenalate',
      casNumber: '283159-90-0',
      otherNames: [],
      reportable: true
    },
    'RF-1059-001-PPP': {
      reference: 'RF-1059-001-PPP',
      name: 'Fosetyl',
      casNumber: '15845-66-6',
      otherNames: [],
      reportable: true,
      lmrCanBeOptional: true
    },
    'RF-1060-001-PPP': {
      reference: 'RF-1060-001-PPP',
      name: 'Isofenphos-methyl-oxon',
      casNumber: '209663-42-3',
      otherNames: [],
      reportable: true
    },
    'RF-1061-001-PPP': {
      reference: 'RF-1061-001-PPP',
      name: '2-Hydroxyethylphosphonic acid',
      casNumber: '22987-21-9',
      otherNames: [],
      reportable: true
    },
    'RF-1062-001-PPP': {
      reference: 'RF-1062-001-PPP',
      name: '6-Benzyladenine',
      casNumber: '1214-39-7',
      otherNames: ['6-Benzyladenin'],
      reportable: true
    },
    'RF-1063-001-PPP': {
      reference: 'RF-1063-001-PPP',
      name: 'Diphenyl sulfone',
      casNumber: '127-63-9',
      otherNames: ['Diphenylsulfon'],
      reportable: true
    },
    'RF-1064-001-PPP': {
      reference: 'RF-1064-001-PPP',
      name: "4,4'-Dichlorodiphenyl sulfone",
      casNumber: '80-07-9',
      otherNames: [],
      reportable: true
    },
    'RF-1066-001-PPP': {
      reference: 'RF-1066-001-PPP',
      name: 'Cinerin',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-1066-002-PPP': {
      reference: 'RF-1066-002-PPP',
      name: 'Cinerin I',
      casNumber: '25402-06-6',
      otherNames: [],
      reportable: true
    },
    'RF-1066-003-PPP': {
      reference: 'RF-1066-003-PPP',
      name: 'Cinerin II',
      casNumber: '121-20-0',
      otherNames: [],
      reportable: true
    },
    'RF-1067-001-PPP': {
      reference: 'RF-1067-001-PPP',
      name: 'Dimethyl fumarate',
      casNumber: '624-49-7',
      otherNames: [],
      reportable: true
    },
    'RF-1068-001-PPP': {
      reference: 'RF-1068-001-PPP',
      name: 'Endosulfandiol',
      casNumber: '2157-19-9',
      otherNames: [],
      reportable: true
    },
    'RF-1069-001-PPP': {
      reference: 'RF-1069-001-PPP',
      name: 'Fenchlorazole',
      casNumber: '103112-36-3',
      otherNames: [],
      reportable: true
    },
    'RF-1070-001-PPP': {
      reference: 'RF-1070-001-PPP',
      name: 'Sum of flonicamid and TFNA-AM, expressed as flonicamid',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-1071-001-PPP': {
      reference: 'RF-1071-001-PPP',
      name: 'Fluopyram',
      casNumber: '658066-35-4',
      otherNames: [],
      reportable: true
    },
    'RF-1073-001-PPP': {
      reference: 'RF-1073-001-PPP',
      name: 'Octacloroestireno',
      casNumber: '29082-74-4',
      otherNames: [],
      reportable: true
    },
    'RF-1075-001-PPP': {
      reference: 'RF-1075-001-PPP',
      name: 'Tetrachloroaniline, 2,3,4,5-',
      casNumber: '634-83-3',
      otherNames: [],
      reportable: true
    },
    'RF-1075-002-PPP': {
      reference: 'RF-1075-002-PPP',
      name: 'Tetrachloroanilline, 2,3,5,6-',
      casNumber: '3481-20-7',
      otherNames: [],
      reportable: true
    },
    'RF-1076-001-PPP': {
      reference: 'RF-1076-001-PPP',
      name: 'Thiocyclam hydrogen oxalate',
      casNumber: '31895-22-4',
      otherNames: [],
      reportable: true
    },
    'RF-1077-001-PPP': {
      reference: 'RF-1077-001-PPP',
      name: 'Thiometon sulfoxide',
      casNumber: '2703-37-9',
      otherNames: [],
      reportable: true
    },
    'RF-1078-001-PPP': {
      reference: 'RF-1078-001-PPP',
      name: 'Quaternary Ammonium Compounds (QACs)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-1078-002-PPP': {
      reference: 'RF-1078-002-PPP',
      name: 'Didecyldimethylammonium chloride (mixture of alkyl-quaternary ammonium salts with alkyl chain lengths of C8, C10 and C12)',
      casNumber: null,
      otherNames: [],
      reportable: true
    },
    'RF-1078-003-PPP': {
      reference: 'RF-1078-003-PPP',
      name: 'BAC 10',
      casNumber: '965-32-2',
      otherNames: [],
      reportable: true
    },
    'RF-1078-004-PPP': {
      reference: 'RF-1078-004-PPP',
      name: 'BAC 12',
      casNumber: '139-07-1',
      otherNames: [],
      reportable: true
    },
    'RF-1078-005-PPP': {
      reference: 'RF-1078-005-PPP',
      name: 'BAC 14',
      casNumber: '139-08-2',
      otherNames: [],
      reportable: true
    },
    'RF-1078-006-PPP': {
      reference: 'RF-1078-006-PPP',
      name: 'BAC 16',
      casNumber: '122-18-9',
      otherNames: [],
      reportable: true
    },
    'RF-1078-007-PPP': {
      reference: 'RF-1078-007-PPP',
      name: 'BAC 18',
      casNumber: null,
      otherNames: [],
      reportable: true
    }
  } as const satisfies Referential;
// ----- ne pas supprimer cette ligne : fin

type Referential = {
  [key in string]: {
    reference: key;
    name: string;
    casNumber: string | null;
    otherNames: string[];
    reportable: boolean;
    lmrCanBeOptional?: true;
    deprecated?: true;
  };
};

// Codes générés par Maestro pour les substances remontées par les laboratoires qui n'ont
// pas de code SSD2 EFSA
// Ce bloc doit rester en dehors du bloc généré ci-dessus, que `ssd2-generate` réécrit.
const MaestroResidueReferential = {
  'MAESTRO-CYPROSULFAMIDE': {
    reference: 'MAESTRO-CYPROSULFAMIDE',
    name: 'Cyprosulfamide',
    casNumber: null,
    otherNames: [],
    reportable: false,
    lmrCanBeOptional: true
  }
} as const satisfies Referential;

export const SSD2Referential = {
  ...EfsaSSD2Referential,
  ...MaestroResidueReferential
};

export const SSD2IdLabel = Object.values(SSD2Referential).reduce(
  (acc, { reference, name }) => {
    acc[reference] = name;
    return acc;
  },
  {} as Record<string, string>
);

const values = Object.values(SSD2Referential);

const getSSD2IdByCasNumber = (potentialCasNumber: string): SSD2Id | null => {
  return (
    values.find(({ casNumber }) => casNumber === potentialCasNumber)
      ?.reference ?? null
  );
};
const getSSD2IdByLabel = (label: string): SSD2Id | null => {
  const labelLowerCase = label.toLowerCase();
  const ssd2Id =
    values.find(({ name }) => name.toLowerCase() === labelLowerCase)
      ?.reference ?? null;

  if (ssd2Id !== null) {
    return ssd2Id;
  }

  return (
    values.find(({ otherNames }) =>
      otherNames.map((n) => n.toLowerCase()).includes(labelLowerCase)
    )?.reference ?? null
  );
};

export const searchSSD2IdByLabel = (query: string): SSD2Id[] => {
  return values
    .filter(({ name, otherNames }) =>
      [name, ...otherNames].some((n) => includesIgnoringAccents(n, query))
    )
    .map(({ reference }) => reference);
};

export const getSSD2Id = (
  label: string,
  codeSandre: string | null,
  casNumber: string | null
): SSD2Id | null => {
  let ssd2Id: SSD2Id | null = null;

  if (casNumber !== null) {
    ssd2Id = getSSD2IdByCasNumber(casNumber);
  }

  if (ssd2Id === null && codeSandre !== null) {
    ssd2Id = SandreToSSD2[codeSandre] ?? null;
  }

  if (ssd2Id === null) {
    ssd2Id = getSSD2IdByLabel(label);
  }

  return ssd2Id;
};
